/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class AlarmHistoryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出报警历史信息
     * @param alarmHistoryQueryDTO alarmHistoryQueryDTO
     * @return OK
     */
    exportAlarmHistory(alarmHistoryQueryDTO: AlarmHistoryQueryDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/alarm-history/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmHistoryQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportAlarmHistory(_response);
        });
    }

    protected processExportAlarmHistory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询报警历史信息
     * @param alarmHistoryQueryDTO alarmHistoryQueryDTO
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageAlarmHistory(alarmHistoryQueryDTO: AlarmHistoryQueryDTO, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfAlarmHistoryVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/alarm-history/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmHistoryQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageAlarmHistory(_response);
        });
    }

    protected processGetPageAlarmHistory(response: AxiosResponse): Promise<IPageOfAlarmHistoryVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfAlarmHistoryVO.fromJS(resultData200) : new IPageOfAlarmHistoryVO();
            return result200;
        }
        return Promise.resolve<IPageOfAlarmHistoryVO>(<any>null);
    }

    /**
     * 大区报警数量统计
     * @param issueType (optional) 报警类型: 1:错误 2:警告 3:提示
     * @return OK
     */
    getAreaAlarmStatistics(issueType: string | null | undefined): Promise<ChartDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/alarm-history/statistics/area?";
        if (issueType !== undefined)
            url_ += "issueType=" + encodeURIComponent("" + issueType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAreaAlarmStatistics(_response);
        });
    }

    protected processGetAreaAlarmStatistics(response: AxiosResponse): Promise<ChartDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ChartDataVO[]>(<any>null);
    }

    /**
     * 省份报警数量统计
     * @param queryDTO queryDTO
     * @return OK
     */
    getProvinceAlarmStatistics(queryDTO: ProvinceStatisticsDTO): Promise<ChartDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/alarm-history/statistics/province";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProvinceAlarmStatistics(_response);
        });
    }

    protected processGetProvinceAlarmStatistics(response: AxiosResponse): Promise<ChartDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ChartDataVO[]>(<any>null);
    }
}

export class AlarmStatisticsServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 首页面板当日报警
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    alarmTodayDetail(current: number | null | undefined, size: number | null | undefined): Promise<IPageOfAlarmCurDayDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/alarm-statistics/detail?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAlarmTodayDetail(_response);
        });
    }

    protected processAlarmTodayDetail(response: AxiosResponse): Promise<IPageOfAlarmCurDayDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfAlarmCurDayDetailVO.fromJS(resultData200) : new IPageOfAlarmCurDayDetailVO();
            return result200;
        }
        return Promise.resolve<IPageOfAlarmCurDayDetailVO>(<any>null);
    }

    /**
     * 报警明细
     * @param alarmDetailDTO alarmDetailDTO
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    alarmDetail(alarmDetailDTO: AlarmDetailDTO, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfAlarmDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/alarm-statistics/detail?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmDetailDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAlarmDetail(_response);
        });
    }

    protected processAlarmDetail(response: AxiosResponse): Promise<IPageOfAlarmDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfAlarmDetailVO.fromJS(resultData200) : new IPageOfAlarmDetailVO();
            return result200;
        }
        return Promise.resolve<IPageOfAlarmDetailVO>(<any>null);
    }

    /**
     * 当天的报警明细
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param workStationId workStationId
     * @return OK
     */
    alarmRealDetail(current: number | null | undefined, size: number | null | undefined, workStationId: string): Promise<IPageOfAlarmDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/alarm-statistics/{workStationId}/detail?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined.");
        url_ = url_.replace("{workStationId}", encodeURIComponent("" + workStationId)); 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAlarmRealDetail(_response);
        });
    }

    protected processAlarmRealDetail(response: AxiosResponse): Promise<IPageOfAlarmDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfAlarmDetailVO.fromJS(resultData200) : new IPageOfAlarmDetailVO();
            return result200;
        }
        return Promise.resolve<IPageOfAlarmDetailVO>(<any>null);
    }
}

export class DeviceStateNotifyClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * deviceStateNotify
     * @param tenantId tenantId
     * @return OK
     */
    deviceStateNotify(tenantId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/client/device-state-notify?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeviceStateNotify(_response);
        });
    }

    protected processDeviceStateNotify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class StatisticsServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 报警统计
     * @param input input
     * @return OK
     */
    alarmStatistics(input: AlarmStatisticsDTO): Promise<AlarmStatisticsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/alarm-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAlarmStatistics(_response);
        });
    }

    protected processAlarmStatistics(response: AxiosResponse): Promise<AlarmStatisticsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AlarmStatisticsVO.fromJS(resultData200) : new AlarmStatisticsVO();
            return result200;
        }
        return Promise.resolve<AlarmStatisticsVO>(<any>null);
    }

    /**
     * 查询稼动率列表数据
     * @param current (optional) 当前页
     * @param queryDTO queryDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getWeeklyEfficiencyData(current: number | null | undefined, queryDTO: WeeklyEfficiencyDataQueryDTO, size: number | null | undefined): Promise<IPageOfWeeklyEfficiencyVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/efficiency-data?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWeeklyEfficiencyData(_response);
        });
    }

    protected processGetWeeklyEfficiencyData(response: AxiosResponse): Promise<IPageOfWeeklyEfficiencyVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWeeklyEfficiencyVO.fromJS(resultData200) : new IPageOfWeeklyEfficiencyVO();
            return result200;
        }
        return Promise.resolve<IPageOfWeeklyEfficiencyVO>(<any>null);
    }

    /**
     * 能耗统计
     * @param electricityStatisticsDTO electricityStatisticsDTO
     * @return OK
     */
    getElectricityStatistics(electricityStatisticsDTO: ElectricityStatisticsDTO): Promise<ElectricityStatisticsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/electricity-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(electricityStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetElectricityStatistics(_response);
        });
    }

    protected processGetElectricityStatistics(response: AxiosResponse): Promise<ElectricityStatisticsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ElectricityStatisticsVO.fromJS(resultData200) : new ElectricityStatisticsVO();
            return result200;
        }
        return Promise.resolve<ElectricityStatisticsVO>(<any>null);
    }

    /**
     * 导出稼动率
     * @param excelDTO excelDTO
     * @return OK
     */
    exportWeeklyEfficiencyData(excelDTO: WeeklyEfficiencyDataExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(excelDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportWeeklyEfficiencyData(_response);
        });
    }

    protected processExportWeeklyEfficiencyData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 产量分析
     * @param workStationIdList workStationIdList
     * @return OK
     */
    getOutputAnalysis(workStationIdList: string[]): Promise<OutputAnalysisVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/output-analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationIdList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOutputAnalysis(_response);
        });
    }

    protected processGetOutputAnalysis(response: AxiosResponse): Promise<OutputAnalysisVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OutputAnalysisVO.fromJS(resultData200) : new OutputAnalysisVO();
            return result200;
        }
        return Promise.resolve<OutputAnalysisVO>(<any>null);
    }

    /**
     * 产量统计
     * @param outputStatisticsDTO outputStatisticsDTO
     * @return OK
     */
    outputStatistics(outputStatisticsDTO: OutputStatisticsDTO): Promise<OutputStatisticsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/output-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(outputStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOutputStatistics(_response);
        });
    }

    protected processOutputStatistics(response: AxiosResponse): Promise<OutputStatisticsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OutputStatisticsVO.fromJS(resultData200) : new OutputStatisticsVO();
            return result200;
        }
        return Promise.resolve<OutputStatisticsVO>(<any>null);
    }

    /**
     * 生产效率
     * @param input input
     * @return OK
     */
    productivityAnalysis(input: ProductivityAnalysisDTO): Promise<ProductivityAnalysisVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/productivity-analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProductivityAnalysis(_response);
        });
    }

    protected processProductivityAnalysis(response: AxiosResponse): Promise<ProductivityAnalysisVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductivityAnalysisVO.fromJS(resultData200) : new ProductivityAnalysisVO();
            return result200;
        }
        return Promise.resolve<ProductivityAnalysisVO>(<any>null);
    }

    /**
     * 工厂日每小时稼动率变化
     * @param hourDTO hourDTO
     * @return OK
     */
    productivityAnalysisHourRps(hourDTO: OperationStatisticsHourDTO): Promise<WorkStationStatusStatisticHourByRpsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/productivity-analysis-hour-rps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hourDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProductivityAnalysisHourRps(_response);
        });
    }

    protected processProductivityAnalysisHourRps(response: AxiosResponse): Promise<WorkStationStatusStatisticHourByRpsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationStatusStatisticHourByRpsVO.fromJS(resultData200) : new WorkStationStatusStatisticHourByRpsVO();
            return result200;
        }
        return Promise.resolve<WorkStationStatusStatisticHourByRpsVO>(<any>null);
    }

    /**
     * 运行统计分析
     * @param operationStatisticsDTO operationStatisticsDTO
     * @return OK
     */
    operationStatisticsRps(operationStatisticsDTO: OperationStatisticsDTO): Promise<WorkStationStatusStatisticByRpsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/productivity-analysis-rps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOperationStatisticsRps(_response);
        });
    }

    protected processOperationStatisticsRps(response: AxiosResponse): Promise<WorkStationStatusStatisticByRpsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationStatusStatisticByRpsVO.fromJS(resultData200) : new WorkStationStatusStatisticByRpsVO();
            return result200;
        }
        return Promise.resolve<WorkStationStatusStatisticByRpsVO>(<any>null);
    }

    /**
     * 时间对比运行统计分析
     * @param operationStatisticsDTO operationStatisticsDTO
     * @return OK
     */
    operationStatisticsRps2(operationStatisticsDTO: OperationStatisticsDTO): Promise<ShiftStatusStatisticByRpsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/productivity-analysis-rps-shift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOperationStatisticsRps2(_response);
        });
    }

    protected processOperationStatisticsRps2(response: AxiosResponse): Promise<ShiftStatusStatisticByRpsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ShiftStatusStatisticByRpsVO.fromJS(resultData200) : new ShiftStatusStatisticByRpsVO();
            return result200;
        }
        return Promise.resolve<ShiftStatusStatisticByRpsVO>(<any>null);
    }

    /**
     * 分割查询条件
     * @param input input
     * @return OK
     */
    splitFilter(input: AnalysisFilterDTO): Promise<SplitFilterListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/split-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSplitFilter(_response);
        });
    }

    protected processSplitFilter(response: AxiosResponse): Promise<SplitFilterListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? SplitFilterListVO.fromJS(resultData200) : new SplitFilterListVO();
            return result200;
        }
        return Promise.resolve<SplitFilterListVO>(<any>null);
    }

    /**
     * 状态记录
     * @param input input
     * @return OK
     */
    statusRecord(input: StatusRecordDTO): Promise<StatusRecordListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/status-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStatusRecord(_response);
        });
    }

    protected processStatusRecord(response: AxiosResponse): Promise<StatusRecordListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StatusRecordListVO.fromJS(resultData200) : new StatusRecordListVO();
            return result200;
        }
        return Promise.resolve<StatusRecordListVO>(<any>null);
    }

    /**
     * 导出状态记录
     * @param input input
     * @return OK
     */
    exportStatusRecord(input: StatusRecordDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/status-record/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportStatusRecord(_response);
        });
    }

    protected processExportStatusRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 用时分析
     * @param input input
     * @return OK
     */
    timeAnalysis(input: TimeAnalysisDTO): Promise<TimeAnalysisVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/time-analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTimeAnalysis(_response);
        });
    }

    protected processTimeAnalysis(response: AxiosResponse): Promise<TimeAnalysisVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TimeAnalysisVO.fromJS(resultData200) : new TimeAnalysisVO();
            return result200;
        }
        return Promise.resolve<TimeAnalysisVO>(<any>null);
    }

    /**
     * 用时分析
     * @param input input
     * @return OK
     */
    timeAnalysisByWcs(input: TimeAnalysisQueryDTO): Promise<WorkstationWcsStatisticVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/time-analysis-wcs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTimeAnalysisByWcs(_response);
        });
    }

    protected processTimeAnalysisByWcs(response: AxiosResponse): Promise<WorkstationWcsStatisticVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkstationWcsStatisticVO.fromJS(resultData200) : new WorkstationWcsStatisticVO();
            return result200;
        }
        return Promise.resolve<WorkstationWcsStatisticVO>(<any>null);
    }

    /**
     * 工位产能对比(设备对比)
     * @param workStationOutputSearchDTO workStationOutputSearchDTO
     * @return OK
     */
    workStationOutputByDeviceComparation(workStationOutputSearchDTO: WorkStationOutputSearchDTO): Promise<WorkStationOutputByDeviceVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/workstation-output-device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationOutputSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOutputByDeviceComparation(_response);
        });
    }

    protected processWorkStationOutputByDeviceComparation(response: AxiosResponse): Promise<WorkStationOutputByDeviceVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationOutputByDeviceVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationOutputByDeviceVO[]>(<any>null);
    }

    /**
     * 工位产能对比(时间对比)
     * @param workStationOutputSearchDTO workStationOutputSearchDTO
     * @return OK
     */
    workStationOutputByTimeComparation(workStationOutputSearchDTO: WorkStationOutputSearchDTO): Promise<WorkStationOutputByTimeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/workstation-output-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationOutputSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOutputByTimeComparation(_response);
        });
    }

    protected processWorkStationOutputByTimeComparation(response: AxiosResponse): Promise<WorkStationOutputByTimeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationOutputByTimeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationOutputByTimeVO[]>(<any>null);
    }
}

export class MdcCardServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 省份平均稼动率统计
     * @param queryDTO queryDTO
     * @return OK
     */
    getProvinceOeeStatistics(queryDTO: ProvinceStatisticsDTO): Promise<ChartDataVOOfdouble[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/card/province-average-oee-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProvinceOeeStatistics(_response);
        });
    }

    protected processGetProvinceOeeStatistics(response: AxiosResponse): Promise<ChartDataVOOfdouble[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartDataVOOfdouble.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ChartDataVOOfdouble[]>(<any>null);
    }

    /**
     * 卡片工位稼动率柱状图
     * @return OK
     */
    workStationOee(): Promise<WorkStationOeeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/card/work-station-oee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOee(_response);
        });
    }

    protected processWorkStationOee(response: AxiosResponse): Promise<WorkStationOeeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStationOeeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkStationOeeVO[]>(<any>null);
    }
}

export class StatusRecordCardServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 当天工位的状态记录的卡片信息
     * @return OK
     */
    statusRecordCard(): Promise<StatusRecordCardVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/card/status/current-day-record";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStatusRecordCard(_response);
        });
    }

    protected processStatusRecordCard(response: AxiosResponse): Promise<StatusRecordCardVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusRecordCardVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StatusRecordCardVO[]>(<any>null);
    }
}

export class MdcExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出报警报表
     * @param alarmExcelDTO alarmExcelDTO
     * @return OK
     */
    exportAlarmData(alarmExcelDTO: AlarmExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/excel/export-alarm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmExcelDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportAlarmData(_response);
        });
    }

    protected processExportAlarmData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出能耗报表
     * @param electricityStatisticsDTO electricityStatisticsDTO
     * @return OK
     */
    exportElectricityData(electricityStatisticsDTO: ElectricityStatisticsDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/excel/export-electricity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(electricityStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportElectricityData(_response);
        });
    }

    protected processExportElectricityData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出产量报表
     * @param outputStatisticsDTO outputStatisticsDTO
     * @return OK
     */
    exportOutputData(outputStatisticsDTO: OutputStatisticsDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/excel/export-output";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(outputStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportOutputData(_response);
        });
    }

    protected processExportOutputData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出综合效率报表
     * @param operationStatisticsDTO operationStatisticsDTO
     * @return OK
     */
    exportRpsData(operationStatisticsDTO: OperationStatisticsDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/mdc/excel/export-rps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportRpsData(_response);
        });
    }

    protected processExportRpsData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class OpsAlarmStatisticsServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 运维云报警统计
     * @param customerQueryDTO customerQueryDTO
     * @return OK
     */
    getOpsAlarmStatistics(customerQueryDTO: CustomerQueryDTO): Promise<AlarmInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/ops/alarm-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOpsAlarmStatistics(_response);
        });
    }

    protected processGetOpsAlarmStatistics(response: AxiosResponse): Promise<AlarmInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlarmInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AlarmInfoVO[]>(<any>null);
    }

    /**
     * 运维云报警统计图表
     * @param customerQueryDTO customerQueryDTO
     * @return OK
     */
    getOpsAlarmStatisticsChart(customerQueryDTO: CustomerQueryDTO): Promise<ChartDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/ops/alarm-statistics/chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOpsAlarmStatisticsChart(_response);
        });
    }

    protected processGetOpsAlarmStatisticsChart(response: AxiosResponse): Promise<ChartDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ChartDataVO[]>(<any>null);
    }

    /**
     * 分页获取运维云报警统计列表
     * @param current (optional) 当前页
     * @param opsAlarmStatisticsDTO opsAlarmStatisticsDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageOpsAlarmStatistics(current: number | null | undefined, opsAlarmStatisticsDTO: OpsAlarmStatisticsDTO, size: number | null | undefined): Promise<IPageOfWorkStationAlarmVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/ops/alarm-statistics/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(opsAlarmStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageOpsAlarmStatistics(_response);
        });
    }

    protected processGetPageOpsAlarmStatistics(response: AxiosResponse): Promise<IPageOfWorkStationAlarmVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkStationAlarmVO.fromJS(resultData200) : new IPageOfWorkStationAlarmVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkStationAlarmVO>(<any>null);
    }
}

export class OpsProductivityAnalysisServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 运行效率分析
     * @param current (optional) 当前页
     * @param opsProductivityAnalysisDTO opsProductivityAnalysisDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    productivityAnalysis(current: number | null | undefined, opsProductivityAnalysisDTO: OpsProductivityAnalysisDTO, size: number | null | undefined): Promise<OpsProductivityAnalysisVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/ops/productivity-analysis?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(opsProductivityAnalysisDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProductivityAnalysis(_response);
        });
    }

    protected processProductivityAnalysis(response: AxiosResponse): Promise<OpsProductivityAnalysisVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OpsProductivityAnalysisVO.fromJS(resultData200) : new OpsProductivityAnalysisVO();
            return result200;
        }
        return Promise.resolve<OpsProductivityAnalysisVO>(<any>null);
    }

    /**
     * 平均稼动率统计(本日，本周，本月)
     * @param areaNameList areaNameList
     * @return OK
     */
    getAverageOeeStatistics(areaNameList: string[]): Promise<AverageOeeStatisticVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/ops/productivity-analysis/average-oee-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(areaNameList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAverageOeeStatistics(_response);
        });
    }

    protected processGetAverageOeeStatistics(response: AxiosResponse): Promise<AverageOeeStatisticVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AverageOeeStatisticVO.fromJS(resultData200) : new AverageOeeStatisticVO();
            return result200;
        }
        return Promise.resolve<AverageOeeStatisticVO>(<any>null);
    }

    /**
     * 客户运行效率分析
     * @param operationStatisticsDTO operationStatisticsDTO
     * @return OK
     */
    customerProductivityAnalysis(operationStatisticsDTO: OperationStatisticsDTO): Promise<WorkStationStatusStatisticByRpsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/ops/productivity-analysis/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operationStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCustomerProductivityAnalysis(_response);
        });
    }

    protected processCustomerProductivityAnalysis(response: AxiosResponse): Promise<WorkStationStatusStatisticByRpsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationStatusStatisticByRpsVO.fromJS(resultData200) : new WorkStationStatusStatisticByRpsVO();
            return result200;
        }
        return Promise.resolve<WorkStationStatusStatisticByRpsVO>(<any>null);
    }

    /**
     * 客户平均稼动率统计(本日，本周，本月)
     * @param customerId (optional) customerId
     * @return OK
     */
    getCustomerAverageOeeStatistics(customerId: string | null | undefined): Promise<AverageOeeStatisticVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/ops/productivity-analysis/customer-average-oee-statistics?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerAverageOeeStatistics(_response);
        });
    }

    protected processGetCustomerAverageOeeStatistics(response: AxiosResponse): Promise<AverageOeeStatisticVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AverageOeeStatisticVO.fromJS(resultData200) : new AverageOeeStatisticVO();
            return result200;
        }
        return Promise.resolve<AverageOeeStatisticVO>(<any>null);
    }
}

export class OpsStatusRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 分页
     * @param current (optional) 当前页
     * @param opsStatusRecordSelectDTO opsStatusRecordSelectDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageOpsStatusRecord(current: number | null | undefined, opsStatusRecordSelectDTO: OpsStatusRecordSelectDTO, size: number | null | undefined): Promise<StatusRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/ops/status-record/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(opsStatusRecordSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageOpsStatusRecord(_response);
        });
    }

    protected processGetPageOpsStatusRecord(response: AxiosResponse): Promise<StatusRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StatusRecordVO.fromJS(resultData200) : new StatusRecordVO();
            return result200;
        }
        return Promise.resolve<StatusRecordVO>(<any>null);
    }
}

export class ProcessParametersServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 加工过程参数
     * @param dto dto
     * @return OK
     */
    getProcessParameters(dto: ProcessParametersDTO): Promise<ProcessParameterEndVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/process-parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessParameters(_response);
        });
    }

    protected processGetProcessParameters(response: AxiosResponse): Promise<ProcessParameterEndVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessParameterEndVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProcessParameterEndVO[]>(<any>null);
    }

    /**
     * findProcessParameters
     * @param dto dto
     * @return OK
     */
    findProcessParameters(dto: ProcessParametersDTO): Promise<DeviceHistoryDataVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/process-parameters/find-process-parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindProcessParameters(_response);
        });
    }

    protected processFindProcessParameters(response: AxiosResponse): Promise<DeviceHistoryDataVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeviceHistoryDataVo.fromJS(resultData200) : new DeviceHistoryDataVo();
            return result200;
        }
        return Promise.resolve<DeviceHistoryDataVo>(<any>null);
    }

    /**
     * 工位下的时间段
     * @param dto dto
     * @return OK
     */
    getTimeSlot(dto: TimeSlotDTO): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/process-parameters/frequency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTimeSlot(_response);
        });
    }

    protected processGetTimeSlot(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 获取工况状态
     * @param workStationId workStationId
     * @return OK
     */
    getWcsName(workStationId: string): Promise<{ [key: string] : string; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/process-parameters/wcs?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWcsName(_response);
        });
    }

    protected processGetWcsName(response: AxiosResponse): Promise<{ [key: string] : string; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : string; }>(<any>null);
    }
}

export class ProcessParametersExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出加工过程参数
     * @param processParameters processParameters
     * @return OK
     */
    exportEmployees(processParameters: ProcessParametersImportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/process-parameters-excel/export-process-parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processParameters);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportEmployees(_response);
        });
    }

    protected processExportEmployees(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出工位状态比率
     * @param timeAnalysisWcsExcelDTO timeAnalysisWcsExcelDTO
     * @return OK
     */
    exportTimeAnalysisWcs(timeAnalysisWcsExcelDTO: TimeAnalysisWcsExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/process-parameters-excel/export-time-analysis-wcs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeAnalysisWcsExcelDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportTimeAnalysisWcs(_response);
        });
    }

    protected processExportTimeAnalysisWcs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class VisualAlarmServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 报警信息统计
     * @param workStationQueryDataSourceDTO workStationQueryDataSourceDTO
     * @return OK
     */
    getAlarmStatistics(workStationQueryDataSourceDTO: WorkStationQueryDataSourceDTO): Promise<AlarmInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/alarm-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAlarmStatistics(_response);
        });
    }

    protected processGetAlarmStatistics(response: AxiosResponse): Promise<AlarmInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlarmInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AlarmInfoVO[]>(<any>null);
    }

    /**
     * 单设备报警统计
     * @param topQueryDataSourceDTO topQueryDataSourceDTO
     * @return OK
     */
    getDeviceAlarmStatistics(topQueryDataSourceDTO: TopQueryDataSourceDTO): Promise<TopBarDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/device-alarm-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceAlarmStatistics(_response);
        });
    }

    protected processGetDeviceAlarmStatistics(response: AxiosResponse): Promise<TopBarDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopBarDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TopBarDataVO[]>(<any>null);
    }

    /**
     * 设备组报警统计
     * @param topQueryDataSourceDTO topQueryDataSourceDTO
     * @return OK
     */
    getDeviceGroupAlarmStatistics(topQueryDataSourceDTO: TopQueryDataSourceDTO): Promise<AlarmDetailCountVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/device-group-alarm-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceGroupAlarmStatistics(_response);
        });
    }

    protected processGetDeviceGroupAlarmStatistics(response: AxiosResponse): Promise<AlarmDetailCountVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AlarmDetailCountVO.fromJS(resultData200) : new AlarmDetailCountVO();
            return result200;
        }
        return Promise.resolve<AlarmDetailCountVO>(<any>null);
    }

    /**
     * 设备报警统计展示 - 前三十天
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     * @deprecated
     */
    workStationAlarmStatisticsMonth(groupIdsDTO: GroupIdsDTO): Promise<ROfAlarmDetailCountVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/work-station/alarm-statistics/month";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationAlarmStatisticsMonth(_response);
        });
    }

    protected processWorkStationAlarmStatisticsMonth(response: AxiosResponse): Promise<ROfAlarmDetailCountVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAlarmDetailCountVO.fromJS(resultData200) : new ROfAlarmDetailCountVO();
            return result200;
        }
        return Promise.resolve<ROfAlarmDetailCountVO>(<any>null);
    }

    /**
     * 设备报警统计展示 - 前七天
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     * @deprecated
     */
    workStationAlarmStatisticsSevenDays(groupIdsDTO: GroupIdsDTO): Promise<ROfAlarmDetailCountVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/work-station/alarm-statistics/seven-days";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationAlarmStatisticsSevenDays(_response);
        });
    }

    protected processWorkStationAlarmStatisticsSevenDays(response: AxiosResponse): Promise<ROfAlarmDetailCountVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAlarmDetailCountVO.fromJS(resultData200) : new ROfAlarmDetailCountVO();
            return result200;
        }
        return Promise.resolve<ROfAlarmDetailCountVO>(<any>null);
    }

    /**
     * 设备报警统计展示 - 前十天
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     * @deprecated
     */
    workStationAlarmStatisticsTenDays(groupIdsDTO: GroupIdsDTO): Promise<ROfAlarmDetailCountVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/work-station/alarm-statistics/ten-days";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationAlarmStatisticsTenDays(_response);
        });
    }

    protected processWorkStationAlarmStatisticsTenDays(response: AxiosResponse): Promise<ROfAlarmDetailCountVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAlarmDetailCountVO.fromJS(resultData200) : new ROfAlarmDetailCountVO();
            return result200;
        }
        return Promise.resolve<ROfAlarmDetailCountVO>(<any>null);
    }

    /**
     * 设备报警统计报警数 - 前七
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     * @deprecated
     */
    workStationAlarmStatisticsTopSeven(groupIdsDTO: GroupIdsDTO): Promise<ROfListOfWorkStationAlarmInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/work-station/alarm-statistics/top-seven";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationAlarmStatisticsTopSeven(_response);
        });
    }

    protected processWorkStationAlarmStatisticsTopSeven(response: AxiosResponse): Promise<ROfListOfWorkStationAlarmInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationAlarmInfoVO.fromJS(resultData200) : new ROfListOfWorkStationAlarmInfoVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationAlarmInfoVO>(<any>null);
    }

    /**
     * 设备报警统计报警数 - 前十
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     * @deprecated
     */
    workStationAlarmStatisticsTopTen(groupIdsDTO: GroupIdsDTO): Promise<ROfListOfWorkStationAlarmInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/work-station/alarm-statistics/top-ten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationAlarmStatisticsTopTen(_response);
        });
    }

    protected processWorkStationAlarmStatisticsTopTen(response: AxiosResponse): Promise<ROfListOfWorkStationAlarmInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationAlarmInfoVO.fromJS(resultData200) : new ROfListOfWorkStationAlarmInfoVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationAlarmInfoVO>(<any>null);
    }

    /**
     * 设备报警统计报警数 - 前三十
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     * @deprecated
     */
    workStationAlarmStatisticsTopThirty(groupIdsDTO: GroupIdsDTO): Promise<ROfListOfWorkStationAlarmInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-alarm/work-station/alarm-statistics/top-thirty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationAlarmStatisticsTopThirty(_response);
        });
    }

    protected processWorkStationAlarmStatisticsTopThirty(response: AxiosResponse): Promise<ROfListOfWorkStationAlarmInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationAlarmInfoVO.fromJS(resultData200) : new ROfListOfWorkStationAlarmInfoVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationAlarmInfoVO>(<any>null);
    }
}

export class DataSourceServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取自然日班次日数据源
     * @return OK
     */
    calendarData(): Promise<DataSourceDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/nature-date";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCalendarData(_response);
        });
    }

    protected processCalendarData(response: AxiosResponse): Promise<DataSourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataSourceDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DataSourceDTO[]>(<any>null);
    }

    /**
     * 获取平均稼动率查询维度数据源
     * @return OK
     */
    oeeData(): Promise<DataSourceDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/oee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOeeData(_response);
        });
    }

    protected processOeeData(response: AxiosResponse): Promise<DataSourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataSourceDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DataSourceDTO[]>(<any>null);
    }

    /**
     * 获取工单状态数据源
     * @return OK
     */
    orderStatusData(): Promise<DataSourceDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/order-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOrderStatusData(_response);
        });
    }

    protected processOrderStatusData(response: AxiosResponse): Promise<DataSourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataSourceDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DataSourceDTO[]>(<any>null);
    }

    /**
     * 获取停机时间查询维度数据源
     * @return OK
     */
    outageTimeData(): Promise<DataSourceDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/outage-time";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOutageTimeData(_response);
        });
    }

    protected processOutageTimeData(response: AxiosResponse): Promise<DataSourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataSourceDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DataSourceDTO[]>(<any>null);
    }

    /**
     * 获取计划状态数据源
     * @return OK
     */
    planStatusData(): Promise<DataSourceDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/plan-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPlanStatusData(_response);
        });
    }

    protected processPlanStatusData(response: AxiosResponse): Promise<DataSourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataSourceDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DataSourceDTO[]>(<any>null);
    }

    /**
     * 获取计划时间维度数据源
     * @return OK
     */
    planTimeData(): Promise<DataSourceDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/plan-time";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPlanTimeData(_response);
        });
    }

    protected processPlanTimeData(response: AxiosResponse): Promise<DataSourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataSourceDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DataSourceDTO[]>(<any>null);
    }

    /**
     * 获取班次下标
     * @return OK
     */
    shiftIndexData(): Promise<number[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/shift-index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processShiftIndexData(_response);
        });
    }

    protected processShiftIndexData(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<number[]>(<any>null);
    }

    /**
     * 获取设备班次产量对比数据源
     * @return OK
     */
    shiftOutputData(): Promise<DataSourceDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/shift-output";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processShiftOutputData(_response);
        });
    }

    protected processShiftOutputData(response: AxiosResponse): Promise<DataSourceDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataSourceDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<DataSourceDTO[]>(<any>null);
    }

    /**
     * 获取top值
     * @return OK
     */
    topData(): Promise<number[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-data-source/top";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTopData(_response);
        });
    }

    protected processTopData(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<number[]>(<any>null);
    }
}

export class VisualOutputServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 工位当前加工产品
     * @param workStationOeeDTO workStationOeeDTO
     * @return OK
     */
    currentWorkStationProduct(workStationOeeDTO: WorkStationOeeDTO): Promise<{ [key: string] : string; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/current-work-station-product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationOeeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCurrentWorkStationProduct(_response);
        });
    }

    protected processCurrentWorkStationProduct(response: AxiosResponse): Promise<{ [key: string] : string; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : string; }>(<any>null);
    }

    /**
     * 设备班次产量
     * @param workStationQueryDataSourceDTO workStationQueryDataSourceDTO
     * @return OK
     */
    getDeviceShiftOutput(workStationQueryDataSourceDTO: WorkStationQueryDataSourceDTO): Promise<BarDataVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/device-shift-output";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceShiftOutput(_response);
        });
    }

    protected processGetDeviceShiftOutput(response: AxiosResponse): Promise<BarDataVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BarDataVO.fromJS(resultData200) : new BarDataVO();
            return result200;
        }
        return Promise.resolve<BarDataVO>(<any>null);
    }

    /**
     * 班次产量对比
     * @param shiftOutputQueryDataSourceDTO shiftOutputQueryDataSourceDTO
     * @return OK
     */
    getDeviceShiftYield(shiftOutputQueryDataSourceDTO: ShiftOutputQueryDataSourceDTO): Promise<ShiftOutputDataVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/device-shift-output-contrast";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shiftOutputQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceShiftYield(_response);
        });
    }

    protected processGetDeviceShiftYield(response: AxiosResponse): Promise<ShiftOutputDataVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ShiftOutputDataVO.fromJS(resultData200) : new ShiftOutputDataVO();
            return result200;
        }
        return Promise.resolve<ShiftOutputDataVO>(<any>null);
    }

    /**
     * 设备班次产量列表展示
     * @param workStationQueryDataSourceDTO workStationQueryDataSourceDTO
     * @return OK
     */
    getDeviceShiftOutputList(workStationQueryDataSourceDTO: WorkStationQueryDataSourceDTO): Promise<ShiftOutputVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/device-shift-output-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceShiftOutputList(_response);
        });
    }

    protected processGetDeviceShiftOutputList(response: AxiosResponse): Promise<ShiftOutputVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftOutputVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ShiftOutputVO[]>(<any>null);
    }

    /**
     * 设备班次产量
     * @param queryTime (optional) queryTime
     * @return OK
     * @deprecated
     */
    equipmentShiftOutput(queryTime: string | null | undefined): Promise<ROfMdcVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/equipment-shift-output?";
        if (queryTime !== undefined)
            url_ += "queryTime=" + encodeURIComponent("" + queryTime) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEquipmentShiftOutput(_response);
        });
    }

    protected processEquipmentShiftOutput(response: AxiosResponse): Promise<ROfMdcVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMdcVisualVO.fromJS(resultData200) : new ROfMdcVisualVO();
            return result200;
        }
        return Promise.resolve<ROfMdcVisualVO>(<any>null);
    }

    /**
     * 设备班次产量工位组分组
     * @param groupId groupId
     * @return OK
     * @deprecated
     */
    equipmentShiftOutputByGroupId(groupId: string): Promise<ROfMdcVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/equipment-shift-output-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEquipmentShiftOutputByGroupId(_response);
        });
    }

    protected processEquipmentShiftOutputByGroupId(response: AxiosResponse): Promise<ROfMdcVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMdcVisualVO.fromJS(resultData200) : new ROfMdcVisualVO();
            return result200;
        }
        return Promise.resolve<ROfMdcVisualVO>(<any>null);
    }

    /**
     * 设备班次产量列表展示
     * @return OK
     * @deprecated
     */
    equipmentShiftOutputList(): Promise<ROfListOfShiftOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/equipment-shift-output-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEquipmentShiftOutputList(_response);
        });
    }

    protected processEquipmentShiftOutputList(response: AxiosResponse): Promise<ROfListOfShiftOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfShiftOutputVO.fromJS(resultData200) : new ROfListOfShiftOutputVO();
            return result200;
        }
        return Promise.resolve<ROfListOfShiftOutputVO>(<any>null);
    }

    /**
     * 设备班次产量列表展示工位组分组
     * @param groupId groupId
     * @return OK
     * @deprecated
     */
    equipmentShiftOutputListByGroupId(groupId: string): Promise<ROfListOfShiftOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/equipment-shift-output-list-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEquipmentShiftOutputListByGroupId(_response);
        });
    }

    protected processEquipmentShiftOutputListByGroupId(response: AxiosResponse): Promise<ROfListOfShiftOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfShiftOutputVO.fromJS(resultData200) : new ROfListOfShiftOutputVO();
            return result200;
        }
        return Promise.resolve<ROfListOfShiftOutputVO>(<any>null);
    }

    /**
     * 多设备每小时班次产量
     * @return OK
     */
    multiDeviceOutput(): Promise<ROfListOfDeviceOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/multi/device/output";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMultiDeviceOutput(_response);
        });
    }

    protected processMultiDeviceOutput(response: AxiosResponse): Promise<ROfListOfDeviceOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeviceOutputVO.fromJS(resultData200) : new ROfListOfDeviceOutputVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeviceOutputVO>(<any>null);
    }

    /**
     * 多设备每小时班次产量
     * @param groupId groupId
     * @return OK
     */
    multiDeviceOutputByGroupId(groupId: string): Promise<ROfListOfDeviceOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/multi/device/output/group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMultiDeviceOutputByGroupId(_response);
        });
    }

    protected processMultiDeviceOutputByGroupId(response: AxiosResponse): Promise<ROfListOfDeviceOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeviceOutputVO.fromJS(resultData200) : new ROfListOfDeviceOutputVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeviceOutputVO>(<any>null);
    }

    /**
     * 多设备每小时班次产量  合并
     * @param outputMergeDTO outputMergeDTO
     * @return OK
     */
    multiDeviceOutputMerge(outputMergeDTO: OutputMergeDTO): Promise<ROfListOfDeviceOutputMergeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/multi/device/output/merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(outputMergeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMultiDeviceOutputMerge(_response);
        });
    }

    protected processMultiDeviceOutputMerge(response: AxiosResponse): Promise<ROfListOfDeviceOutputMergeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeviceOutputMergeVO.fromJS(resultData200) : new ROfListOfDeviceOutputMergeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeviceOutputMergeVO>(<any>null);
    }

    /**
     * 设备组7日内采集数量与报工数量
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     * @deprecated
     */
    deviceShiftYieldTotal(groupIdsDTO: GroupIdsDTO): Promise<ROfDeviceShiftYieldVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/seven-day/device/output";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeviceShiftYieldTotal(_response);
        });
    }

    protected processDeviceShiftYieldTotal(response: AxiosResponse): Promise<ROfDeviceShiftYieldVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDeviceShiftYieldVO.fromJS(resultData200) : new ROfDeviceShiftYieldVO();
            return result200;
        }
        return Promise.resolve<ROfDeviceShiftYieldVO>(<any>null);
    }

    /**
     * 设备组单日每一台设备的采集数量与报工数量
     * @param groupIdsDTO groupIdsDTO
     * @return OK
     * @deprecated
     */
    deviceShiftYield(groupIdsDTO: GroupIdsDTO): Promise<ROfDeviceShiftYieldVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/single-day/device/output";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeviceShiftYield(_response);
        });
    }

    protected processDeviceShiftYield(response: AxiosResponse): Promise<ROfDeviceShiftYieldVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDeviceShiftYieldVO.fromJS(resultData200) : new ROfDeviceShiftYieldVO();
            return result200;
        }
        return Promise.resolve<ROfDeviceShiftYieldVO>(<any>null);
    }

    /**
     * 单设备每小时班次产量
     * @param workStationId workStationId
     * @return OK
     */
    singleDeviceOutput(workStationId: string): Promise<ROfDeviceOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/single/device/output?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSingleDeviceOutput(_response);
        });
    }

    protected processSingleDeviceOutput(response: AxiosResponse): Promise<ROfDeviceOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDeviceOutputVO.fromJS(resultData200) : new ROfDeviceOutputVO();
            return result200;
        }
        return Promise.resolve<ROfDeviceOutputVO>(<any>null);
    }

    /**
     * 单设备每小时班次产量  合并
     * @param outputMergeDTO outputMergeDTO
     * @return OK
     */
    singleDeviceOutputMerge(outputMergeDTO: OutputMergeDTO): Promise<ROfDeviceOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-output/single/device/output/merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(outputMergeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSingleDeviceOutputMerge(_response);
        });
    }

    protected processSingleDeviceOutputMerge(response: AxiosResponse): Promise<ROfDeviceOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDeviceOutputVO.fromJS(resultData200) : new ROfDeviceOutputVO();
            return result200;
        }
        return Promise.resolve<ROfDeviceOutputVO>(<any>null);
    }
}

export class VisualStateServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 工位组当前班次平均稼动率
     * @param groupId (optional) 工位组id(需按照工位组分组则填写)
     * @return OK
     * @deprecated
     */
    averageUtilizationRateFrequency(groupId: string | null | undefined): Promise<ROfAverageUtilizationRateVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/average-utilization-rate-frequency?";
        if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAverageUtilizationRateFrequency(_response);
        });
    }

    protected processAverageUtilizationRateFrequency(response: AxiosResponse): Promise<ROfAverageUtilizationRateVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAverageUtilizationRateVO.fromJS(resultData200) : new ROfAverageUtilizationRateVO();
            return result200;
        }
        return Promise.resolve<ROfAverageUtilizationRateVO>(<any>null);
    }

    /**
     * 工位组当前班次平均稼动率(柱状图)
     * @param dto dto
     * @return OK
     */
    averageUtilizationRateFrequencyColumnar(dto: GroupIdsDTO): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/average-utilization-rate-frequency-columnar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAverageUtilizationRateFrequencyColumnar(_response);
        });
    }

    protected processAverageUtilizationRateFrequencyColumnar(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 近15天平均运行时长
     * @param dto dto
     * @return OK
     */
    currentDaysAvgRunningTime(dto: GroupIdsDTO): Promise<ROfMdcVisualStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/current-fifth-days-avg-running-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCurrentDaysAvgRunningTime(_response);
        });
    }

    protected processCurrentDaysAvgRunningTime(response: AxiosResponse): Promise<ROfMdcVisualStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMdcVisualStatusVO.fromJS(resultData200) : new ROfMdcVisualStatusVO();
            return result200;
        }
        return Promise.resolve<ROfMdcVisualStatusVO>(<any>null);
    }

    /**
     * 近15天设备各班次平均稼动率以及日平均稼动率
     * @param dto dto
     * @return OK
     */
    currentDaysWorkStationOee(dto: GroupIdsDTO): Promise<ROfListOfWorkStationShiftOeeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/current-fifth-days-work-station-oee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCurrentDaysWorkStationOee(_response);
        });
    }

    protected processCurrentDaysWorkStationOee(response: AxiosResponse): Promise<ROfListOfWorkStationShiftOeeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationShiftOeeVO.fromJS(resultData200) : new ROfListOfWorkStationShiftOeeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationShiftOeeVO>(<any>null);
    }

    /**
     * 当前月停机时间统计
     * @param dto dto
     * @return OK
     * @deprecated
     */
    currentMonthStateDuration(dto: GroupIdsDTO): Promise<ROfListOfStatisticMonthOutageTimeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/current-month-state-duration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCurrentMonthStateDuration(_response);
        });
    }

    protected processCurrentMonthStateDuration(response: AxiosResponse): Promise<ROfListOfStatisticMonthOutageTimeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatisticMonthOutageTimeVO.fromJS(resultData200) : new ROfListOfStatisticMonthOutageTimeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatisticMonthOutageTimeVO>(<any>null);
    }

    /**
     * 当月设备班次稼动率
     * @param dto dto
     * @return OK
     */
    currentMonthWorkStationOee(dto: GroupIdsDTO): Promise<ROfListOfWorkStationShiftOeeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/current-month-work-station-oee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCurrentMonthWorkStationOee(_response);
        });
    }

    protected processCurrentMonthWorkStationOee(response: AxiosResponse): Promise<ROfListOfWorkStationShiftOeeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationShiftOeeVO.fromJS(resultData200) : new ROfListOfWorkStationShiftOeeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationShiftOeeVO>(<any>null);
    }

    /**
     * 客户各状态设备数量
     * @param customerQueryDTO customerQueryDTO
     * @return OK
     */
    getCustomerDeviceStatusCount(customerQueryDTO: CustomerQueryDTO): Promise<WorkstationStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/customer-device-status-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerDeviceStatusCount(_response);
        });
    }

    protected processGetCustomerDeviceStatusCount(response: AxiosResponse): Promise<WorkstationStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkstationStatusVO.fromJS(resultData200) : new WorkstationStatusVO();
            return result200;
        }
        return Promise.resolve<WorkstationStatusVO>(<any>null);
    }

    /**
     * 平均稼动率
     * @param oeeQueryDataSourceDTO oeeQueryDataSourceDTO
     * @return OK
     */
    getDeviceAverageOee(oeeQueryDataSourceDTO: OeeQueryDataSourceDTO): Promise<AverageUtilizationRateVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-average-oee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(oeeQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceAverageOee(_response);
        });
    }

    protected processGetDeviceAverageOee(response: AxiosResponse): Promise<AverageUtilizationRateVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AverageUtilizationRateVO.fromJS(resultData200) : new AverageUtilizationRateVO();
            return result200;
        }
        return Promise.resolve<AverageUtilizationRateVO>(<any>null);
    }

    /**
     * 平均稼动率柱状图
     * @param oeeColumnarQueryDataSourceDTO oeeColumnarQueryDataSourceDTO
     * @return OK
     */
    getDeviceAverageOeeColumnar(oeeColumnarQueryDataSourceDTO: OeeColumnarQueryDataSourceDTO): Promise<WorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-average-oee-columnar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(oeeColumnarQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceAverageOeeColumnar(_response);
        });
    }

    protected processGetDeviceAverageOeeColumnar(response: AxiosResponse): Promise<WorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationOeeBarVO.fromJS(resultData200) : new WorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<WorkStationOeeBarVO>(<any>null);
    }

    /**
     * 根据状态查询设备
     * @param deviceQueryDTO deviceQueryDTO
     * @return OK
     */
    getDeviceByStatus(deviceQueryDTO: DeviceQueryDTO): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-by-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceByStatus(_response);
        });
    }

    protected processGetDeviceByStatus(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 设备停机时长
     * @param topQueryDataSourceDTO topQueryDataSourceDTO
     * @return OK
     */
    getDeviceDowntime(topQueryDataSourceDTO: TopQueryDataSourceDTO): Promise<TopBarDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-downtime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceDowntime(_response);
        });
    }

    protected processGetDeviceDowntime(response: AxiosResponse): Promise<TopBarDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopBarDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TopBarDataVO[]>(<any>null);
    }

    /**
     * 停机时长统计
     * @param queryDTO queryDTO
     * @return OK
     */
    getDeviceDowntimeStatistics(queryDTO: DowntimeQueryDataSourceDTO): Promise<StatisticMonthOutageTimeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-downtime-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceDowntimeStatistics(_response);
        });
    }

    protected processGetDeviceDowntimeStatistics(response: AxiosResponse): Promise<StatisticMonthOutageTimeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatisticMonthOutageTimeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StatisticMonthOutageTimeVO[]>(<any>null);
    }

    /**
     * 设备稼动率
     * @param topQueryDataSourceDTO topQueryDataSourceDTO
     * @return OK
     */
    getDeviceOee(topQueryDataSourceDTO: TopQueryDataSourceDTO): Promise<TopBarDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-oee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceOee(_response);
        });
    }

    protected processGetDeviceOee(response: AxiosResponse): Promise<TopBarDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopBarDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TopBarDataVO[]>(<any>null);
    }

    /**
     * 设备运行时长
     * @param topQueryDataSourceDTO topQueryDataSourceDTO
     * @return OK
     */
    getDeviceRunningTime(topQueryDataSourceDTO: TopQueryDataSourceDTO): Promise<TopBarDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-runnning-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceRunningTime(_response);
        });
    }

    protected processGetDeviceRunningTime(response: AxiosResponse): Promise<TopBarDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopBarDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TopBarDataVO[]>(<any>null);
    }

    /**
     * 各状态设备数量
     * @param workStationQueryDataSourceDTO workStationQueryDataSourceDTO
     * @return OK
     */
    getDeviceStatusCount(workStationQueryDataSourceDTO: WorkStationQueryDataSourceDTO): Promise<WorkstationStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-status-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceStatusCount(_response);
        });
    }

    protected processGetDeviceStatusCount(response: AxiosResponse): Promise<WorkstationStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkstationStatusVO.fromJS(resultData200) : new WorkstationStatusVO();
            return result200;
        }
        return Promise.resolve<WorkstationStatusVO>(<any>null);
    }

    /**
     * 工位状态甘特图
     * @param shiftIndexQueryDataSourceDTO shiftIndexQueryDataSourceDTO
     * @return OK
     */
    getDeviceStatusGantt(shiftIndexQueryDataSourceDTO: ShiftIndexQueryDataSourceDTO): Promise<StatusRecordGanttVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-status-gantt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shiftIndexQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceStatusGantt(_response);
        });
    }

    protected processGetDeviceStatusGantt(response: AxiosResponse): Promise<StatusRecordGanttVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusRecordGanttVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StatusRecordGanttVO[]>(<any>null);
    }

    /**
     * 工位状态
     * @param workStationQueryDataSourceDTO workStationQueryDataSourceDTO
     * @return OK
     */
    getDeviceStatusPie(workStationQueryDataSourceDTO: WorkStationQueryDataSourceDTO): Promise<StatusRecordPieVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-status-pie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceStatusPie(_response);
        });
    }

    protected processGetDeviceStatusPie(response: AxiosResponse): Promise<StatusRecordPieVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusRecordPieVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StatusRecordPieVO[]>(<any>null);
    }

    /**
     * 工位状态轮播图
     * @param workStationQueryDataSourceDTO workStationQueryDataSourceDTO
     * @return OK
     */
    getDeviceStatusPieRotation(workStationQueryDataSourceDTO: WorkStationQueryDataSourceDTO): Promise<StatusRecordPieVO[][]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-status-pie-rotation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceStatusPieRotation(_response);
        });
    }

    protected processGetDeviceStatusPieRotation(response: AxiosResponse): Promise<StatusRecordPieVO[][]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<StatusRecordPieVO[][]>(<any>null);
    }

    /**
     * 设备等待时长
     * @param topQueryDataSourceDTO topQueryDataSourceDTO
     * @return OK
     */
    getDeviceWaitTime(topQueryDataSourceDTO: TopQueryDataSourceDTO): Promise<TopBarDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/device-wait-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topQueryDataSourceDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceWaitTime(_response);
        });
    }

    protected processGetDeviceWaitTime(response: AxiosResponse): Promise<TopBarDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopBarDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TopBarDataVO[]>(<any>null);
    }

    /**
     * 设备班次平均等待时长
     * @param dto dto
     * @return OK
     */
    getEquipmentWaitStatusTime(dto: WorkStationQueryDataSourceDTO): Promise<ROfStatusTimeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/equipment-average-wait-status-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentWaitStatusTime(_response);
        });
    }

    protected processGetEquipmentWaitStatusTime(response: AxiosResponse): Promise<ROfStatusTimeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfStatusTimeVO.fromJS(resultData200) : new ROfStatusTimeVO();
            return result200;
        }
        return Promise.resolve<ROfStatusTimeVO>(<any>null);
    }

    /**
     * 各状态设备数量
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getEquipmentStatusCount(dto: GroupIdsDTO): Promise<ROfWorkStationVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/equipment-status-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentStatusCount(_response);
        });
    }

    protected processGetEquipmentStatusCount(response: AxiosResponse): Promise<ROfWorkStationVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationVisualVO.fromJS(resultData200) : new ROfWorkStationVisualVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationVisualVO>(<any>null);
    }

    /**
     * 各状态设备数量
     * @param workStationIdListDTO workStationIdListDTO
     * @return OK
     */
    getEquipmentStatusCountMerge(workStationIdListDTO: WorkStationIdListDTO): Promise<ROfWorkStationVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/equipment-status-count-merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationIdListDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentStatusCountMerge(_response);
        });
    }

    protected processGetEquipmentStatusCountMerge(response: AxiosResponse): Promise<ROfWorkStationVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationVisualVO.fromJS(resultData200) : new ROfWorkStationVisualVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationVisualVO>(<any>null);
    }

    /**
     * 设备各状态时长总和
     * @param dto dto
     * @return OK
     */
    getEquipmentStatusTime(dto: GroupIdsDTO): Promise<ROfStatusTimeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/equipment-status-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentStatusTime(_response);
        });
    }

    protected processGetEquipmentStatusTime(response: AxiosResponse): Promise<ROfStatusTimeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfStatusTimeVO.fromJS(resultData200) : new ROfStatusTimeVO();
            return result200;
        }
        return Promise.resolve<ROfStatusTimeVO>(<any>null);
    }

    /**
     * 近12个月设备班次稼动率
     * @param dto dto
     * @return OK
     */
    lastTwelveMonthWorkStationOee(dto: GroupIdsDTO): Promise<ROfListOfWorkStationShiftOeeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/last-twelve-month-work-station-oee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLastTwelveMonthWorkStationOee(_response);
        });
    }

    protected processLastTwelveMonthWorkStationOee(response: AxiosResponse): Promise<ROfListOfWorkStationShiftOeeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationShiftOeeVO.fromJS(resultData200) : new ROfListOfWorkStationShiftOeeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationShiftOeeVO>(<any>null);
    }

    /**
     * 近十二个月停机时间统计
     * @param dto dto
     * @return OK
     * @deprecated
     */
    nearlyTwelveMonthsDuration(dto: GroupIdsDTO): Promise<ROfListOfStatisticMonthOutageTimeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/nearly-twelve-months-duration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processNearlyTwelveMonthsDuration(_response);
        });
    }

    protected processNearlyTwelveMonthsDuration(response: AxiosResponse): Promise<ROfListOfStatisticMonthOutageTimeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatisticMonthOutageTimeVO.fromJS(resultData200) : new ROfListOfStatisticMonthOutageTimeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatisticMonthOutageTimeVO>(<any>null);
    }

    /**
     * 设备停机时长前七
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getEquipmentOutageTimeTopSeven(dto: GroupIdsDTO): Promise<ROfListOfStatusTimeTopVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/outage-time-top-seven";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentOutageTimeTopSeven(_response);
        });
    }

    protected processGetEquipmentOutageTimeTopSeven(response: AxiosResponse): Promise<ROfListOfStatusTimeTopVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusTimeTopVO.fromJS(resultData200) : new ROfListOfStatusTimeTopVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusTimeTopVO>(<any>null);
    }

    /**
     * 设备停机时长前十
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getEquipmentOutageTimeTopTen(dto: GroupIdsDTO): Promise<ROfListOfStatusTimeTopVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/outage-time-top-ten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentOutageTimeTopTen(_response);
        });
    }

    protected processGetEquipmentOutageTimeTopTen(response: AxiosResponse): Promise<ROfListOfStatusTimeTopVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusTimeTopVO.fromJS(resultData200) : new ROfListOfStatusTimeTopVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusTimeTopVO>(<any>null);
    }

    /**
     * 设备停机时长前三十
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getEquipmentOutageTimeTopThirty(dto: GroupIdsDTO): Promise<ROfListOfStatusTimeTopVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/outage-time-top-thirty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentOutageTimeTopThirty(_response);
        });
    }

    protected processGetEquipmentOutageTimeTopThirty(response: AxiosResponse): Promise<ROfListOfStatusTimeTopVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusTimeTopVO.fromJS(resultData200) : new ROfListOfStatusTimeTopVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusTimeTopVO>(<any>null);
    }

    /**
     * 近30天停机时间统计
     * @param dto dto
     * @return OK
     * @deprecated
     */
    previousMonthStateDuration(dto: GroupIdsDTO): Promise<ROfListOfStatisticMonthOutageTimeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/previous-month-state-duration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPreviousMonthStateDuration(_response);
        });
    }

    protected processPreviousMonthStateDuration(response: AxiosResponse): Promise<ROfListOfStatisticMonthOutageTimeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatisticMonthOutageTimeVO.fromJS(resultData200) : new ROfListOfStatisticMonthOutageTimeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatisticMonthOutageTimeVO>(<any>null);
    }

    /**
     * 近30天设备班次稼动率
     * @param dto dto
     * @return OK
     */
    previousMonthWorkStationOee(dto: GroupIdsDTO): Promise<ROfListOfWorkStationShiftOeeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/previous-month-work-station-oee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPreviousMonthWorkStationOee(_response);
        });
    }

    protected processPreviousMonthWorkStationOee(response: AxiosResponse): Promise<ROfListOfWorkStationShiftOeeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationShiftOeeVO.fromJS(resultData200) : new ROfListOfWorkStationShiftOeeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationShiftOeeVO>(<any>null);
    }

    /**
     * 设备运行时长前七
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getEquipmentRunningTimeTopSeven(dto: GroupIdsDTO): Promise<ROfListOfStatusTimeTopVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/running-time-top-seven";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentRunningTimeTopSeven(_response);
        });
    }

    protected processGetEquipmentRunningTimeTopSeven(response: AxiosResponse): Promise<ROfListOfStatusTimeTopVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusTimeTopVO.fromJS(resultData200) : new ROfListOfStatusTimeTopVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusTimeTopVO>(<any>null);
    }

    /**
     * 设备运行时长前十
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getEquipmentRunningTimeTopTen(dto: GroupIdsDTO): Promise<ROfListOfStatusTimeTopVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/running-time-top-ten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentRunningTimeTopTen(_response);
        });
    }

    protected processGetEquipmentRunningTimeTopTen(response: AxiosResponse): Promise<ROfListOfStatusTimeTopVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusTimeTopVO.fromJS(resultData200) : new ROfListOfStatusTimeTopVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusTimeTopVO>(<any>null);
    }

    /**
     * 设备运行时长前三十
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getEquipmentRunningTimeTopThirty(dto: GroupIdsDTO): Promise<ROfListOfStatusTimeTopVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/running-time-top-thirty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEquipmentRunningTimeTopThirty(_response);
        });
    }

    protected processGetEquipmentRunningTimeTopThirty(response: AxiosResponse): Promise<ROfListOfStatusTimeTopVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusTimeTopVO.fromJS(resultData200) : new ROfListOfStatusTimeTopVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusTimeTopVO>(<any>null);
    }

    /**
     * 根据工位code集合获取当前班次运行时长
     * @param workStationCodeList workStationCodeList
     * @return OK
     */
    shiftIndexList(workStationCodeList: string[]): Promise<ShiftIndexRunningTimeVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/shift-index/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationCodeList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processShiftIndexList(_response);
        });
    }

    protected processShiftIndexList(response: AxiosResponse): Promise<ShiftIndexRunningTimeVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftIndexRunningTimeVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ShiftIndexRunningTimeVO[]>(<any>null);
    }

    /**
     * 根据工位code集合获取工位当前班次运行时长,当前状态持续时间,当前加工产品
     * @param workStationCodeList workStationCodeList
     * @return OK
     */
    getShiftIndexStatusDurationProduct(workStationCodeList: string[]): Promise<ShiftIndexStatusDurationProductVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/shiftIndex-statusDuration-product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationCodeList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetShiftIndexStatusDurationProduct(_response);
        });
    }

    protected processGetShiftIndexStatusDurationProduct(response: AxiosResponse): Promise<ShiftIndexStatusDurationProductVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ShiftIndexStatusDurationProductVO.fromJS(resultData200) : new ShiftIndexStatusDurationProductVO();
            return result200;
        }
        return Promise.resolve<ShiftIndexStatusDurationProductVO>(<any>null);
    }

    /**
     * 工位当前状态持续时间
     * @param workStationCodesDTO workStationCodesDTO
     * @return OK
     * @deprecated
     */
    workStationCurrentStatusDuration(workStationCodesDTO: WorkStationCodesDTO): Promise<ROfListOfWorkStationCurrentStatusVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-current-status-duration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationCodesDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationCurrentStatusDuration(_response);
        });
    }

    protected processWorkStationCurrentStatusDuration(response: AxiosResponse): Promise<ROfListOfWorkStationCurrentStatusVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationCurrentStatusVO.fromJS(resultData200) : new ROfListOfWorkStationCurrentStatusVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationCurrentStatusVO>(<any>null);
    }

    /**
     * 工位当前班次稼动率
     * @param groupId (optional) 工位组id(需按照工位组分组则填写)
     * @return OK
     */
    workStationFrequencyOee(groupId: string | null | undefined): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-frequency-oee?";
        if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationFrequencyOee(_response);
        });
    }

    protected processWorkStationFrequencyOee(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位组当天平均稼动率
     * @param groupId groupId
     * @return OK
     * @deprecated
     */
    workStationGroupAverageUtilizationRate(groupId: string): Promise<ROfAverageUtilizationRateVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-group-average-utilization-rate?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationGroupAverageUtilizationRate(_response);
        });
    }

    protected processWorkStationGroupAverageUtilizationRate(response: AxiosResponse): Promise<ROfAverageUtilizationRateVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAverageUtilizationRateVO.fromJS(resultData200) : new ROfAverageUtilizationRateVO();
            return result200;
        }
        return Promise.resolve<ROfAverageUtilizationRateVO>(<any>null);
    }

    /**
     * 工位组当天稼动率(柱状图)
     * @param dto dto
     * @return OK
     */
    workStationGroupAverageUtilizationRateColumnar(dto: GroupIdsDTO): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-group-average-utilization-rate-columnar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationGroupAverageUtilizationRateColumnar(_response);
        });
    }

    protected processWorkStationGroupAverageUtilizationRateColumnar(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位组当月平均稼动率
     * @param groupId groupId
     * @return OK
     * @deprecated
     */
    workStationGroupAverageUtilizationRateMonth(groupId: string): Promise<ROfAverageUtilizationRateVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-group-average-utilization-rate-month?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationGroupAverageUtilizationRateMonth(_response);
        });
    }

    protected processWorkStationGroupAverageUtilizationRateMonth(response: AxiosResponse): Promise<ROfAverageUtilizationRateVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAverageUtilizationRateVO.fromJS(resultData200) : new ROfAverageUtilizationRateVO();
            return result200;
        }
        return Promise.resolve<ROfAverageUtilizationRateVO>(<any>null);
    }

    /**
     * 工位组当月平均稼动率(柱状图)
     * @param dto dto
     * @return OK
     */
    workStationGroupAverageUtilizationRateMonthColumnar(dto: GroupIdsDTO): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-group-average-utilization-rate-month-columnar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationGroupAverageUtilizationRateMonthColumnar(_response);
        });
    }

    protected processWorkStationGroupAverageUtilizationRateMonthColumnar(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位组当周平均稼动率
     * @param groupId groupId
     * @return OK
     * @deprecated
     */
    workStationGroupAverageUtilizationRateWeek(groupId: string): Promise<ROfAverageUtilizationRateVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-group-average-utilization-rate-week?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationGroupAverageUtilizationRateWeek(_response);
        });
    }

    protected processWorkStationGroupAverageUtilizationRateWeek(response: AxiosResponse): Promise<ROfAverageUtilizationRateVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAverageUtilizationRateVO.fromJS(resultData200) : new ROfAverageUtilizationRateVO();
            return result200;
        }
        return Promise.resolve<ROfAverageUtilizationRateVO>(<any>null);
    }

    /**
     * 工位组当周平均稼动率(柱状图)
     * @param dto dto
     * @return OK
     */
    workStationGroupAverageUtilizationRateWeekColumnar(dto: GroupIdsDTO): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-group-average-utilization-rate-week-columnar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationGroupAverageUtilizationRateWeekColumnar(_response);
        });
    }

    protected processWorkStationGroupAverageUtilizationRateWeekColumnar(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位当前班次稼动率
     * @param groupId (optional) 工位组id(需按照工位组分组则填写)
     * @return OK
     */
    workStationGroupFrequencyOee(groupId: string | null | undefined): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-group-frequency-oee?";
        if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationGroupFrequencyOee(_response);
        });
    }

    protected processWorkStationGroupFrequencyOee(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位当前班次稼动率
     * @param workStationOeeDTO workStationOeeDTO
     * @return OK
     */
    workStationListFrequencyOee(workStationOeeDTO: WorkStationOeeDTO): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-list-frequency-oee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationOeeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationListFrequencyOee(_response);
        });
    }

    protected processWorkStationListFrequencyOee(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位当天稼动率
     * @return OK
     */
    workStationOee(): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-oee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOee(_response);
        });
    }

    protected processWorkStationOee(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 稼动率分布图（当天数据）
     * @param dto dto
     * @return OK
     */
    workStationOeeDistribution(dto: GroupIdsDTO): Promise<ROfListOfWorkStationOeeVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-oee-distribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOeeDistribution(_response);
        });
    }

    protected processWorkStationOeeDistribution(response: AxiosResponse): Promise<ROfListOfWorkStationOeeVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationOeeVisualVO.fromJS(resultData200) : new ROfListOfWorkStationOeeVisualVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationOeeVisualVO>(<any>null);
    }

    /**
     * 工位稼动率通过工位组分组
     * @param groupId groupId
     * @return OK
     */
    workStationOeeByGroupId(groupId: string): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-oee-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOeeByGroupId(_response);
        });
    }

    protected processWorkStationOeeByGroupId(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 设备稼动率前七
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getWorkStationOeeTopSeven(dto: GroupIdsDTO): Promise<ROfListOfWorkStationOeeVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-oee-top-seven";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationOeeTopSeven(_response);
        });
    }

    protected processGetWorkStationOeeTopSeven(response: AxiosResponse): Promise<ROfListOfWorkStationOeeVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationOeeVisualVO.fromJS(resultData200) : new ROfListOfWorkStationOeeVisualVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationOeeVisualVO>(<any>null);
    }

    /**
     * 设备稼动率前十
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getWorkStationOeeTopTen(dto: GroupIdsDTO): Promise<ROfListOfWorkStationOeeVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-oee-top-ten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationOeeTopTen(_response);
        });
    }

    protected processGetWorkStationOeeTopTen(response: AxiosResponse): Promise<ROfListOfWorkStationOeeVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationOeeVisualVO.fromJS(resultData200) : new ROfListOfWorkStationOeeVisualVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationOeeVisualVO>(<any>null);
    }

    /**
     * 设备稼动率前三十
     * @param dto dto
     * @return OK
     * @deprecated
     */
    getWorkStationOeeTopThirty(dto: GroupIdsDTO): Promise<ROfListOfWorkStationOeeVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-oee-top-thirty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkStationOeeTopThirty(_response);
        });
    }

    protected processGetWorkStationOeeTopThirty(response: AxiosResponse): Promise<ROfListOfWorkStationOeeVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfWorkStationOeeVisualVO.fromJS(resultData200) : new ROfListOfWorkStationOeeVisualVO();
            return result200;
        }
        return Promise.resolve<ROfListOfWorkStationOeeVisualVO>(<any>null);
    }

    /**
     * 工位稼动率与标准值对比
     * @return OK
     */
    workStationStandardOee(): Promise<WorkStationStandardOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-standard-oee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStandardOee(_response);
        });
    }

    protected processWorkStationStandardOee(response: AxiosResponse): Promise<WorkStationStandardOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationStandardOeeBarVO.fromJS(resultData200) : new WorkStationStandardOeeBarVO();
            return result200;
        }
        return Promise.resolve<WorkStationStandardOeeBarVO>(<any>null);
    }

    /**
     * 工位状态记录甘特图
     * @param shiftIndex (optional) shiftIndex
     * @return OK
     * @deprecated
     */
    workStationStatusGantt(shiftIndex: number | null | undefined): Promise<ROfListOfStatusRecordGanttVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-status-gantt?";
        if (shiftIndex !== undefined)
            url_ += "shiftIndex=" + encodeURIComponent("" + shiftIndex) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusGantt(_response);
        });
    }

    protected processWorkStationStatusGantt(response: AxiosResponse): Promise<ROfListOfStatusRecordGanttVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusRecordGanttVO.fromJS(resultData200) : new ROfListOfStatusRecordGanttVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusRecordGanttVO>(<any>null);
    }

    /**
     * 工位状态记录甘特图工位组分组
     * @param groupId groupId
     * @return OK
     * @deprecated
     */
    workStationStatusGanttByGroupId(groupId: string): Promise<ROfListOfStatusRecordGanttVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-status-gantt-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusGanttByGroupId(_response);
        });
    }

    protected processWorkStationStatusGanttByGroupId(response: AxiosResponse): Promise<ROfListOfStatusRecordGanttVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusRecordGanttVO.fromJS(resultData200) : new ROfListOfStatusRecordGanttVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusRecordGanttVO>(<any>null);
    }

    /**
     * 工位状态统计饼状图
     * @param workStationId workStationId
     * @return OK
     * @deprecated
     */
    workStationStatusPie(workStationId: string): Promise<ROfListOfStatusRecordPieVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-status-pie?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusPie(_response);
        });
    }

    protected processWorkStationStatusPie(response: AxiosResponse): Promise<ROfListOfStatusRecordPieVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusRecordPieVO.fromJS(resultData200) : new ROfListOfStatusRecordPieVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusRecordPieVO>(<any>null);
    }

    /**
     * 工位状态统计饼状图(轮播)
     * @return OK
     * @deprecated
     */
    workStationStatusPieRotation(): Promise<ROfListOfListOfStatusRecordPieVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-status-pie-rotation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusPieRotation(_response);
        });
    }

    protected processWorkStationStatusPieRotation(response: AxiosResponse): Promise<ROfListOfListOfStatusRecordPieVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfListOfStatusRecordPieVO.fromJS(resultData200) : new ROfListOfListOfStatusRecordPieVO();
            return result200;
        }
        return Promise.resolve<ROfListOfListOfStatusRecordPieVO>(<any>null);
    }

    /**
     * 工位状态统计饼状图(轮播)工位组分组
     * @param groupId groupId
     * @return OK
     * @deprecated
     */
    workStationStatusPieRotationByGroupId(groupId: string): Promise<ROfListOfListOfStatusRecordPieVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-status-pie-rotation-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusPieRotationByGroupId(_response);
        });
    }

    protected processWorkStationStatusPieRotationByGroupId(response: AxiosResponse): Promise<ROfListOfListOfStatusRecordPieVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfListOfStatusRecordPieVO.fromJS(resultData200) : new ROfListOfListOfStatusRecordPieVO();
            return result200;
        }
        return Promise.resolve<ROfListOfListOfStatusRecordPieVO>(<any>null);
    }

    /**
     * 工位状态统计饼状图(轮播)工位id集合
     * @param statusRecordPieWorkStationIdsDTO statusRecordPieWorkStationIdsDTO
     * @return OK
     * @deprecated
     */
    workStationStatusPieRotationByIds(statusRecordPieWorkStationIdsDTO: StatusRecordPieWorkStationIdsDTO): Promise<ROfListOfListOfStatusRecordPieVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visual-state/work-station-status-pie-rotation/ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusRecordPieWorkStationIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusPieRotationByIds(_response);
        });
    }

    protected processWorkStationStatusPieRotationByIds(response: AxiosResponse): Promise<ROfListOfListOfStatusRecordPieVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfListOfStatusRecordPieVO.fromJS(resultData200) : new ROfListOfListOfStatusRecordPieVO();
            return result200;
        }
        return Promise.resolve<ROfListOfListOfStatusRecordPieVO>(<any>null);
    }
}

export class MdcVisualServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 工位当前加工产品
     * @param workStationOeeDTO workStationOeeDTO
     * @return OK
     */
    currentWorkStationProduct(workStationOeeDTO: WorkStationOeeDTO): Promise<{ [key: string] : string; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/current-work-station-product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationOeeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCurrentWorkStationProduct(_response);
        });
    }

    protected processCurrentWorkStationProduct(response: AxiosResponse): Promise<{ [key: string] : string; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : string; }>(<any>null);
    }

    /**
     * 设备班次产量
     * @return OK
     */
    equipmentShiftOutput(): Promise<ROfMdcVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/equipment-shift-output";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEquipmentShiftOutput(_response);
        });
    }

    protected processEquipmentShiftOutput(response: AxiosResponse): Promise<ROfMdcVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMdcVisualVO.fromJS(resultData200) : new ROfMdcVisualVO();
            return result200;
        }
        return Promise.resolve<ROfMdcVisualVO>(<any>null);
    }

    /**
     * 设备班次产量工位组分组
     * @param groupId groupId
     * @return OK
     */
    equipmentShiftOutputByGroupId(groupId: string): Promise<ROfMdcVisualVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/equipment-shift-output-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEquipmentShiftOutputByGroupId(_response);
        });
    }

    protected processEquipmentShiftOutputByGroupId(response: AxiosResponse): Promise<ROfMdcVisualVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfMdcVisualVO.fromJS(resultData200) : new ROfMdcVisualVO();
            return result200;
        }
        return Promise.resolve<ROfMdcVisualVO>(<any>null);
    }

    /**
     * 设备班次产量列表展示
     * @return OK
     */
    equipmentShiftOutputList(): Promise<ROfListOfShiftOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/equipment-shift-output-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEquipmentShiftOutputList(_response);
        });
    }

    protected processEquipmentShiftOutputList(response: AxiosResponse): Promise<ROfListOfShiftOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfShiftOutputVO.fromJS(resultData200) : new ROfListOfShiftOutputVO();
            return result200;
        }
        return Promise.resolve<ROfListOfShiftOutputVO>(<any>null);
    }

    /**
     * 设备班次产量列表展示工位组分组
     * @param groupId groupId
     * @return OK
     */
    equipmentShiftOutputListByGroupId(groupId: string): Promise<ROfListOfShiftOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/equipment-shift-output-list-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEquipmentShiftOutputListByGroupId(_response);
        });
    }

    protected processEquipmentShiftOutputListByGroupId(response: AxiosResponse): Promise<ROfListOfShiftOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfShiftOutputVO.fromJS(resultData200) : new ROfListOfShiftOutputVO();
            return result200;
        }
        return Promise.resolve<ROfListOfShiftOutputVO>(<any>null);
    }

    /**
     * 多设备每小时班次产量
     * @return OK
     */
    multiDeviceOutput(): Promise<ROfListOfDeviceOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/multi/device/output";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMultiDeviceOutput(_response);
        });
    }

    protected processMultiDeviceOutput(response: AxiosResponse): Promise<ROfListOfDeviceOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeviceOutputVO.fromJS(resultData200) : new ROfListOfDeviceOutputVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeviceOutputVO>(<any>null);
    }

    /**
     * 多设备每小时班次产量
     * @param groupId groupId
     * @return OK
     */
    multiDeviceOutputByGroupId(groupId: string): Promise<ROfListOfDeviceOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/multi/device/output/group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMultiDeviceOutputByGroupId(_response);
        });
    }

    protected processMultiDeviceOutputByGroupId(response: AxiosResponse): Promise<ROfListOfDeviceOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeviceOutputVO.fromJS(resultData200) : new ROfListOfDeviceOutputVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeviceOutputVO>(<any>null);
    }

    /**
     * 多设备每小时班次产量  合并
     * @param outputMergeDTO outputMergeDTO
     * @return OK
     */
    multiDeviceOutputMerge(outputMergeDTO: OutputMergeDTO): Promise<ROfListOfDeviceOutputMergeVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/multi/device/output/merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(outputMergeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMultiDeviceOutputMerge(_response);
        });
    }

    protected processMultiDeviceOutputMerge(response: AxiosResponse): Promise<ROfListOfDeviceOutputMergeVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfDeviceOutputMergeVO.fromJS(resultData200) : new ROfListOfDeviceOutputMergeVO();
            return result200;
        }
        return Promise.resolve<ROfListOfDeviceOutputMergeVO>(<any>null);
    }

    /**
     * 单设备每小时班次产量
     * @param workStationId workStationId
     * @return OK
     */
    singleDeviceOutput(workStationId: string): Promise<ROfDeviceOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/single/device/output?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSingleDeviceOutput(_response);
        });
    }

    protected processSingleDeviceOutput(response: AxiosResponse): Promise<ROfDeviceOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDeviceOutputVO.fromJS(resultData200) : new ROfDeviceOutputVO();
            return result200;
        }
        return Promise.resolve<ROfDeviceOutputVO>(<any>null);
    }

    /**
     * 单设备每小时班次产量  合并
     * @param outputMergeDTO outputMergeDTO
     * @return OK
     */
    singleDeviceOutputMerge(outputMergeDTO: OutputMergeDTO): Promise<ROfDeviceOutputVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/single/device/output/merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(outputMergeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSingleDeviceOutputMerge(_response);
        });
    }

    protected processSingleDeviceOutputMerge(response: AxiosResponse): Promise<ROfDeviceOutputVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfDeviceOutputVO.fromJS(resultData200) : new ROfDeviceOutputVO();
            return result200;
        }
        return Promise.resolve<ROfDeviceOutputVO>(<any>null);
    }

    /**
     * 工位当前班次稼动率
     * @param groupId (optional) 工位组id(需按照工位组分组则填写)
     * @return OK
     */
    workStationFrequencyOee(groupId: string | null | undefined): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-frequency-oee?";
        if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationFrequencyOee(_response);
        });
    }

    protected processWorkStationFrequencyOee(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位当天稼动率
     * @return OK
     */
    workStationOee(): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-oee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOee(_response);
        });
    }

    protected processWorkStationOee(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位稼动率柱状图工位组分组
     * @param groupId groupId
     * @return OK
     */
    workStationOeeByGroupId(groupId: string): Promise<ROfWorkStationOeeBarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-oee-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationOeeByGroupId(_response);
        });
    }

    protected processWorkStationOeeByGroupId(response: AxiosResponse): Promise<ROfWorkStationOeeBarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWorkStationOeeBarVO.fromJS(resultData200) : new ROfWorkStationOeeBarVO();
            return result200;
        }
        return Promise.resolve<ROfWorkStationOeeBarVO>(<any>null);
    }

    /**
     * 工位状态记录甘特图
     * @param shiftIndex (optional) shiftIndex
     * @return OK
     */
    workStationStatusGantt(shiftIndex: number | null | undefined): Promise<ROfListOfStatusRecordGanttVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-status-gantt?";
        if (shiftIndex !== undefined)
            url_ += "shiftIndex=" + encodeURIComponent("" + shiftIndex) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusGantt(_response);
        });
    }

    protected processWorkStationStatusGantt(response: AxiosResponse): Promise<ROfListOfStatusRecordGanttVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusRecordGanttVO.fromJS(resultData200) : new ROfListOfStatusRecordGanttVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusRecordGanttVO>(<any>null);
    }

    /**
     * 工位状态记录甘特图工位组分组
     * @param groupId groupId
     * @return OK
     */
    workStationStatusGanttByGroupId(groupId: string): Promise<ROfListOfStatusRecordGanttVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-status-gantt-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusGanttByGroupId(_response);
        });
    }

    protected processWorkStationStatusGanttByGroupId(response: AxiosResponse): Promise<ROfListOfStatusRecordGanttVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusRecordGanttVO.fromJS(resultData200) : new ROfListOfStatusRecordGanttVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusRecordGanttVO>(<any>null);
    }

    /**
     * 工位状态统计饼状图
     * @param workStationId workStationId
     * @return OK
     */
    workStationStatusPie(workStationId: string): Promise<ROfListOfStatusRecordPieVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-status-pie?";
        if (workStationId === undefined || workStationId === null)
            throw new Error("The parameter 'workStationId' must be defined and cannot be null.");
        else
            url_ += "workStationId=" + encodeURIComponent("" + workStationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusPie(_response);
        });
    }

    protected processWorkStationStatusPie(response: AxiosResponse): Promise<ROfListOfStatusRecordPieVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfStatusRecordPieVO.fromJS(resultData200) : new ROfListOfStatusRecordPieVO();
            return result200;
        }
        return Promise.resolve<ROfListOfStatusRecordPieVO>(<any>null);
    }

    /**
     * 工位状态统计饼状图(轮播)
     * @return OK
     */
    workStationStatusPieRotation(): Promise<ROfListOfListOfStatusRecordPieVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-status-pie-rotation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusPieRotation(_response);
        });
    }

    protected processWorkStationStatusPieRotation(response: AxiosResponse): Promise<ROfListOfListOfStatusRecordPieVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfListOfStatusRecordPieVO.fromJS(resultData200) : new ROfListOfListOfStatusRecordPieVO();
            return result200;
        }
        return Promise.resolve<ROfListOfListOfStatusRecordPieVO>(<any>null);
    }

    /**
     * 工位状态统计饼状图(轮播)工位组分组
     * @param groupId groupId
     * @return OK
     */
    workStationStatusPieRotationByGroupId(groupId: string): Promise<ROfListOfListOfStatusRecordPieVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-status-pie-rotation-group-id?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusPieRotationByGroupId(_response);
        });
    }

    protected processWorkStationStatusPieRotationByGroupId(response: AxiosResponse): Promise<ROfListOfListOfStatusRecordPieVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfListOfStatusRecordPieVO.fromJS(resultData200) : new ROfListOfListOfStatusRecordPieVO();
            return result200;
        }
        return Promise.resolve<ROfListOfListOfStatusRecordPieVO>(<any>null);
    }

    /**
     * 工位状态统计饼状图(轮播)工位id集合
     * @param statusRecordPieWorkStationIdsDTO statusRecordPieWorkStationIdsDTO
     * @return OK
     */
    workStationStatusPieRotationByIds(statusRecordPieWorkStationIdsDTO: StatusRecordPieWorkStationIdsDTO): Promise<ROfListOfListOfStatusRecordPieVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/visualization/work-station-status-pie-rotation/ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusRecordPieWorkStationIdsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationStatusPieRotationByIds(_response);
        });
    }

    protected processWorkStationStatusPieRotationByIds(response: AxiosResponse): Promise<ROfListOfListOfStatusRecordPieVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfListOfStatusRecordPieVO.fromJS(resultData200) : new ROfListOfListOfStatusRecordPieVO();
            return result200;
        }
        return Promise.resolve<ROfListOfListOfStatusRecordPieVO>(<any>null);
    }
}

export class WorkStationEfficiencyServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 工位登入详情
     * @param id (optional) id
     * @return OK
     */
    detail(id: string | null | undefined): Promise<WorkStationEfficiencyVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/detail/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<WorkStationEfficiencyVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationEfficiencyVO.fromJS(resultData200) : new WorkStationEfficiencyVO();
            return result200;
        }
        return Promise.resolve<WorkStationEfficiencyVO>(<any>null);
    }

    /**
     * 导出工位效率综合统计
     * @param workstationLoginExcelDTO workstationLoginExcelDTO
     * @return OK
     */
    exportLoginData(workstationLoginExcelDTO: WorkstationLoginExcelDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/export-workstation-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workstationLoginExcelDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportLoginData(_response);
        });
    }

    protected processExportLoginData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * getData
     * @return OK
     */
    getData(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/getData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetData(_response);
        });
    }

    protected processGetData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * getYieldData
     * @return OK
     */
    getYieldData(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/getYieldData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetYieldData(_response);
        });
    }

    protected processGetYieldData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 人员登入登出详情 查询分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param workStationLoginDetailDTO workStationLoginDetailDTO
     * @return OK
     */
    workStationLoginDetailPage(current: number | null | undefined, size: number | null | undefined, workStationLoginDetailDTO: WorkStationLoginDetailDTO): Promise<IPageOfWorkStationLoginDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workStationLoginDetailDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkStationLoginDetailPage(_response);
        });
    }

    protected processWorkStationLoginDetailPage(response: AxiosResponse): Promise<IPageOfWorkStationLoginDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkStationLoginDetailVO.fromJS(resultData200) : new IPageOfWorkStationLoginDetailVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkStationLoginDetailVO>(<any>null);
    }

    /**
     * 检查工位、人员是否有登录记录
     * @param checkDTO checkDTO
     * @return OK
     */
    workstationCheck(checkDTO: WorkStationEfficiencyCheckDTO): Promise<WorkStationEfficiencyLoginVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/workstation-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWorkstationCheck(_response);
        });
    }

    protected processWorkstationCheck(response: AxiosResponse): Promise<WorkStationEfficiencyLoginVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationEfficiencyLoginVO.fromJS(resultData200) : new WorkStationEfficiencyLoginVO();
            return result200;
        }
        return Promise.resolve<WorkStationEfficiencyLoginVO>(<any>null);
    }

    /**
     * 工位登入综合统计
     * @param alarmStatisticsDTO alarmStatisticsDTO
     * @return OK
     */
    searchData(alarmStatisticsDTO: WorkStationEfficiencySearchDTO): Promise<WorkstationLoginCountVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/workstation-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchData(_response);
        });
    }

    protected processSearchData(response: AxiosResponse): Promise<WorkstationLoginCountVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkstationLoginCountVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkstationLoginCountVO[]>(<any>null);
    }

    /**
     * 工位登入接口
     * @param loginDTO loginDTO
     * @return OK
     */
    loginWorkStation(loginDTO: WorkStationEfficiencyLoginDTO): Promise<WorkStationEfficiencyLoginVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/workstation-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginWorkStation(_response);
        });
    }

    protected processLoginWorkStation(response: AxiosResponse): Promise<WorkStationEfficiencyLoginVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationEfficiencyLoginVO.fromJS(resultData200) : new WorkStationEfficiencyLoginVO();
            return result200;
        }
        return Promise.resolve<WorkStationEfficiencyLoginVO>(<any>null);
    }

    /**
     * 工位登入接口（含DMP产量）
     * @param loginDTO loginDTO
     * @return OK
     */
    loginWorkStationDmp(loginDTO: WorkStationEfficiencyLoginDTO): Promise<WorkStationEfficiencyLoginVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/workstation-login-dmp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginWorkStationDmp(_response);
        });
    }

    protected processLoginWorkStationDmp(response: AxiosResponse): Promise<WorkStationEfficiencyLoginVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkStationEfficiencyLoginVO.fromJS(resultData200) : new WorkStationEfficiencyLoginVO();
            return result200;
        }
        return Promise.resolve<WorkStationEfficiencyLoginVO>(<any>null);
    }

    /**
     * 工位登出接口（含DMP产量）
     * @param logoutDTO logoutDTO
     * @return OK
     */
    logoutDmp(logoutDTO: WorkStationEfficiencyLogoutDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/workstation-logout-dmp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logoutDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogoutDmp(_response);
        });
    }

    protected processLogoutDmp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 工位登出接口
     * @param id (optional) id
     * @return OK
     */
    logout(id: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-mdc')+ "/workstation-statistics/workstation-out/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class AlarmCurDayDetailVO implements IAlarmCurDayDetailVO {
    /** 报警代码 */
    alarmCode!: string | undefined;
    /** 报警信息 */
    alarmMsg!: string | undefined;
    /** 报警时间 */
    alarmTime!: Date | undefined;
    /** 设备编号 */
    workStationCode!: string | undefined;
    /** 设备名称 */
    workStationName!: string | undefined;

    constructor(data?: IAlarmCurDayDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alarmCode = data["alarmCode"];
            this.alarmMsg = data["alarmMsg"];
            this.alarmTime = data["alarmTime"] ? new Date(data["alarmTime"].toString()) : <any>undefined;
            this.workStationCode = data["workStationCode"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): AlarmCurDayDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmCurDayDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmCode"] = this.alarmCode;
        data["alarmMsg"] = this.alarmMsg;
        data["alarmTime"] = this.alarmTime ? this.alarmTime.toISOString() : <any>undefined;
        data["workStationCode"] = this.workStationCode;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IAlarmCurDayDetailVO {
    /** 报警代码 */
    alarmCode: string | undefined;
    /** 报警信息 */
    alarmMsg: string | undefined;
    /** 报警时间 */
    alarmTime: Date | undefined;
    /** 设备编号 */
    workStationCode: string | undefined;
    /** 设备名称 */
    workStationName: string | undefined;
}

export class AlarmDetailCountVO implements IAlarmDetailCountVO {
    /** 报警时间 */
    alarmTime!: string[] | undefined;
    /** 报警数量 */
    count!: string[] | undefined;

    constructor(data?: IAlarmDetailCountVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["alarmTime"] && data["alarmTime"].constructor === Array) {
                this.alarmTime = [] as any;
                for (let item of data["alarmTime"])
                    this.alarmTime!.push(item);
            }
            if (data["count"] && data["count"].constructor === Array) {
                this.count = [] as any;
                for (let item of data["count"])
                    this.count!.push(item);
            }
        }
    }

    static fromJS(data: any): AlarmDetailCountVO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDetailCountVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.alarmTime && this.alarmTime.constructor === Array) {
            data["alarmTime"] = [];
            for (let item of this.alarmTime)
                data["alarmTime"].push(item);
        }
        if (this.count && this.count.constructor === Array) {
            data["count"] = [];
            for (let item of this.count)
                data["count"].push(item);
        }
        return data; 
    }
}

export interface IAlarmDetailCountVO {
    /** 报警时间 */
    alarmTime: string[] | undefined;
    /** 报警数量 */
    count: string[] | undefined;
}

export class AlarmDetailDTO implements IAlarmDetailDTO {
    /** 1:冷数据,2:热数据 */
    dataType!: number | undefined;
    /** 日 */
    date!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: AlarmDetailDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IAlarmDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataType = data["dataType"];
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.month = data["month"];
            this.shiftIndex = data["shiftIndex"];
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            this.workStationId = data["workStationId"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): AlarmDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataType"] = this.dataType;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["month"] = this.month;
        data["shiftIndex"] = this.shiftIndex;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        data["workStationId"] = this.workStationId;
        data["year"] = this.year;
        return data; 
    }
}

export interface IAlarmDetailDTO {
    /** 1:冷数据,2:热数据 */
    dataType: number | undefined;
    /** 日 */
    date: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: AlarmDetailDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 年 */
    year: number | undefined;
}

export class AlarmDetailVO implements IAlarmDetailVO {
    /** 报警CODE */
    alarmCode!: string | undefined;
    /** 报警信息 */
    alarmMsg!: string | undefined;
    /** 报警时间 */
    alarmTime!: Date | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;

    constructor(data?: IAlarmDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alarmCode = data["alarmCode"];
            this.alarmMsg = data["alarmMsg"];
            this.alarmTime = data["alarmTime"] ? new Date(data["alarmTime"].toString()) : <any>undefined;
            this.deviceTypeId = data["deviceTypeId"];
        }
    }

    static fromJS(data: any): AlarmDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmCode"] = this.alarmCode;
        data["alarmMsg"] = this.alarmMsg;
        data["alarmTime"] = this.alarmTime ? this.alarmTime.toISOString() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        return data; 
    }
}

export interface IAlarmDetailVO {
    /** 报警CODE */
    alarmCode: string | undefined;
    /** 报警信息 */
    alarmMsg: string | undefined;
    /** 报警时间 */
    alarmTime: Date | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
}

export class AlarmExcelDTO implements IAlarmExcelDTO {
    /** 日 */
    date!: string[] | undefined;
    /** 月 */
    month!: number[] | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: AlarmExcelDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number[] | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IAlarmExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["date"] && data["date"].constructor === Array) {
                this.date = [] as any;
                for (let item of data["date"])
                    this.date!.push(item);
            }
            if (data["month"] && data["month"].constructor === Array) {
                this.month = [] as any;
                for (let item of data["month"])
                    this.month!.push(item);
            }
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.statisticalMethod = data["statisticalMethod"];
            if (data["week"] && data["week"].constructor === Array) {
                this.week = [] as any;
                for (let item of data["week"])
                    this.week!.push(item);
            }
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): AlarmExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.date && this.date.constructor === Array) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item);
        }
        if (this.month && this.month.constructor === Array) {
            data["month"] = [];
            for (let item of this.month)
                data["month"].push(item);
        }
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["statisticalMethod"] = this.statisticalMethod;
        if (this.week && this.week.constructor === Array) {
            data["week"] = [];
            for (let item of this.week)
                data["week"].push(item);
        }
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IAlarmExcelDTO {
    /** 日 */
    date: string[] | undefined;
    /** 月 */
    month: number[] | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: AlarmExcelDTOStatisticalMethod | undefined;
    /** 周 */
    week: number[] | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class AlarmHistoryQueryDTO implements IAlarmHistoryQueryDTO {
    /** 报警代码 */
    alarmCode!: string | undefined;
    /** 客户id列表 */
    customerIdList!: string[] | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 设备类型列表 */
    deviceTypeIdList!: string[] | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 所选中的数据 */
    idList!: string[] | undefined;
    /** 报警类型 */
    issueType!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 机床信息 */
    workStationInfo!: string | undefined;

    constructor(data?: IAlarmHistoryQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alarmCode = data["alarmCode"];
            if (data["customerIdList"] && data["customerIdList"].constructor === Array) {
                this.customerIdList = [] as any;
                for (let item of data["customerIdList"])
                    this.customerIdList!.push(item);
            }
            this.customerName = data["customerName"];
            if (data["deviceTypeIdList"] && data["deviceTypeIdList"].constructor === Array) {
                this.deviceTypeIdList = [] as any;
                for (let item of data["deviceTypeIdList"])
                    this.deviceTypeIdList!.push(item);
            }
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [] as any;
                for (let item of data["idList"])
                    this.idList!.push(item);
            }
            this.issueType = data["issueType"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.workStationInfo = data["workStationInfo"];
        }
    }

    static fromJS(data: any): AlarmHistoryQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmHistoryQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmCode"] = this.alarmCode;
        if (this.customerIdList && this.customerIdList.constructor === Array) {
            data["customerIdList"] = [];
            for (let item of this.customerIdList)
                data["customerIdList"].push(item);
        }
        data["customerName"] = this.customerName;
        if (this.deviceTypeIdList && this.deviceTypeIdList.constructor === Array) {
            data["deviceTypeIdList"] = [];
            for (let item of this.deviceTypeIdList)
                data["deviceTypeIdList"].push(item);
        }
        data["endTime"] = this.endTime ? formatDate(this.endTime) : <any>undefined;
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["issueType"] = this.issueType;
        data["startTime"] = this.startTime ? formatDate(this.startTime) : <any>undefined;
        data["workStationInfo"] = this.workStationInfo;
        return data; 
    }
}

export interface IAlarmHistoryQueryDTO {
    /** 报警代码 */
    alarmCode: string | undefined;
    /** 客户id列表 */
    customerIdList: string[] | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 设备类型列表 */
    deviceTypeIdList: string[] | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 所选中的数据 */
    idList: string[] | undefined;
    /** 报警类型 */
    issueType: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 机床信息 */
    workStationInfo: string | undefined;
}

export class AlarmHistoryVO implements IAlarmHistoryVO {
    /** 报警消息 */
    alarmMessage!: string | undefined;
    /** 报警时间 */
    alarmTime!: Date | undefined;
    /** 所属客户 */
    customerName!: string | undefined;
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 主键ID */
    id!: string | undefined;
    /** 报警代码 */
    issueCode!: string | undefined;
    /** 序列号 */
    serialNo!: string | undefined;
    /** 机床名称 */
    workStationName!: string | undefined;

    constructor(data?: IAlarmHistoryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alarmMessage = data["alarmMessage"];
            this.alarmTime = data["alarmTime"] ? new Date(data["alarmTime"].toString()) : <any>undefined;
            this.customerName = data["customerName"];
            this.deviceTypeId = data["deviceTypeId"];
            this.id = data["id"];
            this.issueCode = data["issueCode"];
            this.serialNo = data["serialNo"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): AlarmHistoryVO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmHistoryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmMessage"] = this.alarmMessage;
        data["alarmTime"] = this.alarmTime ? this.alarmTime.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        data["issueCode"] = this.issueCode;
        data["serialNo"] = this.serialNo;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IAlarmHistoryVO {
    /** 报警消息 */
    alarmMessage: string | undefined;
    /** 报警时间 */
    alarmTime: Date | undefined;
    /** 所属客户 */
    customerName: string | undefined;
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 主键ID */
    id: string | undefined;
    /** 报警代码 */
    issueCode: string | undefined;
    /** 序列号 */
    serialNo: string | undefined;
    /** 机床名称 */
    workStationName: string | undefined;
}

export class AlarmInfoVO implements IAlarmInfoVO {
    /** 报警CODE */
    code!: string | undefined;
    /** 报警数量 */
    count!: number | undefined;

    constructor(data?: IAlarmInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): AlarmInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["count"] = this.count;
        return data; 
    }
}

export interface IAlarmInfoVO {
    /** 报警CODE */
    code: string | undefined;
    /** 报警数量 */
    count: number | undefined;
}

export class AlarmStatisticsDTO implements IAlarmStatisticsDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: AlarmStatisticsDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IAlarmStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): AlarmStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["month"] = this.month;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IAlarmStatisticsDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: AlarmStatisticsDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class AlarmStatisticsVO implements IAlarmStatisticsVO {
    /** 工位报警统计列表 */
    items!: WorkStationAlarmVO[] | undefined;

    constructor(data?: IAlarmStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(WorkStationAlarmVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlarmStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAlarmStatisticsVO {
    /** 工位报警统计列表 */
    items: WorkStationAlarmVO[] | undefined;
}

export class AnalysisFilterDTO implements IAnalysisFilterDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: AnalysisFilterDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IAnalysisFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): AnalysisFilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisFilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["month"] = this.month;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IAnalysisFilterDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: AnalysisFilterDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class AverageOeeStatisticVO implements IAverageOeeStatisticVO {
    /** 本日 */
    day!: number | undefined;
    /** 本月 */
    month!: number | undefined;
    /** 本周 */
    week!: number | undefined;

    constructor(data?: IAverageOeeStatisticVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"];
            this.month = data["month"];
            this.week = data["week"];
        }
    }

    static fromJS(data: any): AverageOeeStatisticVO {
        data = typeof data === 'object' ? data : {};
        let result = new AverageOeeStatisticVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["month"] = this.month;
        data["week"] = this.week;
        return data; 
    }
}

export interface IAverageOeeStatisticVO {
    /** 本日 */
    day: number | undefined;
    /** 本月 */
    month: number | undefined;
    /** 本周 */
    week: number | undefined;
}

export class AverageUtilizationRateVO implements IAverageUtilizationRateVO {
    /** 平均稼动率 */
    averageUtilizationRate!: number | undefined;

    constructor(data?: IAverageUtilizationRateVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.averageUtilizationRate = data["averageUtilizationRate"];
        }
    }

    static fromJS(data: any): AverageUtilizationRateVO {
        data = typeof data === 'object' ? data : {};
        let result = new AverageUtilizationRateVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageUtilizationRate"] = this.averageUtilizationRate;
        return data; 
    }
}

export interface IAverageUtilizationRateVO {
    /** 平均稼动率 */
    averageUtilizationRate: number | undefined;
}

export class BarDataVO implements IBarDataVO {
    /** 横坐标 */
    categories!: string[] | undefined;
    /** 图表信息 */
    series!: ColumnInfo[] | undefined;

    constructor(data?: IBarDataVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(ColumnInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BarDataVO {
        data = typeof data === 'object' ? data : {};
        let result = new BarDataVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBarDataVO {
    /** 横坐标 */
    categories: string[] | undefined;
    /** 图表信息 */
    series: ColumnInfo[] | undefined;
}

export class ChartDataVO implements IChartDataVO {
    name!: string | undefined;
    value!: any | undefined;

    constructor(data?: IChartDataVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ChartDataVO {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IChartDataVO {
    name: string | undefined;
    value: any | undefined;
}

export class ChartDataVOOfdouble implements IChartDataVOOfdouble {
    name!: string | undefined;
    value!: number | undefined;

    constructor(data?: IChartDataVOOfdouble) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ChartDataVOOfdouble {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataVOOfdouble();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IChartDataVOOfdouble {
    name: string | undefined;
    value: number | undefined;
}

export class CollectStatusVO implements ICollectStatusVO {
    /** 采集状态值 */
    collectStatus!: number | undefined;
    /** 采集状态名 */
    collectStatusName!: string | undefined;
    /** 颜色 */
    color!: string | undefined;

    constructor(data?: ICollectStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collectStatus = data["collectStatus"];
            this.collectStatusName = data["collectStatusName"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): CollectStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new CollectStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collectStatus"] = this.collectStatus;
        data["collectStatusName"] = this.collectStatusName;
        data["color"] = this.color;
        return data; 
    }
}

export interface ICollectStatusVO {
    /** 采集状态值 */
    collectStatus: number | undefined;
    /** 采集状态名 */
    collectStatusName: string | undefined;
    /** 颜色 */
    color: string | undefined;
}

export class ColumnInfo implements IColumnInfo {
    /** 图表数据列表 */
    data!: any[] | undefined;
    /** 图表对应图例名 */
    name!: string | undefined;

    constructor(data?: IColumnInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ColumnInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IColumnInfo {
    /** 图表数据列表 */
    data: any[] | undefined;
    /** 图表对应图例名 */
    name: string | undefined;
}

export class ColumnInfoDTO implements IColumnInfoDTO {
    /** 编号 */
    code!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 标准效率 */
    standardEfficiency!: number | undefined;
    /** 显示标题 */
    title!: string | undefined;

    constructor(data?: IColumnInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.standardEfficiency = data["standardEfficiency"];
            this.title = data["title"];
        }
    }

    static fromJS(data: any): ColumnInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["standardEfficiency"] = this.standardEfficiency;
        data["title"] = this.title;
        return data; 
    }
}

export interface IColumnInfoDTO {
    /** 编号 */
    code: string | undefined;
    /** id */
    id: string | undefined;
    /** 标准效率 */
    standardEfficiency: number | undefined;
    /** 显示标题 */
    title: string | undefined;
}

export class ColumnInfoVO implements IColumnInfoVO {
    /** 编号 */
    code!: string | undefined;
    /** 显示标题 */
    title!: string | undefined;

    constructor(data?: IColumnInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.title = data["title"];
        }
    }

    static fromJS(data: any): ColumnInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["title"] = this.title;
        return data; 
    }
}

export interface IColumnInfoVO {
    /** 编号 */
    code: string | undefined;
    /** 显示标题 */
    title: string | undefined;
}

export class CustomerQueryDTO implements ICustomerQueryDTO {
    /** 大区列表 */
    areaNameList!: string[] | undefined;
    /** 图表类型: 1:报警代码,2:报警类型,3:客户名称,4机床序列号 */
    chartType!: number | undefined;

    constructor(data?: ICustomerQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["areaNameList"] && data["areaNameList"].constructor === Array) {
                this.areaNameList = [] as any;
                for (let item of data["areaNameList"])
                    this.areaNameList!.push(item);
            }
            this.chartType = data["chartType"];
        }
    }

    static fromJS(data: any): CustomerQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.areaNameList && this.areaNameList.constructor === Array) {
            data["areaNameList"] = [];
            for (let item of this.areaNameList)
                data["areaNameList"].push(item);
        }
        data["chartType"] = this.chartType;
        return data; 
    }
}

export interface ICustomerQueryDTO {
    /** 大区列表 */
    areaNameList: string[] | undefined;
    /** 图表类型: 1:报警代码,2:报警类型,3:客户名称,4机床序列号 */
    chartType: number | undefined;
}

export class DataSourceDTO implements IDataSourceDTO {
    /** 属性值 */
    propertyKey!: number | undefined;
    /** 属性名称 */
    propertyName!: string | undefined;

    constructor(data?: IDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyKey = data["propertyKey"];
            this.propertyName = data["propertyName"];
        }
    }

    static fromJS(data: any): DataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyKey"] = this.propertyKey;
        data["propertyName"] = this.propertyName;
        return data; 
    }
}

export interface IDataSourceDTO {
    /** 属性值 */
    propertyKey: number | undefined;
    /** 属性名称 */
    propertyName: string | undefined;
}

export class DeviceHistoryDataVo implements IDeviceHistoryDataVo {
    tableData!: HashMapOfstringAndstring[] | undefined;
    tableHeaderList!: string[] | undefined;

    constructor(data?: IDeviceHistoryDataVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["tableData"] && data["tableData"].constructor === Array) {
                this.tableData = [] as any;
                for (let item of data["tableData"])
                    this.tableData!.push(HashMapOfstringAndstring.fromJS(item));
            }
            if (data["tableHeaderList"] && data["tableHeaderList"].constructor === Array) {
                this.tableHeaderList = [] as any;
                for (let item of data["tableHeaderList"])
                    this.tableHeaderList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeviceHistoryDataVo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceHistoryDataVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tableData && this.tableData.constructor === Array) {
            data["tableData"] = [];
            for (let item of this.tableData)
                data["tableData"].push(item.toJSON());
        }
        if (this.tableHeaderList && this.tableHeaderList.constructor === Array) {
            data["tableHeaderList"] = [];
            for (let item of this.tableHeaderList)
                data["tableHeaderList"].push(item);
        }
        return data; 
    }
}

export interface IDeviceHistoryDataVo {
    tableData: HashMapOfstringAndstring[] | undefined;
    tableHeaderList: string[] | undefined;
}

export class DeviceOutputMergeVO implements IDeviceOutputMergeVO {
    categories!: string[] | undefined;
    series!: SeriesVO[] | undefined;

    constructor(data?: IDeviceOutputMergeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(SeriesVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceOutputMergeVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceOutputMergeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceOutputMergeVO {
    categories: string[] | undefined;
    series: SeriesVO[] | undefined;
}

export class DeviceOutputVO implements IDeviceOutputVO {
    categories!: number[] | undefined;
    series!: SeriesVO[] | undefined;

    constructor(data?: IDeviceOutputVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(SeriesVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceOutputVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceOutputVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceOutputVO {
    categories: number[] | undefined;
    series: SeriesVO[] | undefined;
}

export class DeviceQueryDTO implements IDeviceQueryDTO {
    /** 大区列表 */
    areaNameList!: string[] | undefined;
    /** 状态 */
    statusList!: number[] | undefined;
    /** 工位ID列表 */
    workStationIdList!: string[] | undefined;

    constructor(data?: IDeviceQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["areaNameList"] && data["areaNameList"].constructor === Array) {
                this.areaNameList = [] as any;
                for (let item of data["areaNameList"])
                    this.areaNameList!.push(item);
            }
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [] as any;
                for (let item of data["statusList"])
                    this.statusList!.push(item);
            }
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeviceQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.areaNameList && this.areaNameList.constructor === Array) {
            data["areaNameList"] = [];
            for (let item of this.areaNameList)
                data["areaNameList"].push(item);
        }
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IDeviceQueryDTO {
    /** 大区列表 */
    areaNameList: string[] | undefined;
    /** 状态 */
    statusList: number[] | undefined;
    /** 工位ID列表 */
    workStationIdList: string[] | undefined;
}

export class DeviceShiftYieldVO implements IDeviceShiftYieldVO {
    /** 设备的采集数量 */
    collectYield!: string[] | undefined;
    /** 设备名称 */
    deviceName!: string[] | undefined;
    /** 设备的报工数量 */
    reportNumber!: string[] | undefined;

    constructor(data?: IDeviceShiftYieldVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["collectYield"] && data["collectYield"].constructor === Array) {
                this.collectYield = [] as any;
                for (let item of data["collectYield"])
                    this.collectYield!.push(item);
            }
            if (data["deviceName"] && data["deviceName"].constructor === Array) {
                this.deviceName = [] as any;
                for (let item of data["deviceName"])
                    this.deviceName!.push(item);
            }
            if (data["reportNumber"] && data["reportNumber"].constructor === Array) {
                this.reportNumber = [] as any;
                for (let item of data["reportNumber"])
                    this.reportNumber!.push(item);
            }
        }
    }

    static fromJS(data: any): DeviceShiftYieldVO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceShiftYieldVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.collectYield && this.collectYield.constructor === Array) {
            data["collectYield"] = [];
            for (let item of this.collectYield)
                data["collectYield"].push(item);
        }
        if (this.deviceName && this.deviceName.constructor === Array) {
            data["deviceName"] = [];
            for (let item of this.deviceName)
                data["deviceName"].push(item);
        }
        if (this.reportNumber && this.reportNumber.constructor === Array) {
            data["reportNumber"] = [];
            for (let item of this.reportNumber)
                data["reportNumber"].push(item);
        }
        return data; 
    }
}

export interface IDeviceShiftYieldVO {
    /** 设备的采集数量 */
    collectYield: string[] | undefined;
    /** 设备名称 */
    deviceName: string[] | undefined;
    /** 设备的报工数量 */
    reportNumber: string[] | undefined;
}

export class DowntimeQueryDataSourceDTO implements IDowntimeQueryDataSourceDTO {
    /** 停机时长时间维度1:近30天,2:当月,3:近12个月 */
    outageTime!: number | undefined;
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: IDowntimeQueryDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outageTime = data["outageTime"];
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): DowntimeQueryDataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DowntimeQueryDataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outageTime"] = this.outageTime;
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IDowntimeQueryDataSourceDTO {
    /** 停机时长时间维度1:近30天,2:当月,3:近12个月 */
    outageTime: number | undefined;
    /** 工位id */
    workStationIdList: string[] | undefined;
}

export class ElectricityStatisticsDTO implements IElectricityStatisticsDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: ElectricityStatisticsDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IElectricityStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ElectricityStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["month"] = this.month;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IElectricityStatisticsDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: ElectricityStatisticsDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class ElectricityStatisticsVO implements IElectricityStatisticsVO {
    /** 列信息 */
    columns!: ColumnInfoVO[] | undefined;
    /** 工位能耗列表 */
    items!: WorkStationElectricityVO[] | undefined;

    constructor(data?: IElectricityStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["columns"] && data["columns"].constructor === Array) {
                this.columns = [] as any;
                for (let item of data["columns"])
                    this.columns!.push(ColumnInfoVO.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(WorkStationElectricityVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectricityStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columns && this.columns.constructor === Array) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IElectricityStatisticsVO {
    /** 列信息 */
    columns: ColumnInfoVO[] | undefined;
    /** 工位能耗列表 */
    items: WorkStationElectricityVO[] | undefined;
}

export class EmployeeInfoVO implements IEmployeeInfoVO {
    /** 编号 */
    employeeCode!: string | undefined;
    /** Id */
    employeeId!: string | undefined;
    /** 姓名 */
    employeeName!: string | undefined;

    constructor(data?: IEmployeeInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.employeeCode = data["employeeCode"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
        }
    }

    static fromJS(data: any): EmployeeInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        return data; 
    }
}

export interface IEmployeeInfoVO {
    /** 编号 */
    employeeCode: string | undefined;
    /** Id */
    employeeId: string | undefined;
    /** 姓名 */
    employeeName: string | undefined;
}

export class GroupIdsDTO implements IGroupIdsDTO {
    groupIdList!: string[] | undefined;

    constructor(data?: IGroupIdsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["groupIdList"] && data["groupIdList"].constructor === Array) {
                this.groupIdList = [] as any;
                for (let item of data["groupIdList"])
                    this.groupIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupIdsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupIdsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.groupIdList && this.groupIdList.constructor === Array) {
            data["groupIdList"] = [];
            for (let item of this.groupIdList)
                data["groupIdList"].push(item);
        }
        return data; 
    }
}

export interface IGroupIdsDTO {
    groupIdList: string[] | undefined;
}

export class HashMapOfstringAndstring implements IHashMapOfstringAndstring {

    [key: string]: string | any; 

    constructor(data?: IHashMapOfstringAndstring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }

    static fromJS(data: any): HashMapOfstringAndstring {
        data = typeof data === 'object' ? data : {};
        let result = new HashMapOfstringAndstring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data; 
    }
}

export interface IHashMapOfstringAndstring {

    [key: string]: string | any; 
}

export class IPageOfAlarmCurDayDetailVO implements IIPageOfAlarmCurDayDetailVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AlarmCurDayDetailVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAlarmCurDayDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AlarmCurDayDetailVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAlarmCurDayDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAlarmCurDayDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAlarmCurDayDetailVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AlarmCurDayDetailVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfAlarmDetailVO implements IIPageOfAlarmDetailVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AlarmDetailVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAlarmDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AlarmDetailVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAlarmDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAlarmDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAlarmDetailVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AlarmDetailVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfAlarmHistoryVO implements IIPageOfAlarmHistoryVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: AlarmHistoryVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfAlarmHistoryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(AlarmHistoryVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfAlarmHistoryVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfAlarmHistoryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfAlarmHistoryVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: AlarmHistoryVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWeeklyEfficiencyVO implements IIPageOfWeeklyEfficiencyVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WeeklyEfficiencyVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWeeklyEfficiencyVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WeeklyEfficiencyVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWeeklyEfficiencyVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWeeklyEfficiencyVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWeeklyEfficiencyVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WeeklyEfficiencyVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWorkStationAlarmVO implements IIPageOfWorkStationAlarmVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkStationAlarmVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkStationAlarmVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkStationAlarmVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkStationAlarmVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkStationAlarmVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkStationAlarmVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkStationAlarmVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWorkStationLoginDetailVO implements IIPageOfWorkStationLoginDetailVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkStationLoginDetailVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkStationLoginDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkStationLoginDetailVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkStationLoginDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkStationLoginDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkStationLoginDetailVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkStationLoginDetailVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWorkStationStatisticRpsDTO implements IIPageOfWorkStationStatisticRpsDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkStationStatisticRpsDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkStationStatisticRpsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkStationStatisticRpsDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkStationStatisticRpsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkStationStatisticRpsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkStationStatisticRpsDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkStationStatisticRpsDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWorkStationStatusRecordVO implements IIPageOfWorkStationStatusRecordVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkStationStatusRecordVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkStationStatusRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkStationStatusRecordVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkStationStatusRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkStationStatusRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkStationStatusRecordVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkStationStatusRecordVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class KeyNameDTO implements IKeyNameDTO {
    /** 编码 */
    code!: string | undefined;
    /** key */
    key!: string | undefined;
    /** 名称 */
    name!: string | undefined;
    /** 序列号 */
    serialNo!: string | undefined;
    /** 标准效率 */
    standardEfficiency!: number | undefined;

    constructor(data?: IKeyNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.key = data["key"];
            this.name = data["name"];
            this.serialNo = data["serialNo"];
            this.standardEfficiency = data["standardEfficiency"];
        }
    }

    static fromJS(data: any): KeyNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KeyNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["key"] = this.key;
        data["name"] = this.name;
        data["serialNo"] = this.serialNo;
        data["standardEfficiency"] = this.standardEfficiency;
        return data; 
    }
}

export interface IKeyNameDTO {
    /** 编码 */
    code: string | undefined;
    /** key */
    key: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 序列号 */
    serialNo: string | undefined;
    /** 标准效率 */
    standardEfficiency: number | undefined;
}

export class KeyNameDTO_1 implements IKeyNameDTO_1 {
    /** key */
    key!: string | undefined;
    /** 名称 */
    name!: string | undefined;

    constructor(data?: IKeyNameDTO_1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): KeyNameDTO_1 {
        data = typeof data === 'object' ? data : {};
        let result = new KeyNameDTO_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        return data; 
    }
}

export interface IKeyNameDTO_1 {
    /** key */
    key: string | undefined;
    /** 名称 */
    name: string | undefined;
}

export class MdcVisualData implements IMdcVisualData {
    data!: number[] | undefined;
    name!: string | undefined;

    constructor(data?: IMdcVisualData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): MdcVisualData {
        data = typeof data === 'object' ? data : {};
        let result = new MdcVisualData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IMdcVisualData {
    data: number[] | undefined;
    name: string | undefined;
}

export class MdcVisualStatusData implements IMdcVisualStatusData {
    data!: number[] | undefined;
    name!: string | undefined;

    constructor(data?: IMdcVisualStatusData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): MdcVisualStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new MdcVisualStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IMdcVisualStatusData {
    data: number[] | undefined;
    name: string | undefined;
}

export class MdcVisualStatusVO implements IMdcVisualStatusVO {
    /** 工位名称集合 */
    categories!: string[] | undefined;
    /** 工位数据 */
    series!: MdcVisualStatusData[] | undefined;

    constructor(data?: IMdcVisualStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(MdcVisualStatusData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MdcVisualStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new MdcVisualStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMdcVisualStatusVO {
    /** 工位名称集合 */
    categories: string[] | undefined;
    /** 工位数据 */
    series: MdcVisualStatusData[] | undefined;
}

export class MdcVisualVO implements IMdcVisualVO {
    /** 工位名称集合 */
    categories!: string[] | undefined;
    /** 工位数据 */
    series!: MdcVisualData[] | undefined;

    constructor(data?: IMdcVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(MdcVisualData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MdcVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new MdcVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMdcVisualVO {
    /** 工位名称集合 */
    categories: string[] | undefined;
    /** 工位数据 */
    series: MdcVisualData[] | undefined;
}

export class OeeColumnarQueryDataSourceDTO implements IOeeColumnarQueryDataSourceDTO {
    /** 平均稼动率时间维度1:当前班次,2:当天,3:当周,4:当月 */
    oeeTimeType!: number | undefined;
    /** 工位组id集合 */
    workStationGroupIdList!: string[] | undefined;

    constructor(data?: IOeeColumnarQueryDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.oeeTimeType = data["oeeTimeType"];
            if (data["workStationGroupIdList"] && data["workStationGroupIdList"].constructor === Array) {
                this.workStationGroupIdList = [] as any;
                for (let item of data["workStationGroupIdList"])
                    this.workStationGroupIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): OeeColumnarQueryDataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OeeColumnarQueryDataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oeeTimeType"] = this.oeeTimeType;
        if (this.workStationGroupIdList && this.workStationGroupIdList.constructor === Array) {
            data["workStationGroupIdList"] = [];
            for (let item of this.workStationGroupIdList)
                data["workStationGroupIdList"].push(item);
        }
        return data; 
    }
}

export interface IOeeColumnarQueryDataSourceDTO {
    /** 平均稼动率时间维度1:当前班次,2:当天,3:当周,4:当月 */
    oeeTimeType: number | undefined;
    /** 工位组id集合 */
    workStationGroupIdList: string[] | undefined;
}

export class OeeQueryDataSourceDTO implements IOeeQueryDataSourceDTO {
    /** 平均稼动率时间维度1:当前班次,2:当天,3:当周,4:当月 */
    oeeTimeType!: number | undefined;
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: IOeeQueryDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.oeeTimeType = data["oeeTimeType"];
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): OeeQueryDataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OeeQueryDataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oeeTimeType"] = this.oeeTimeType;
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IOeeQueryDataSourceDTO {
    /** 平均稼动率时间维度1:当前班次,2:当天,3:当周,4:当月 */
    oeeTimeType: number | undefined;
    /** 工位id */
    workStationIdList: string[] | undefined;
}

export class OperationStatisticsDTO implements IOperationStatisticsDTO {
    /** 结束日期 */
    endDate!: Date | undefined;
    /** 效率类型:RUNNING--运行率--1,ALARM--报警率--2,OEE--稼动率--3 */
    productivityType!: OperationStatisticsDTOProductivityType | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 显示维度:TIME--时间对比--2,WORKSTATION--设备比对--1 */
    showType!: number | undefined;
    /** 开始日期 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: number | undefined;
    /** 租户 */
    tenantId!: string | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;

    constructor(data?: IOperationStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.productivityType = data["productivityType"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.showType = data["showType"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.tenantId = data["tenantId"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperationStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OperationStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["productivityType"] = this.productivityType;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["showType"] = this.showType;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["tenantId"] = this.tenantId;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOperationStatisticsDTO {
    /** 结束日期 */
    endDate: Date | undefined;
    /** 效率类型:RUNNING--运行率--1,ALARM--报警率--2,OEE--稼动率--3 */
    productivityType: OperationStatisticsDTOProductivityType | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 显示维度:TIME--时间对比--2,WORKSTATION--设备比对--1 */
    showType: number | undefined;
    /** 开始日期 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: number | undefined;
    /** 租户 */
    tenantId: string | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
}

export class OperationStatisticsHourDTO implements IOperationStatisticsHourDTO {
    /** 工厂日 */
    factoryDate!: Date;
    /** 租户 */
    tenantId!: string | undefined;
    /** 工位Id */
    workStationId!: string;

    constructor(data?: IOperationStatisticsHourDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.factoryDate = data["factoryDate"] ? new Date(data["factoryDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): OperationStatisticsHourDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OperationStatisticsHourDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factoryDate"] = this.factoryDate ? this.factoryDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IOperationStatisticsHourDTO {
    /** 工厂日 */
    factoryDate: Date;
    /** 租户 */
    tenantId: string | undefined;
    /** 工位Id */
    workStationId: string;
}

export class OpsAlarmStatisticsDTO implements IOpsAlarmStatisticsDTO {
    /** 报警代码 */
    alarmCode!: string | undefined;
    /** 区域 */
    areaName!: string | undefined;
    /** 客户ID列表 */
    customerIdList!: string[] | undefined;
    /** 日 */
    date!: Date | undefined;
    /** 设备类型列表 */
    deviceTypeIdList!: string[] | undefined;
    /** 报警类型 */
    issueType!: string | undefined;
    /** 月 */
    month!: number | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: OpsAlarmStatisticsDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 机床信息 */
    workStationInfo!: string | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IOpsAlarmStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alarmCode = data["alarmCode"];
            this.areaName = data["areaName"];
            if (data["customerIdList"] && data["customerIdList"].constructor === Array) {
                this.customerIdList = [] as any;
                for (let item of data["customerIdList"])
                    this.customerIdList!.push(item);
            }
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            if (data["deviceTypeIdList"] && data["deviceTypeIdList"].constructor === Array) {
                this.deviceTypeIdList = [] as any;
                for (let item of data["deviceTypeIdList"])
                    this.deviceTypeIdList!.push(item);
            }
            this.issueType = data["issueType"];
            this.month = data["month"];
            this.shiftIndex = data["shiftIndex"];
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            this.workStationInfo = data["workStationInfo"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): OpsAlarmStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OpsAlarmStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmCode"] = this.alarmCode;
        data["areaName"] = this.areaName;
        if (this.customerIdList && this.customerIdList.constructor === Array) {
            data["customerIdList"] = [];
            for (let item of this.customerIdList)
                data["customerIdList"].push(item);
        }
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        if (this.deviceTypeIdList && this.deviceTypeIdList.constructor === Array) {
            data["deviceTypeIdList"] = [];
            for (let item of this.deviceTypeIdList)
                data["deviceTypeIdList"].push(item);
        }
        data["issueType"] = this.issueType;
        data["month"] = this.month;
        data["shiftIndex"] = this.shiftIndex;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        data["workStationInfo"] = this.workStationInfo;
        data["year"] = this.year;
        return data; 
    }
}

export interface IOpsAlarmStatisticsDTO {
    /** 报警代码 */
    alarmCode: string | undefined;
    /** 区域 */
    areaName: string | undefined;
    /** 客户ID列表 */
    customerIdList: string[] | undefined;
    /** 日 */
    date: Date | undefined;
    /** 设备类型列表 */
    deviceTypeIdList: string[] | undefined;
    /** 报警类型 */
    issueType: string | undefined;
    /** 月 */
    month: number | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: OpsAlarmStatisticsDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 机床信息 */
    workStationInfo: string | undefined;
    /** 年 */
    year: number | undefined;
}

export class OpsProductivityAnalysisDTO implements IOpsProductivityAnalysisDTO {
    /** 区域 */
    areaName!: string | undefined;
    /** 客户ID列表 */
    customerIdList!: string[] | undefined;
    /** 设备类型列表 */
    deviceTypeIdList!: string[] | undefined;
    /** 结束日期 */
    endDate!: Date | undefined;
    /** 效率类型:RUNNING--运行率--1,ALARM--报警率--2,OEE--稼动率--3 */
    productivityType!: OpsProductivityAnalysisDTOProductivityType | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 显示维度:TIME--时间对比--2,WORKSTATION--设备比对--1 */
    showType!: number | undefined;
    /** 开始日期 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: number | undefined;
    /** 租户 */
    tenantId!: string | undefined;
    /** 机床信息 */
    workStationInfo!: string | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;

    constructor(data?: IOpsProductivityAnalysisDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            if (data["customerIdList"] && data["customerIdList"].constructor === Array) {
                this.customerIdList = [] as any;
                for (let item of data["customerIdList"])
                    this.customerIdList!.push(item);
            }
            if (data["deviceTypeIdList"] && data["deviceTypeIdList"].constructor === Array) {
                this.deviceTypeIdList = [] as any;
                for (let item of data["deviceTypeIdList"])
                    this.deviceTypeIdList!.push(item);
            }
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.productivityType = data["productivityType"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.showType = data["showType"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.tenantId = data["tenantId"];
            this.workStationInfo = data["workStationInfo"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OpsProductivityAnalysisDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OpsProductivityAnalysisDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        if (this.customerIdList && this.customerIdList.constructor === Array) {
            data["customerIdList"] = [];
            for (let item of this.customerIdList)
                data["customerIdList"].push(item);
        }
        if (this.deviceTypeIdList && this.deviceTypeIdList.constructor === Array) {
            data["deviceTypeIdList"] = [];
            for (let item of this.deviceTypeIdList)
                data["deviceTypeIdList"].push(item);
        }
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["productivityType"] = this.productivityType;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["showType"] = this.showType;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["tenantId"] = this.tenantId;
        data["workStationInfo"] = this.workStationInfo;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOpsProductivityAnalysisDTO {
    /** 区域 */
    areaName: string | undefined;
    /** 客户ID列表 */
    customerIdList: string[] | undefined;
    /** 设备类型列表 */
    deviceTypeIdList: string[] | undefined;
    /** 结束日期 */
    endDate: Date | undefined;
    /** 效率类型:RUNNING--运行率--1,ALARM--报警率--2,OEE--稼动率--3 */
    productivityType: OpsProductivityAnalysisDTOProductivityType | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 显示维度:TIME--时间对比--2,WORKSTATION--设备比对--1 */
    showType: number | undefined;
    /** 开始日期 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: number | undefined;
    /** 租户 */
    tenantId: string | undefined;
    /** 机床信息 */
    workStationInfo: string | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
}

export class OpsProductivityAnalysisVO implements IOpsProductivityAnalysisVO {
    /** 列信息 */
    columns!: ColumnInfoDTO[] | undefined;
    /** 结束日期 */
    endDate!: Date | undefined;
    /** 数据 */
    page!: IPageOfWorkStationStatisticRpsDTO | undefined;
    /** 效率类型:RUNNING--运行率--1,ALARM--报警率--2,OEE--稼动率--3 */
    productivityType!: OpsProductivityAnalysisVOProductivityType | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 显示维度:TIME--时间对比--2,WORKSTATION--设备比对--1 */
    showType!: number | undefined;
    /** 开始日期 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: number | undefined;
    /** 租户 */
    tenantId!: string | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;

    constructor(data?: IOpsProductivityAnalysisVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["columns"] && data["columns"].constructor === Array) {
                this.columns = [] as any;
                for (let item of data["columns"])
                    this.columns!.push(ColumnInfoDTO.fromJS(item));
            }
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.page = data["page"] ? IPageOfWorkStationStatisticRpsDTO.fromJS(data["page"]) : <any>undefined;
            this.productivityType = data["productivityType"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.showType = data["showType"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.tenantId = data["tenantId"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OpsProductivityAnalysisVO {
        data = typeof data === 'object' ? data : {};
        let result = new OpsProductivityAnalysisVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columns && this.columns.constructor === Array) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        data["productivityType"] = this.productivityType;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["showType"] = this.showType;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["tenantId"] = this.tenantId;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOpsProductivityAnalysisVO {
    /** 列信息 */
    columns: ColumnInfoDTO[] | undefined;
    /** 结束日期 */
    endDate: Date | undefined;
    /** 数据 */
    page: IPageOfWorkStationStatisticRpsDTO | undefined;
    /** 效率类型:RUNNING--运行率--1,ALARM--报警率--2,OEE--稼动率--3 */
    productivityType: OpsProductivityAnalysisVOProductivityType | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 显示维度:TIME--时间对比--2,WORKSTATION--设备比对--1 */
    showType: number | undefined;
    /** 开始日期 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: number | undefined;
    /** 租户 */
    tenantId: string | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
}

export class OpsStatusRecordSelectDTO implements IOpsStatusRecordSelectDTO {
    /** 区域 */
    areaName!: string | undefined;
    /** 客户ID列表 */
    customerIdList!: string[] | undefined;
    /** 查询日期 */
    date!: Date;
    /** 省份 */
    provinceName!: string | undefined;
    /** 机床信息 */
    workStationInfo!: string | undefined;

    constructor(data?: IOpsStatusRecordSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            if (data["customerIdList"] && data["customerIdList"].constructor === Array) {
                this.customerIdList = [] as any;
                for (let item of data["customerIdList"])
                    this.customerIdList!.push(item);
            }
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.provinceName = data["provinceName"];
            this.workStationInfo = data["workStationInfo"];
        }
    }

    static fromJS(data: any): OpsStatusRecordSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OpsStatusRecordSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        if (this.customerIdList && this.customerIdList.constructor === Array) {
            data["customerIdList"] = [];
            for (let item of this.customerIdList)
                data["customerIdList"].push(item);
        }
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["provinceName"] = this.provinceName;
        data["workStationInfo"] = this.workStationInfo;
        return data; 
    }
}

export interface IOpsStatusRecordSelectDTO {
    /** 区域 */
    areaName: string | undefined;
    /** 客户ID列表 */
    customerIdList: string[] | undefined;
    /** 查询日期 */
    date: Date;
    /** 省份 */
    provinceName: string | undefined;
    /** 机床信息 */
    workStationInfo: string | undefined;
}

export class OutputAnalysisVO implements IOutputAnalysisVO {
    dayAverageOutput!: number | undefined;
    dayOutput!: number | undefined;
    monthAverageOutput!: number | undefined;
    monthOutput!: number | undefined;
    shiftAverageOutput!: number | undefined;
    shiftOutput!: number | undefined;
    weekAverageOutput!: number | undefined;
    weekOutput!: number | undefined;

    constructor(data?: IOutputAnalysisVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dayAverageOutput = data["dayAverageOutput"];
            this.dayOutput = data["dayOutput"];
            this.monthAverageOutput = data["monthAverageOutput"];
            this.monthOutput = data["monthOutput"];
            this.shiftAverageOutput = data["shiftAverageOutput"];
            this.shiftOutput = data["shiftOutput"];
            this.weekAverageOutput = data["weekAverageOutput"];
            this.weekOutput = data["weekOutput"];
        }
    }

    static fromJS(data: any): OutputAnalysisVO {
        data = typeof data === 'object' ? data : {};
        let result = new OutputAnalysisVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayAverageOutput"] = this.dayAverageOutput;
        data["dayOutput"] = this.dayOutput;
        data["monthAverageOutput"] = this.monthAverageOutput;
        data["monthOutput"] = this.monthOutput;
        data["shiftAverageOutput"] = this.shiftAverageOutput;
        data["shiftOutput"] = this.shiftOutput;
        data["weekAverageOutput"] = this.weekAverageOutput;
        data["weekOutput"] = this.weekOutput;
        return data; 
    }
}

export interface IOutputAnalysisVO {
    dayAverageOutput: number | undefined;
    dayOutput: number | undefined;
    monthAverageOutput: number | undefined;
    monthOutput: number | undefined;
    shiftAverageOutput: number | undefined;
    shiftOutput: number | undefined;
    weekAverageOutput: number | undefined;
    weekOutput: number | undefined;
}

export class OutputMergeDTO implements IOutputMergeDTO {
    /** 自然日班次日维度,1:自然日,2:班次日 */
    natureType!: number | undefined;
    /** 工位id集合 */
    workStationIdList!: string[] | undefined;

    constructor(data?: IOutputMergeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.natureType = data["natureType"];
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): OutputMergeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OutputMergeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["natureType"] = this.natureType;
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IOutputMergeDTO {
    /** 自然日班次日维度,1:自然日,2:班次日 */
    natureType: number | undefined;
    /** 工位id集合 */
    workStationIdList: string[] | undefined;
}

export class OutputStatisticsDTO implements IOutputStatisticsDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: OutputStatisticsDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IOutputStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): OutputStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OutputStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["month"] = this.month;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IOutputStatisticsDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: OutputStatisticsDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class OutputStatisticsVO implements IOutputStatisticsVO {
    /** 列信息 */
    columns!: ColumnInfoVO[] | undefined;
    /** 工位产量列表 */
    items!: WorkStationOutputVO[] | undefined;

    constructor(data?: IOutputStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["columns"] && data["columns"].constructor === Array) {
                this.columns = [] as any;
                for (let item of data["columns"])
                    this.columns!.push(ColumnInfoVO.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(WorkStationOutputVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutputStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new OutputStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columns && this.columns.constructor === Array) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOutputStatisticsVO {
    /** 列信息 */
    columns: ColumnInfoVO[] | undefined;
    /** 工位产量列表 */
    items: WorkStationOutputVO[] | undefined;
}

/** 要导出的工位数据项 */
export class ProcessParamDescDTO implements IProcessParamDescDTO {
    /** 业务状态 */
    bizType!: number | undefined;
    /** 工位数据项主键id */
    id!: string | undefined;
    /** 工位数据项绑定的网关id */
    iotAppId!: string | undefined;
    /** 采集项名称 */
    iotAppParamDesc!: string | undefined;
    /** 网关版本 */
    iotVersion!: number | undefined;
    /** 工位数据项名称 */
    paramDesc!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: IProcessParamDescDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            this.id = data["id"];
            this.iotAppId = data["iotAppId"];
            this.iotAppParamDesc = data["iotAppParamDesc"];
            this.iotVersion = data["iotVersion"];
            this.paramDesc = data["paramDesc"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ProcessParamDescDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessParamDescDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        data["id"] = this.id;
        data["iotAppId"] = this.iotAppId;
        data["iotAppParamDesc"] = this.iotAppParamDesc;
        data["iotVersion"] = this.iotVersion;
        data["paramDesc"] = this.paramDesc;
        data["unit"] = this.unit;
        return data; 
    }
}

/** 要导出的工位数据项 */
export interface IProcessParamDescDTO {
    /** 业务状态 */
    bizType: number | undefined;
    /** 工位数据项主键id */
    id: string | undefined;
    /** 工位数据项绑定的网关id */
    iotAppId: string | undefined;
    /** 采集项名称 */
    iotAppParamDesc: string | undefined;
    /** 网关版本 */
    iotVersion: number | undefined;
    /** 工位数据项名称 */
    paramDesc: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

export class ProcessParameterEndVO implements IProcessParameterEndVO {
    /** 最终的集合 */
    finalEndList!: ProcessParametersVO[] | undefined;
    /** 为了区分名称相同的id */
    id!: string | undefined;
    /** 工位数据项名称 */
    paramDesc!: string | undefined;
    /** 单位 */
    unit!: string | undefined;

    constructor(data?: IProcessParameterEndVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["finalEndList"] && data["finalEndList"].constructor === Array) {
                this.finalEndList = [] as any;
                for (let item of data["finalEndList"])
                    this.finalEndList!.push(ProcessParametersVO.fromJS(item));
            }
            this.id = data["id"];
            this.paramDesc = data["paramDesc"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ProcessParameterEndVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessParameterEndVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.finalEndList && this.finalEndList.constructor === Array) {
            data["finalEndList"] = [];
            for (let item of this.finalEndList)
                data["finalEndList"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["paramDesc"] = this.paramDesc;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IProcessParameterEndVO {
    /** 最终的集合 */
    finalEndList: ProcessParametersVO[] | undefined;
    /** 为了区分名称相同的id */
    id: string | undefined;
    /** 工位数据项名称 */
    paramDesc: string | undefined;
    /** 单位 */
    unit: string | undefined;
}

export class ProcessParametersDTO implements IProcessParametersDTO {
    /** 开始时间 */
    beginTime!: string | undefined;
    /** 结束时间 */
    endTime!: string | undefined;
    /** 查询哪种图【1为折线图，0为图表】 */
    filter!: number | undefined;
    propertyNameList!: string[] | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IProcessParametersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginTime = data["beginTime"];
            this.endTime = data["endTime"];
            this.filter = data["filter"];
            if (data["propertyNameList"] && data["propertyNameList"].constructor === Array) {
                this.propertyNameList = [] as any;
                for (let item of data["propertyNameList"])
                    this.propertyNameList!.push(item);
            }
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): ProcessParametersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessParametersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginTime"] = this.beginTime;
        data["endTime"] = this.endTime;
        data["filter"] = this.filter;
        if (this.propertyNameList && this.propertyNameList.constructor === Array) {
            data["propertyNameList"] = [];
            for (let item of this.propertyNameList)
                data["propertyNameList"].push(item);
        }
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IProcessParametersDTO {
    /** 开始时间 */
    beginTime: string | undefined;
    /** 结束时间 */
    endTime: string | undefined;
    /** 查询哪种图【1为折线图，0为图表】 */
    filter: number | undefined;
    propertyNameList: string[] | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class ProcessParametersImportDTO implements IProcessParametersImportDTO {
    /** 日期 */
    data!: string | undefined;
    /** 要导出的工位数据项【非全选时：至少选择一项】 */
    wcpsList!: ProcessParamDescDTO[] | undefined;
    /** 工位id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IProcessParametersImportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.data = data["data"];
            if (data["wcpsList"] && data["wcpsList"].constructor === Array) {
                this.wcpsList = [] as any;
                for (let item of data["wcpsList"])
                    this.wcpsList!.push(ProcessParamDescDTO.fromJS(item));
            }
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ProcessParametersImportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessParametersImportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        if (this.wcpsList && this.wcpsList.constructor === Array) {
            data["wcpsList"] = [];
            for (let item of this.wcpsList)
                data["wcpsList"].push(item.toJSON());
        }
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IProcessParametersImportDTO {
    /** 日期 */
    data: string | undefined;
    /** 要导出的工位数据项【非全选时：至少选择一项】 */
    wcpsList: ProcessParamDescDTO[] | undefined;
    /** 工位id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class ProcessParametersVO implements IProcessParametersVO {
    /** 其他过程参数的值 */
    map!: { [key: string] : string; } | undefined;
    /** 当前的属性名 */
    name!: string | undefined;
    /** 上报的时间 */
    reportTime!: string | undefined;
    /** 上报的值 */
    value!: string | undefined;

    constructor(data?: IProcessParametersVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["map"]) {
                this.map = {} as any;
                for (let key in data["map"]) {
                    if (data["map"].hasOwnProperty(key))
                        this.map![key] = data["map"][key];
                }
            }
            this.name = data["name"];
            this.reportTime = data["reportTime"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ProcessParametersVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessParametersVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.map) {
            data["map"] = {};
            for (let key in this.map) {
                if (this.map.hasOwnProperty(key))
                    data["map"][key] = this.map[key];
            }
        }
        data["name"] = this.name;
        data["reportTime"] = this.reportTime;
        data["value"] = this.value;
        return data; 
    }
}

export interface IProcessParametersVO {
    /** 其他过程参数的值 */
    map: { [key: string] : string; } | undefined;
    /** 当前的属性名 */
    name: string | undefined;
    /** 上报的时间 */
    reportTime: string | undefined;
    /** 上报的值 */
    value: string | undefined;
}

export class ProductOutputInfoVO implements IProductOutputInfoVO {
    /** 标准产能 */
    capacity!: string | undefined;
    /** 颜色 */
    colour!: string | undefined;
    /** 设备名称 */
    deviceName!: string | undefined;
    /** 产量 */
    output!: string | undefined;
    /** 产品编号 */
    productName!: string | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: IProductOutputInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.capacity = data["capacity"];
            this.colour = data["colour"];
            this.deviceName = data["deviceName"];
            this.output = data["output"];
            this.productName = data["productName"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): ProductOutputInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductOutputInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capacity"] = this.capacity;
        data["colour"] = this.colour;
        data["deviceName"] = this.deviceName;
        data["output"] = this.output;
        data["productName"] = this.productName;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface IProductOutputInfoVO {
    /** 标准产能 */
    capacity: string | undefined;
    /** 颜色 */
    colour: string | undefined;
    /** 设备名称 */
    deviceName: string | undefined;
    /** 产量 */
    output: string | undefined;
    /** 产品编号 */
    productName: string | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class ProductivityAnalysisDTO implements IProductivityAnalysisDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 效率类型:RUNNING--运行率--1,ALARM--报警率--2,OEE--稼动率--3 */
    productivityType!: ProductivityAnalysisDTOProductivityType | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: ProductivityAnalysisDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IProductivityAnalysisDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.productivityType = data["productivityType"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ProductivityAnalysisDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityAnalysisDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["month"] = this.month;
        data["productivityType"] = this.productivityType;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IProductivityAnalysisDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 效率类型:RUNNING--运行率--1,ALARM--报警率--2,OEE--稼动率--3 */
    productivityType: ProductivityAnalysisDTOProductivityType | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: ProductivityAnalysisDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class ProductivityAnalysisVO implements IProductivityAnalysisVO {
    /** 列信息 */
    columns!: ColumnInfoVO[] | undefined;
    /** 数据 */
    items!: WorkStationProductivityVO[] | undefined;

    constructor(data?: IProductivityAnalysisVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["columns"] && data["columns"].constructor === Array) {
                this.columns = [] as any;
                for (let item of data["columns"])
                    this.columns!.push(ColumnInfoVO.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(WorkStationProductivityVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductivityAnalysisVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivityAnalysisVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columns && this.columns.constructor === Array) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductivityAnalysisVO {
    /** 列信息 */
    columns: ColumnInfoVO[] | undefined;
    /** 数据 */
    items: WorkStationProductivityVO[] | undefined;
}

export class ProvinceStatisticsDTO implements IProvinceStatisticsDTO {
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 报警类型: 1:错误 2:警告 3:提示 */
    issueType!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;

    constructor(data?: IProvinceStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.issueType = data["issueType"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvinceStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime ? formatDate(this.endTime) : <any>undefined;
        data["issueType"] = this.issueType;
        data["startTime"] = this.startTime ? formatDate(this.startTime) : <any>undefined;
        return data; 
    }
}

export interface IProvinceStatisticsDTO {
    /** 结束时间 */
    endTime: Date | undefined;
    /** 报警类型: 1:错误 2:警告 3:提示 */
    issueType: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
}

/** 返回信息 */
export class ROfAlarmDetailCountVO implements IROfAlarmDetailCountVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: AlarmDetailCountVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfAlarmDetailCountVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? AlarmDetailCountVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfAlarmDetailCountVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfAlarmDetailCountVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfAlarmDetailCountVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: AlarmDetailCountVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfAverageUtilizationRateVO implements IROfAverageUtilizationRateVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: AverageUtilizationRateVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfAverageUtilizationRateVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? AverageUtilizationRateVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfAverageUtilizationRateVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfAverageUtilizationRateVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfAverageUtilizationRateVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: AverageUtilizationRateVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfDeviceOutputVO implements IROfDeviceOutputVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DeviceOutputVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfDeviceOutputVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? DeviceOutputVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfDeviceOutputVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfDeviceOutputVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfDeviceOutputVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DeviceOutputVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfDeviceShiftYieldVO implements IROfDeviceShiftYieldVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DeviceShiftYieldVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfDeviceShiftYieldVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? DeviceShiftYieldVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfDeviceShiftYieldVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfDeviceShiftYieldVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfDeviceShiftYieldVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DeviceShiftYieldVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfDeviceOutputMergeVO implements IROfListOfDeviceOutputMergeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DeviceOutputMergeVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfDeviceOutputMergeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(DeviceOutputMergeVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfDeviceOutputMergeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfDeviceOutputMergeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfDeviceOutputMergeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DeviceOutputMergeVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfDeviceOutputVO implements IROfListOfDeviceOutputVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: DeviceOutputVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfDeviceOutputVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(DeviceOutputVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfDeviceOutputVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfDeviceOutputVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfDeviceOutputVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: DeviceOutputVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfListOfStatusRecordPieVO implements IROfListOfListOfStatusRecordPieVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: StatusRecordPieVO[][] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfListOfStatusRecordPieVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfListOfStatusRecordPieVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfListOfStatusRecordPieVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfListOfStatusRecordPieVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: StatusRecordPieVO[][] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfShiftOutputVO implements IROfListOfShiftOutputVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: ShiftOutputVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfShiftOutputVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(ShiftOutputVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfShiftOutputVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfShiftOutputVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfShiftOutputVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: ShiftOutputVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfStatisticMonthOutageTimeVO implements IROfListOfStatisticMonthOutageTimeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: StatisticMonthOutageTimeVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfStatisticMonthOutageTimeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(StatisticMonthOutageTimeVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfStatisticMonthOutageTimeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfStatisticMonthOutageTimeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfStatisticMonthOutageTimeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: StatisticMonthOutageTimeVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfStatusRecordGanttVO implements IROfListOfStatusRecordGanttVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: StatusRecordGanttVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfStatusRecordGanttVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(StatusRecordGanttVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfStatusRecordGanttVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfStatusRecordGanttVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfStatusRecordGanttVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: StatusRecordGanttVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfStatusRecordPieVO implements IROfListOfStatusRecordPieVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: StatusRecordPieVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfStatusRecordPieVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(StatusRecordPieVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfStatusRecordPieVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfStatusRecordPieVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfStatusRecordPieVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: StatusRecordPieVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfStatusTimeTopVO implements IROfListOfStatusTimeTopVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: StatusTimeTopVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfStatusTimeTopVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(StatusTimeTopVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfStatusTimeTopVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfStatusTimeTopVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfStatusTimeTopVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: StatusTimeTopVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfWorkStationAlarmInfoVO implements IROfListOfWorkStationAlarmInfoVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WorkStationAlarmInfoVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfWorkStationAlarmInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(WorkStationAlarmInfoVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfWorkStationAlarmInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfWorkStationAlarmInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfWorkStationAlarmInfoVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WorkStationAlarmInfoVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfWorkStationCurrentStatusVO implements IROfListOfWorkStationCurrentStatusVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WorkStationCurrentStatusVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfWorkStationCurrentStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(WorkStationCurrentStatusVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfWorkStationCurrentStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfWorkStationCurrentStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfWorkStationCurrentStatusVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WorkStationCurrentStatusVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfWorkStationOeeVisualVO implements IROfListOfWorkStationOeeVisualVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WorkStationOeeVisualVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfWorkStationOeeVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(WorkStationOeeVisualVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfWorkStationOeeVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfWorkStationOeeVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfWorkStationOeeVisualVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WorkStationOeeVisualVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfWorkStationShiftOeeVO implements IROfListOfWorkStationShiftOeeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WorkStationShiftOeeVO[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfWorkStationShiftOeeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(WorkStationShiftOeeVO.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfWorkStationShiftOeeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfWorkStationShiftOeeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfWorkStationShiftOeeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WorkStationShiftOeeVO[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMdcVisualStatusVO implements IROfMdcVisualStatusVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MdcVisualStatusVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMdcVisualStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MdcVisualStatusVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMdcVisualStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMdcVisualStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMdcVisualStatusVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MdcVisualStatusVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfMdcVisualVO implements IROfMdcVisualVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: MdcVisualVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfMdcVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? MdcVisualVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfMdcVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfMdcVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfMdcVisualVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: MdcVisualVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfStatusTimeVO implements IROfStatusTimeVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: StatusTimeVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfStatusTimeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? StatusTimeVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfStatusTimeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfStatusTimeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfStatusTimeVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: StatusTimeVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfWorkStationOeeBarVO implements IROfWorkStationOeeBarVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WorkStationOeeBarVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfWorkStationOeeBarVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? WorkStationOeeBarVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfWorkStationOeeBarVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfWorkStationOeeBarVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfWorkStationOeeBarVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WorkStationOeeBarVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfWorkStationVisualVO implements IROfWorkStationVisualVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WorkStationVisualVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfWorkStationVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? WorkStationVisualVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfWorkStationVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfWorkStationVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfWorkStationVisualVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WorkStationVisualVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class SeriesVO implements ISeriesVO {
    data!: number[] | undefined;
    name!: string | undefined;

    constructor(data?: ISeriesVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SeriesVO {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface ISeriesVO {
    data: number[] | undefined;
    name: string | undefined;
}

export class ShiftIndexQueryDataSourceDTO implements IShiftIndexQueryDataSourceDTO {
    /** 班次下标1,2,3,4 */
    shiftIndexList!: number[] | undefined;
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: IShiftIndexQueryDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["shiftIndexList"] && data["shiftIndexList"].constructor === Array) {
                this.shiftIndexList = [] as any;
                for (let item of data["shiftIndexList"])
                    this.shiftIndexList!.push(item);
            }
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ShiftIndexQueryDataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftIndexQueryDataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.shiftIndexList && this.shiftIndexList.constructor === Array) {
            data["shiftIndexList"] = [];
            for (let item of this.shiftIndexList)
                data["shiftIndexList"].push(item);
        }
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IShiftIndexQueryDataSourceDTO {
    /** 班次下标1,2,3,4 */
    shiftIndexList: number[] | undefined;
    /** 工位id */
    workStationIdList: string[] | undefined;
}

export class ShiftIndexRunningTimeVO implements IShiftIndexRunningTimeVO {
    /** 运行时长 */
    runningTime!: string | undefined;
    /** 工位编码 */
    workStationCode!: string | undefined;

    constructor(data?: IShiftIndexRunningTimeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.runningTime = data["runningTime"];
            this.workStationCode = data["workStationCode"];
        }
    }

    static fromJS(data: any): ShiftIndexRunningTimeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftIndexRunningTimeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runningTime"] = this.runningTime;
        data["workStationCode"] = this.workStationCode;
        return data; 
    }
}

export interface IShiftIndexRunningTimeVO {
    /** 运行时长 */
    runningTime: string | undefined;
    /** 工位编码 */
    workStationCode: string | undefined;
}

export class ShiftIndexStatusDurationProductVO implements IShiftIndexStatusDurationProductVO {
    /** 当前班次运行时长 */
    shiftIndex!: ShiftIndexRunningTimeVO[] | undefined;
    /** 工位当前加工产品 */
    workStationCurrentProduct!: { [key: string] : string; } | undefined;
    /** 工位当前状态持续时间 */
    workStationCurrentStatusDuration!: WorkStationCurrentStatusVO[] | undefined;

    constructor(data?: IShiftIndexStatusDurationProductVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["shiftIndex"] && data["shiftIndex"].constructor === Array) {
                this.shiftIndex = [] as any;
                for (let item of data["shiftIndex"])
                    this.shiftIndex!.push(ShiftIndexRunningTimeVO.fromJS(item));
            }
            if (data["workStationCurrentProduct"]) {
                this.workStationCurrentProduct = {} as any;
                for (let key in data["workStationCurrentProduct"]) {
                    if (data["workStationCurrentProduct"].hasOwnProperty(key))
                        this.workStationCurrentProduct![key] = data["workStationCurrentProduct"][key];
                }
            }
            if (data["workStationCurrentStatusDuration"] && data["workStationCurrentStatusDuration"].constructor === Array) {
                this.workStationCurrentStatusDuration = [] as any;
                for (let item of data["workStationCurrentStatusDuration"])
                    this.workStationCurrentStatusDuration!.push(WorkStationCurrentStatusVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftIndexStatusDurationProductVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftIndexStatusDurationProductVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.shiftIndex && this.shiftIndex.constructor === Array) {
            data["shiftIndex"] = [];
            for (let item of this.shiftIndex)
                data["shiftIndex"].push(item.toJSON());
        }
        if (this.workStationCurrentProduct) {
            data["workStationCurrentProduct"] = {};
            for (let key in this.workStationCurrentProduct) {
                if (this.workStationCurrentProduct.hasOwnProperty(key))
                    data["workStationCurrentProduct"][key] = this.workStationCurrentProduct[key];
            }
        }
        if (this.workStationCurrentStatusDuration && this.workStationCurrentStatusDuration.constructor === Array) {
            data["workStationCurrentStatusDuration"] = [];
            for (let item of this.workStationCurrentStatusDuration)
                data["workStationCurrentStatusDuration"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShiftIndexStatusDurationProductVO {
    /** 当前班次运行时长 */
    shiftIndex: ShiftIndexRunningTimeVO[] | undefined;
    /** 工位当前加工产品 */
    workStationCurrentProduct: { [key: string] : string; } | undefined;
    /** 工位当前状态持续时间 */
    workStationCurrentStatusDuration: WorkStationCurrentStatusVO[] | undefined;
}

export class ShiftOutputDataVO implements IShiftOutputDataVO {
    /** 设备的采集数量 */
    collectYield!: string[] | undefined;
    /** x轴 */
    deviceName!: string[] | undefined;
    /** 设备的报工数量 */
    reportNumber!: string[] | undefined;

    constructor(data?: IShiftOutputDataVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["collectYield"] && data["collectYield"].constructor === Array) {
                this.collectYield = [] as any;
                for (let item of data["collectYield"])
                    this.collectYield!.push(item);
            }
            if (data["deviceName"] && data["deviceName"].constructor === Array) {
                this.deviceName = [] as any;
                for (let item of data["deviceName"])
                    this.deviceName!.push(item);
            }
            if (data["reportNumber"] && data["reportNumber"].constructor === Array) {
                this.reportNumber = [] as any;
                for (let item of data["reportNumber"])
                    this.reportNumber!.push(item);
            }
        }
    }

    static fromJS(data: any): ShiftOutputDataVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOutputDataVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.collectYield && this.collectYield.constructor === Array) {
            data["collectYield"] = [];
            for (let item of this.collectYield)
                data["collectYield"].push(item);
        }
        if (this.deviceName && this.deviceName.constructor === Array) {
            data["deviceName"] = [];
            for (let item of this.deviceName)
                data["deviceName"].push(item);
        }
        if (this.reportNumber && this.reportNumber.constructor === Array) {
            data["reportNumber"] = [];
            for (let item of this.reportNumber)
                data["reportNumber"].push(item);
        }
        return data; 
    }
}

export interface IShiftOutputDataVO {
    /** 设备的采集数量 */
    collectYield: string[] | undefined;
    /** x轴 */
    deviceName: string[] | undefined;
    /** 设备的报工数量 */
    reportNumber: string[] | undefined;
}

export class ShiftOutputQueryDataSourceDTO implements IShiftOutputQueryDataSourceDTO {
    /** 1 单日 2 7天 */
    deviceShiftOutputType!: number | undefined;
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: IShiftOutputQueryDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceShiftOutputType = data["deviceShiftOutputType"];
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ShiftOutputQueryDataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOutputQueryDataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceShiftOutputType"] = this.deviceShiftOutputType;
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IShiftOutputQueryDataSourceDTO {
    /** 1 单日 2 7天 */
    deviceShiftOutputType: number | undefined;
    /** 工位id */
    workStationIdList: string[] | undefined;
}

export class ShiftOutputVO implements IShiftOutputVO {
    data!: number | undefined;
    name!: string | undefined;

    constructor(data?: IShiftOutputVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.data = data["data"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ShiftOutputVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOutputVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["name"] = this.name;
        return data; 
    }
}

export interface IShiftOutputVO {
    data: number | undefined;
    name: string | undefined;
}

export class ShiftStatisticRpsDTO implements IShiftStatisticRpsDTO {
    /** 数据 */
    data!: { [key: string] : number; } | undefined;
    /** 查询日期 */
    dateInfo!: string | undefined;
    /** 班次Id */
    shiftId!: string | undefined;
    /** 班次名称 */
    shiftName!: string | undefined;
    /** 工位Id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IShiftStatisticRpsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        this.data![key] = data["data"][key];
                }
            }
            this.dateInfo = data["dateInfo"];
            this.shiftId = data["shiftId"];
            this.shiftName = data["shiftName"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): ShiftStatisticRpsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftStatisticRpsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        data["dateInfo"] = this.dateInfo;
        data["shiftId"] = this.shiftId;
        data["shiftName"] = this.shiftName;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IShiftStatisticRpsDTO {
    /** 数据 */
    data: { [key: string] : number; } | undefined;
    /** 查询日期 */
    dateInfo: string | undefined;
    /** 班次Id */
    shiftId: string | undefined;
    /** 班次名称 */
    shiftName: string | undefined;
    /** 工位Id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class ShiftStatusStatisticByRpsVO implements IShiftStatusStatisticByRpsVO {
    /** 列信息 */
    columns!: ColumnInfoDTO[] | undefined;
    /** 数据 */
    items!: ShiftStatisticRpsDTO[] | undefined;

    constructor(data?: IShiftStatusStatisticByRpsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["columns"] && data["columns"].constructor === Array) {
                this.columns = [] as any;
                for (let item of data["columns"])
                    this.columns!.push(ColumnInfoDTO.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ShiftStatisticRpsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftStatusStatisticByRpsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftStatusStatisticByRpsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columns && this.columns.constructor === Array) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShiftStatusStatisticByRpsVO {
    /** 列信息 */
    columns: ColumnInfoDTO[] | undefined;
    /** 数据 */
    items: ShiftStatisticRpsDTO[] | undefined;
}

export class SplitFilterListVO implements ISplitFilterListVO {
    /** 分割后的条件列表 */
    items!: SplitFilterVO[] | undefined;

    constructor(data?: ISplitFilterListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SplitFilterVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SplitFilterListVO {
        data = typeof data === 'object' ? data : {};
        let result = new SplitFilterListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISplitFilterListVO {
    /** 分割后的条件列表 */
    items: SplitFilterVO[] | undefined;
}

export class SplitFilterVO implements ISplitFilterVO {
    /** code */
    code!: string | undefined;
    /** 日 */
    date!: string | undefined;
    /** 月 */
    month!: number | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: SplitFilterVOStatisticalMethod | undefined;
    /** 标题 */
    title!: string | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: ISplitFilterVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.date = data["date"];
            this.month = data["month"];
            this.shiftIndex = data["shiftIndex"];
            this.statisticalMethod = data["statisticalMethod"];
            this.title = data["title"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): SplitFilterVO {
        data = typeof data === 'object' ? data : {};
        let result = new SplitFilterVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["date"] = this.date;
        data["month"] = this.month;
        data["shiftIndex"] = this.shiftIndex;
        data["statisticalMethod"] = this.statisticalMethod;
        data["title"] = this.title;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface ISplitFilterVO {
    /** code */
    code: string | undefined;
    /** 日 */
    date: string | undefined;
    /** 月 */
    month: number | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: SplitFilterVOStatisticalMethod | undefined;
    /** 标题 */
    title: string | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

/** 统计月停机时长 */
export class StatisticMonthOutageTimeVO implements IStatisticMonthOutageTimeVO {
    /** 报警时长 */
    alarmTime!: number | undefined;
    /** 日期 */
    factoryDate!: string | undefined;
    /** 关机时长 */
    shutdownTime!: number | undefined;
    /** 待机时长 */
    standbyTime!: number | undefined;
    /** 合计时长 */
    sumTime!: number | undefined;

    constructor(data?: IStatisticMonthOutageTimeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alarmTime = data["alarmTime"];
            this.factoryDate = data["factoryDate"];
            this.shutdownTime = data["shutdownTime"];
            this.standbyTime = data["standbyTime"];
            this.sumTime = data["sumTime"];
        }
    }

    static fromJS(data: any): StatisticMonthOutageTimeVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticMonthOutageTimeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmTime"] = this.alarmTime;
        data["factoryDate"] = this.factoryDate;
        data["shutdownTime"] = this.shutdownTime;
        data["standbyTime"] = this.standbyTime;
        data["sumTime"] = this.sumTime;
        return data; 
    }
}

/** 统计月停机时长 */
export interface IStatisticMonthOutageTimeVO {
    /** 报警时长 */
    alarmTime: number | undefined;
    /** 日期 */
    factoryDate: string | undefined;
    /** 关机时长 */
    shutdownTime: number | undefined;
    /** 待机时长 */
    standbyTime: number | undefined;
    /** 合计时长 */
    sumTime: number | undefined;
}

export class StatusRecordCardVO implements IStatusRecordCardVO {
    /** 当前生产计划 */
    currentPlanCode!: string | undefined;
    /** 当前状态 */
    currentStatus!: string | undefined;
    /** 当前产量 */
    outputVolume!: string | undefined;
    /** 状态持续时间 */
    statusTime!: string | undefined;
    /** 工位编号 */
    workStationCode!: string | undefined;
    /** 工位Id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IStatusRecordCardVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPlanCode = data["currentPlanCode"];
            this.currentStatus = data["currentStatus"];
            this.outputVolume = data["outputVolume"];
            this.statusTime = data["statusTime"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): StatusRecordCardVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordCardVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPlanCode"] = this.currentPlanCode;
        data["currentStatus"] = this.currentStatus;
        data["outputVolume"] = this.outputVolume;
        data["statusTime"] = this.statusTime;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IStatusRecordCardVO {
    /** 当前生产计划 */
    currentPlanCode: string | undefined;
    /** 当前状态 */
    currentStatus: string | undefined;
    /** 当前产量 */
    outputVolume: string | undefined;
    /** 状态持续时间 */
    statusTime: string | undefined;
    /** 工位编号 */
    workStationCode: string | undefined;
    /** 工位Id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class StatusRecordDTO implements IStatusRecordDTO {
    /** 查询日期 */
    date!: Date | undefined;
    /** 持续时长 */
    duration!: number | undefined;
    /** 时间范围:结束时间，0点之后的偏移量(单位：秒) */
    end!: number | undefined;
    /** 状态：1、设备报警  4、设备等待 */
    iotStatus!: number[] | undefined;
    /** 时间范围:开始时间，0点之后的偏移量(单位：秒) */
    start!: number | undefined;
    /** 选中的工位信息 */
    workStationList!: KeyNameDTO[] | undefined;

    constructor(data?: IStatusRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.duration = data["duration"];
            this.end = data["end"];
            if (data["iotStatus"] && data["iotStatus"].constructor === Array) {
                this.iotStatus = [] as any;
                for (let item of data["iotStatus"])
                    this.iotStatus!.push(item);
            }
            this.start = data["start"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatusRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["duration"] = this.duration;
        data["end"] = this.end;
        if (this.iotStatus && this.iotStatus.constructor === Array) {
            data["iotStatus"] = [];
            for (let item of this.iotStatus)
                data["iotStatus"].push(item);
        }
        data["start"] = this.start;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStatusRecordDTO {
    /** 查询日期 */
    date: Date | undefined;
    /** 持续时长 */
    duration: number | undefined;
    /** 时间范围:结束时间，0点之后的偏移量(单位：秒) */
    end: number | undefined;
    /** 状态：1、设备报警  4、设备等待 */
    iotStatus: number[] | undefined;
    /** 时间范围:开始时间，0点之后的偏移量(单位：秒) */
    start: number | undefined;
    /** 选中的工位信息 */
    workStationList: KeyNameDTO[] | undefined;
}

export class StatusRecordGanttBO implements IStatusRecordGanttBO {
    /** 状态颜色 */
    color!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 状态值 */
    status!: string | undefined;

    constructor(data?: IStatusRecordGanttBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.color = data["color"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.status = data["status"];
        }
    }

    static fromJS(data: any): StatusRecordGanttBO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordGanttBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IStatusRecordGanttBO {
    /** 状态颜色 */
    color: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 状态值 */
    status: string | undefined;
}

export class StatusRecordGanttVO implements IStatusRecordGanttVO {
    /** 工位状态记录甘特图BO */
    statusRecordGanttBO!: StatusRecordGanttBO[] | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;
    xendTime!: Date | undefined;
    xstartTime!: Date | undefined;

    constructor(data?: IStatusRecordGanttVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["statusRecordGanttBO"] && data["statusRecordGanttBO"].constructor === Array) {
                this.statusRecordGanttBO = [] as any;
                for (let item of data["statusRecordGanttBO"])
                    this.statusRecordGanttBO!.push(StatusRecordGanttBO.fromJS(item));
            }
            this.workStationName = data["workStationName"];
            this.xendTime = data["xendTime"] ? new Date(data["xendTime"].toString()) : <any>undefined;
            this.xstartTime = data["xstartTime"] ? new Date(data["xstartTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusRecordGanttVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordGanttVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.statusRecordGanttBO && this.statusRecordGanttBO.constructor === Array) {
            data["statusRecordGanttBO"] = [];
            for (let item of this.statusRecordGanttBO)
                data["statusRecordGanttBO"].push(item.toJSON());
        }
        data["workStationName"] = this.workStationName;
        data["xendTime"] = this.xendTime ? this.xendTime.toISOString() : <any>undefined;
        data["xstartTime"] = this.xstartTime ? this.xstartTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStatusRecordGanttVO {
    /** 工位状态记录甘特图BO */
    statusRecordGanttBO: StatusRecordGanttBO[] | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
    xendTime: Date | undefined;
    xstartTime: Date | undefined;
}

export class StatusRecordItemVO implements IStatusRecordItemVO {
    /** 日期 */
    date!: string | undefined;
    /** 持续时长(分钟) */
    duration!: number | undefined;
    /** 开始时间，时间戳 */
    endTime!: Date | undefined;
    /** iot状态 */
    iotStatus!: string | undefined;
    /** 开始时间，时间戳 */
    startTime!: Date | undefined;
    /** 状态编号 */
    wcs!: string | undefined;

    constructor(data?: IStatusRecordItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.duration = data["duration"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.iotStatus = data["iotStatus"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.wcs = data["wcs"];
        }
    }

    static fromJS(data: any): StatusRecordItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["duration"] = this.duration;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["iotStatus"] = this.iotStatus;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["wcs"] = this.wcs;
        return data; 
    }
}

export interface IStatusRecordItemVO {
    /** 日期 */
    date: string | undefined;
    /** 持续时长(分钟) */
    duration: number | undefined;
    /** 开始时间，时间戳 */
    endTime: Date | undefined;
    /** iot状态 */
    iotStatus: string | undefined;
    /** 开始时间，时间戳 */
    startTime: Date | undefined;
    /** 状态编号 */
    wcs: string | undefined;
}

export class StatusRecordListVO implements IStatusRecordListVO {
    /** 采集状态信息 */
    collectStatusInfo!: CollectStatusVO[] | undefined;
    /** 状态记录列表 */
    items!: WorkStationStatusRecordVO[] | undefined;

    constructor(data?: IStatusRecordListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["collectStatusInfo"] && data["collectStatusInfo"].constructor === Array) {
                this.collectStatusInfo = [] as any;
                for (let item of data["collectStatusInfo"])
                    this.collectStatusInfo!.push(CollectStatusVO.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(WorkStationStatusRecordVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatusRecordListVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.collectStatusInfo && this.collectStatusInfo.constructor === Array) {
            data["collectStatusInfo"] = [];
            for (let item of this.collectStatusInfo)
                data["collectStatusInfo"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStatusRecordListVO {
    /** 采集状态信息 */
    collectStatusInfo: CollectStatusVO[] | undefined;
    /** 状态记录列表 */
    items: WorkStationStatusRecordVO[] | undefined;
}

export class StatusRecordPieVO implements IStatusRecordPieVO {
    /** 状态颜色 */
    color!: string | undefined;
    /** 状态名 */
    name!: string | undefined;
    /** 状态值 */
    value!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IStatusRecordPieVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.color = data["color"];
            this.name = data["name"];
            this.value = data["value"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): StatusRecordPieVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordPieVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["name"] = this.name;
        data["value"] = this.value;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IStatusRecordPieVO {
    /** 状态颜色 */
    color: string | undefined;
    /** 状态名 */
    name: string | undefined;
    /** 状态值 */
    value: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class StatusRecordPieWorkStationIdsDTO implements IStatusRecordPieWorkStationIdsDTO {
    /** 工位id集合 */
    workStationIds!: string[] | undefined;

    constructor(data?: IStatusRecordPieWorkStationIdsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["workStationIds"] && data["workStationIds"].constructor === Array) {
                this.workStationIds = [] as any;
                for (let item of data["workStationIds"])
                    this.workStationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): StatusRecordPieWorkStationIdsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordPieWorkStationIdsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.workStationIds && this.workStationIds.constructor === Array) {
            data["workStationIds"] = [];
            for (let item of this.workStationIds)
                data["workStationIds"].push(item);
        }
        return data; 
    }
}

export interface IStatusRecordPieWorkStationIdsDTO {
    /** 工位id集合 */
    workStationIds: string[] | undefined;
}

export class StatusRecordVO implements IStatusRecordVO {
    /** 采集状态信息 */
    collectStatusInfo!: CollectStatusVO[] | undefined;
    /** 状态记录列表 */
    items!: IPageOfWorkStationStatusRecordVO | undefined;

    constructor(data?: IStatusRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["collectStatusInfo"] && data["collectStatusInfo"].constructor === Array) {
                this.collectStatusInfo = [] as any;
                for (let item of data["collectStatusInfo"])
                    this.collectStatusInfo!.push(CollectStatusVO.fromJS(item));
            }
            this.items = data["items"] ? IPageOfWorkStationStatusRecordVO.fromJS(data["items"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.collectStatusInfo && this.collectStatusInfo.constructor === Array) {
            data["collectStatusInfo"] = [];
            for (let item of this.collectStatusInfo)
                data["collectStatusInfo"].push(item.toJSON());
        }
        data["items"] = this.items ? this.items.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IStatusRecordVO {
    /** 采集状态信息 */
    collectStatusInfo: CollectStatusVO[] | undefined;
    /** 状态记录列表 */
    items: IPageOfWorkStationStatusRecordVO | undefined;
}

/** 状态时长TOP */
export class StatusTimeTopVO implements IStatusTimeTopVO {
    /** 状态时长 */
    value!: number | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IStatusTimeTopVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): StatusTimeTopVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusTimeTopVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

/** 状态时长TOP */
export interface IStatusTimeTopVO {
    /** 状态时长 */
    value: number | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

/** 设备状态运行时长 */
export class StatusTimeVO implements IStatusTimeVO {
    /** 平均运行时长 */
    averageRunningTime!: number | undefined;
    /** 所有设备各状态运行时间总和，key分别是：【设备运行、设备等待、设备报警、设备离线、未知状态】 */
    eachStatusTime!: { [key: string] : number; } | undefined;

    constructor(data?: IStatusTimeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.averageRunningTime = data["averageRunningTime"];
            if (data["eachStatusTime"]) {
                this.eachStatusTime = {} as any;
                for (let key in data["eachStatusTime"]) {
                    if (data["eachStatusTime"].hasOwnProperty(key))
                        this.eachStatusTime![key] = data["eachStatusTime"][key];
                }
            }
        }
    }

    static fromJS(data: any): StatusTimeVO {
        data = typeof data === 'object' ? data : {};
        let result = new StatusTimeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageRunningTime"] = this.averageRunningTime;
        if (this.eachStatusTime) {
            data["eachStatusTime"] = {};
            for (let key in this.eachStatusTime) {
                if (this.eachStatusTime.hasOwnProperty(key))
                    data["eachStatusTime"][key] = this.eachStatusTime[key];
            }
        }
        return data; 
    }
}

/** 设备状态运行时长 */
export interface IStatusTimeVO {
    /** 平均运行时长 */
    averageRunningTime: number | undefined;
    /** 所有设备各状态运行时间总和，key分别是：【设备运行、设备等待、设备报警、设备离线、未知状态】 */
    eachStatusTime: { [key: string] : number; } | undefined;
}

export class TimeAnalysisDTO implements ITimeAnalysisDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: TimeAnalysisDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: ITimeAnalysisDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): TimeAnalysisDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAnalysisDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["month"] = this.month;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface ITimeAnalysisDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: TimeAnalysisDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class TimeAnalysisQueryDTO implements ITimeAnalysisQueryDTO {
    /** 日期 */
    date!: Date | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: number | undefined;
    /** 租户 */
    tenantId!: string | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;

    constructor(data?: ITimeAnalysisQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.shiftIndex = data["shiftIndex"];
            this.statisticalMethod = data["statisticalMethod"];
            this.tenantId = data["tenantId"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeAnalysisQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAnalysisQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["shiftIndex"] = this.shiftIndex;
        data["statisticalMethod"] = this.statisticalMethod;
        data["tenantId"] = this.tenantId;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITimeAnalysisQueryDTO {
    /** 日期 */
    date: Date | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: number | undefined;
    /** 租户 */
    tenantId: string | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
}

export class TimeAnalysisVO implements ITimeAnalysisVO {
    /** 工位用时列表 */
    items!: WorkStationTimeVO[] | undefined;

    constructor(data?: ITimeAnalysisVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(WorkStationTimeVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeAnalysisVO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAnalysisVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITimeAnalysisVO {
    /** 工位用时列表 */
    items: WorkStationTimeVO[] | undefined;
}

export class TimeAnalysisWcsExcelDTO implements ITimeAnalysisWcsExcelDTO {
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次, DAY--日, WEEK--周, MONTH--月 */
    statisticalMethod!: TimeAnalysisWcsExcelDTOStatisticalMethod | undefined;
    /** 选中的工位 id-name */
    workStationList!: KeyNameDTO[] | undefined;

    constructor(data?: ITimeAnalysisWcsExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeAnalysisWcsExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAnalysisWcsExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITimeAnalysisWcsExcelDTO {
    /** 结束时间 */
    endDate: Date | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次, DAY--日, WEEK--周, MONTH--月 */
    statisticalMethod: TimeAnalysisWcsExcelDTOStatisticalMethod | undefined;
    /** 选中的工位 id-name */
    workStationList: KeyNameDTO[] | undefined;
}

export class TimeProductOutputInfoVO implements ITimeProductOutputInfoVO {
    /** 标准产能 */
    capacity!: string | undefined;
    /** 颜色 */
    colour!: string | undefined;
    /** 班次名称 */
    indexName!: string | undefined;
    /** 产量 */
    output!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;

    constructor(data?: ITimeProductOutputInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.capacity = data["capacity"];
            this.colour = data["colour"];
            this.indexName = data["indexName"];
            this.output = data["output"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): TimeProductOutputInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeProductOutputInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capacity"] = this.capacity;
        data["colour"] = this.colour;
        data["indexName"] = this.indexName;
        data["output"] = this.output;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface ITimeProductOutputInfoVO {
    /** 标准产能 */
    capacity: string | undefined;
    /** 颜色 */
    colour: string | undefined;
    /** 班次名称 */
    indexName: string | undefined;
    /** 产量 */
    output: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
}

export class TimeSlotDTO implements ITimeSlotDTO {
    /** 当前选中的日期 */
    date!: string | undefined;
    /** 选中的班次编号 */
    shiftIndex!: number | undefined;
    /** 工位id */
    workStationId!: string | undefined;

    constructor(data?: ITimeSlotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.shiftIndex = data["shiftIndex"];
            this.workStationId = data["workStationId"];
        }
    }

    static fromJS(data: any): TimeSlotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSlotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["shiftIndex"] = this.shiftIndex;
        data["workStationId"] = this.workStationId;
        return data; 
    }
}

export interface ITimeSlotDTO {
    /** 当前选中的日期 */
    date: string | undefined;
    /** 选中的班次编号 */
    shiftIndex: number | undefined;
    /** 工位id */
    workStationId: string | undefined;
}

export class TopBarDataVO implements ITopBarDataVO {
    /** 数值 */
    value!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: ITopBarDataVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): TopBarDataVO {
        data = typeof data === 'object' ? data : {};
        let result = new TopBarDataVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface ITopBarDataVO {
    /** 数值 */
    value: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class TopQueryDataSourceDTO implements ITopQueryDataSourceDTO {
    /** top值1,3,5,7,10,15,30 */
    top!: number | undefined;
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: ITopQueryDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.top = data["top"];
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): TopQueryDataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TopQueryDataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["top"] = this.top;
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface ITopQueryDataSourceDTO {
    /** top值1,3,5,7,10,15,30 */
    top: number | undefined;
    /** 工位id */
    workStationIdList: string[] | undefined;
}

export class WeeklyEfficiencyDataExcelDTO implements IWeeklyEfficiencyDataExcelDTO {
    /** 客户列表 */
    customerIdList!: string[] | undefined;
    /** 设备类型列表 */
    deviceTypeIdList!: string[] | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 所选中的稼动率 */
    idList!: string[] | undefined;
    /** 排序字段 */
    sortField!: string | undefined;
    /** 排序方式 */
    sortOrder!: string | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 变化阈值 */
    threshold!: number | undefined;

    constructor(data?: IWeeklyEfficiencyDataExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerIdList"] && data["customerIdList"].constructor === Array) {
                this.customerIdList = [] as any;
                for (let item of data["customerIdList"])
                    this.customerIdList!.push(item);
            }
            if (data["deviceTypeIdList"] && data["deviceTypeIdList"].constructor === Array) {
                this.deviceTypeIdList = [] as any;
                for (let item of data["deviceTypeIdList"])
                    this.deviceTypeIdList!.push(item);
            }
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [] as any;
                for (let item of data["idList"])
                    this.idList!.push(item);
            }
            this.sortField = data["sortField"];
            this.sortOrder = data["sortOrder"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.threshold = data["threshold"];
        }
    }

    static fromJS(data: any): WeeklyEfficiencyDataExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyEfficiencyDataExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerIdList && this.customerIdList.constructor === Array) {
            data["customerIdList"] = [];
            for (let item of this.customerIdList)
                data["customerIdList"].push(item);
        }
        if (this.deviceTypeIdList && this.deviceTypeIdList.constructor === Array) {
            data["deviceTypeIdList"] = [];
            for (let item of this.deviceTypeIdList)
                data["deviceTypeIdList"].push(item);
        }
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["threshold"] = this.threshold;
        return data; 
    }
}

export interface IWeeklyEfficiencyDataExcelDTO {
    /** 客户列表 */
    customerIdList: string[] | undefined;
    /** 设备类型列表 */
    deviceTypeIdList: string[] | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 所选中的稼动率 */
    idList: string[] | undefined;
    /** 排序字段 */
    sortField: string | undefined;
    /** 排序方式 */
    sortOrder: string | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 变化阈值 */
    threshold: number | undefined;
}

export class WeeklyEfficiencyDataQueryDTO implements IWeeklyEfficiencyDataQueryDTO {
    /** 客户列表 */
    customerIdList!: string[] | undefined;
    /** 设备类型列表 */
    deviceTypeIdList!: string[] | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 排序字段 */
    sortField!: string | undefined;
    /** 排序方式 */
    sortOrder!: string | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 变化阈值 */
    threshold!: number | undefined;

    constructor(data?: IWeeklyEfficiencyDataQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["customerIdList"] && data["customerIdList"].constructor === Array) {
                this.customerIdList = [] as any;
                for (let item of data["customerIdList"])
                    this.customerIdList!.push(item);
            }
            if (data["deviceTypeIdList"] && data["deviceTypeIdList"].constructor === Array) {
                this.deviceTypeIdList = [] as any;
                for (let item of data["deviceTypeIdList"])
                    this.deviceTypeIdList!.push(item);
            }
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.sortField = data["sortField"];
            this.sortOrder = data["sortOrder"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.threshold = data["threshold"];
        }
    }

    static fromJS(data: any): WeeklyEfficiencyDataQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyEfficiencyDataQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customerIdList && this.customerIdList.constructor === Array) {
            data["customerIdList"] = [];
            for (let item of this.customerIdList)
                data["customerIdList"].push(item);
        }
        if (this.deviceTypeIdList && this.deviceTypeIdList.constructor === Array) {
            data["deviceTypeIdList"] = [];
            for (let item of this.deviceTypeIdList)
                data["deviceTypeIdList"].push(item);
        }
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["threshold"] = this.threshold;
        return data; 
    }
}

export interface IWeeklyEfficiencyDataQueryDTO {
    /** 客户列表 */
    customerIdList: string[] | undefined;
    /** 设备类型列表 */
    deviceTypeIdList: string[] | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 排序字段 */
    sortField: string | undefined;
    /** 排序方式 */
    sortOrder: string | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 变化阈值 */
    threshold: number | undefined;
}

export class WeeklyEfficiencyVO implements IWeeklyEfficiencyVO {
    /** 所属客户 */
    customerName!: string | undefined;
    /** 设备类型 */
    deviceTypeName!: string | undefined;
    /** 动态区间稼动率 */
    dynamicPeriodValue!: number | undefined;
    id!: string | undefined;
    /** 上上周稼动率 */
    last2rdPeriodValue!: number | undefined;
    /** 上周稼动率 */
    lastPeriodValue!: number | undefined;
    /** 近两周变化值 */
    nearly2WeeksPeriodValue!: number | undefined;
    /** 软件版本 */
    softwareVersion!: string | undefined;
    /** 设备编号 */
    workStationCode!: string | undefined;

    constructor(data?: IWeeklyEfficiencyVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.deviceTypeName = data["deviceTypeName"];
            this.dynamicPeriodValue = data["dynamicPeriodValue"];
            this.id = data["id"];
            this.last2rdPeriodValue = data["last2rdPeriodValue"];
            this.lastPeriodValue = data["lastPeriodValue"];
            this.nearly2WeeksPeriodValue = data["nearly2WeeksPeriodValue"];
            this.softwareVersion = data["softwareVersion"];
            this.workStationCode = data["workStationCode"];
        }
    }

    static fromJS(data: any): WeeklyEfficiencyVO {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyEfficiencyVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["deviceTypeName"] = this.deviceTypeName;
        data["dynamicPeriodValue"] = this.dynamicPeriodValue;
        data["id"] = this.id;
        data["last2rdPeriodValue"] = this.last2rdPeriodValue;
        data["lastPeriodValue"] = this.lastPeriodValue;
        data["nearly2WeeksPeriodValue"] = this.nearly2WeeksPeriodValue;
        data["softwareVersion"] = this.softwareVersion;
        data["workStationCode"] = this.workStationCode;
        return data; 
    }
}

export interface IWeeklyEfficiencyVO {
    /** 所属客户 */
    customerName: string | undefined;
    /** 设备类型 */
    deviceTypeName: string | undefined;
    /** 动态区间稼动率 */
    dynamicPeriodValue: number | undefined;
    id: string | undefined;
    /** 上上周稼动率 */
    last2rdPeriodValue: number | undefined;
    /** 上周稼动率 */
    lastPeriodValue: number | undefined;
    /** 近两周变化值 */
    nearly2WeeksPeriodValue: number | undefined;
    /** 软件版本 */
    softwareVersion: string | undefined;
    /** 设备编号 */
    workStationCode: string | undefined;
}

export class WorkStationAlarmInfoVO implements IWorkStationAlarmInfoVO {
    /** 报警总量 */
    value!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationAlarmInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationAlarmInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationAlarmInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationAlarmInfoVO {
    /** 报警总量 */
    value: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class WorkStationAlarmVO implements IWorkStationAlarmVO {
    /** 报警统计信息列表 */
    alarmInfoList!: AlarmInfoVO[] | undefined;
    /** 工位信息 */
    workStation!: WorkStationInfoVO | undefined;

    constructor(data?: IWorkStationAlarmVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["alarmInfoList"] && data["alarmInfoList"].constructor === Array) {
                this.alarmInfoList = [] as any;
                for (let item of data["alarmInfoList"])
                    this.alarmInfoList!.push(AlarmInfoVO.fromJS(item));
            }
            this.workStation = data["workStation"] ? WorkStationInfoVO.fromJS(data["workStation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkStationAlarmVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationAlarmVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.alarmInfoList && this.alarmInfoList.constructor === Array) {
            data["alarmInfoList"] = [];
            for (let item of this.alarmInfoList)
                data["alarmInfoList"].push(item.toJSON());
        }
        data["workStation"] = this.workStation ? this.workStation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWorkStationAlarmVO {
    /** 报警统计信息列表 */
    alarmInfoList: AlarmInfoVO[] | undefined;
    /** 工位信息 */
    workStation: WorkStationInfoVO | undefined;
}

export class WorkStationCodesDTO implements IWorkStationCodesDTO {
    tenantId!: string | undefined;
    workStationCodeList!: string[] | undefined;

    constructor(data?: IWorkStationCodesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            if (data["workStationCodeList"] && data["workStationCodeList"].constructor === Array) {
                this.workStationCodeList = [] as any;
                for (let item of data["workStationCodeList"])
                    this.workStationCodeList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationCodesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationCodesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (this.workStationCodeList && this.workStationCodeList.constructor === Array) {
            data["workStationCodeList"] = [];
            for (let item of this.workStationCodeList)
                data["workStationCodeList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationCodesDTO {
    tenantId: string | undefined;
    workStationCodeList: string[] | undefined;
}

export class WorkStationConditionStatusDTO implements IWorkStationConditionStatusDTO {
    /** 对应颜色 */
    color!: string | undefined;
    /** wcs */
    rps!: number | undefined;
    /** wcs */
    wcs!: number | undefined;
    /** wcs名字 */
    wcsName!: string | undefined;

    constructor(data?: IWorkStationConditionStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.color = data["color"];
            this.rps = data["rps"];
            this.wcs = data["wcs"];
            this.wcsName = data["wcsName"];
        }
    }

    static fromJS(data: any): WorkStationConditionStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationConditionStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["rps"] = this.rps;
        data["wcs"] = this.wcs;
        data["wcsName"] = this.wcsName;
        return data; 
    }
}

export interface IWorkStationConditionStatusDTO {
    /** 对应颜色 */
    color: string | undefined;
    /** wcs */
    rps: number | undefined;
    /** wcs */
    wcs: number | undefined;
    /** wcs名字 */
    wcsName: string | undefined;
}

export class WorkStationCurrentStatusVO implements IWorkStationCurrentStatusVO {
    /** 当前状态 */
    currentStatus!: string | undefined;
    /** 持续时长 单位：s */
    runningTimes!: string | undefined;
    /** 设备名称 */
    workStationName!: string | undefined;
    /** 设备code */
    workstationCode!: string | undefined;
    /** 设备id */
    workstationId!: string | undefined;

    constructor(data?: IWorkStationCurrentStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentStatus = data["currentStatus"];
            this.runningTimes = data["runningTimes"];
            this.workStationName = data["workStationName"];
            this.workstationCode = data["workstationCode"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkStationCurrentStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationCurrentStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStatus"] = this.currentStatus;
        data["runningTimes"] = this.runningTimes;
        data["workStationName"] = this.workStationName;
        data["workstationCode"] = this.workstationCode;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkStationCurrentStatusVO {
    /** 当前状态 */
    currentStatus: string | undefined;
    /** 持续时长 单位：s */
    runningTimes: string | undefined;
    /** 设备名称 */
    workStationName: string | undefined;
    /** 设备code */
    workstationCode: string | undefined;
    /** 设备id */
    workstationId: string | undefined;
}

export class WorkStationEfficiencyCheckDTO implements IWorkStationEfficiencyCheckDTO {
    /** 员工id */
    employeeId!: string | undefined;
    /** 设备id */
    workstationId!: string | undefined;

    constructor(data?: IWorkStationEfficiencyCheckDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.employeeId = data["employeeId"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkStationEfficiencyCheckDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationEfficiencyCheckDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkStationEfficiencyCheckDTO {
    /** 员工id */
    employeeId: string | undefined;
    /** 设备id */
    workstationId: string | undefined;
}

export class WorkStationEfficiencyLoginDTO implements IWorkStationEfficiencyLoginDTO {
    /** 员工code */
    employeeCode!: string | undefined;
    /** 员工id */
    employeeId!: string | undefined;
    /** 员工姓名 */
    employeeName!: string | undefined;
    /** 登入产量 */
    loginInYield!: number | undefined;
    /** 班次 */
    shiftIndex!: number | undefined;
    /** 班次名 */
    shiftIndexName!: string | undefined;
    /** 租户 */
    tenantId!: string | undefined;
    /** 设备名称 */
    workStationName!: string | undefined;
    /** 设备code */
    workstationCode!: string | undefined;
    /** 设备id */
    workstationId!: string | undefined;

    constructor(data?: IWorkStationEfficiencyLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.employeeCode = data["employeeCode"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
            this.loginInYield = data["loginInYield"];
            this.shiftIndex = data["shiftIndex"];
            this.shiftIndexName = data["shiftIndexName"];
            this.tenantId = data["tenantId"];
            this.workStationName = data["workStationName"];
            this.workstationCode = data["workstationCode"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkStationEfficiencyLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationEfficiencyLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["loginInYield"] = this.loginInYield;
        data["shiftIndex"] = this.shiftIndex;
        data["shiftIndexName"] = this.shiftIndexName;
        data["tenantId"] = this.tenantId;
        data["workStationName"] = this.workStationName;
        data["workstationCode"] = this.workstationCode;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkStationEfficiencyLoginDTO {
    /** 员工code */
    employeeCode: string | undefined;
    /** 员工id */
    employeeId: string | undefined;
    /** 员工姓名 */
    employeeName: string | undefined;
    /** 登入产量 */
    loginInYield: number | undefined;
    /** 班次 */
    shiftIndex: number | undefined;
    /** 班次名 */
    shiftIndexName: string | undefined;
    /** 租户 */
    tenantId: string | undefined;
    /** 设备名称 */
    workStationName: string | undefined;
    /** 设备code */
    workstationCode: string | undefined;
    /** 设备id */
    workstationId: string | undefined;
}

export class WorkStationEfficiencyLoginVO implements IWorkStationEfficiencyLoginVO {
    /** 记录的id */
    id!: string | undefined;
    /** 是否 存在没有登出的记录，false 不存在  true 存在 */
    isExist!: boolean | undefined;
    /** 初始产量 */
    loginInYield!: number | undefined;

    constructor(data?: IWorkStationEfficiencyLoginVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isExist = data["isExist"];
            this.loginInYield = data["loginInYield"];
        }
    }

    static fromJS(data: any): WorkStationEfficiencyLoginVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationEfficiencyLoginVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isExist"] = this.isExist;
        data["loginInYield"] = this.loginInYield;
        return data; 
    }
}

export interface IWorkStationEfficiencyLoginVO {
    /** 记录的id */
    id: string | undefined;
    /** 是否 存在没有登出的记录，false 不存在  true 存在 */
    isExist: boolean | undefined;
    /** 初始产量 */
    loginInYield: number | undefined;
}

export class WorkStationEfficiencyLogoutDTO implements IWorkStationEfficiencyLogoutDTO {
    /** 登录记录id */
    id!: string | undefined;
    /** 登出产量 */
    loginOutYield!: number | undefined;
    /** 填报数量 */
    reportNum!: number | undefined;

    constructor(data?: IWorkStationEfficiencyLogoutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.loginOutYield = data["loginOutYield"];
            this.reportNum = data["reportNum"];
        }
    }

    static fromJS(data: any): WorkStationEfficiencyLogoutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationEfficiencyLogoutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["loginOutYield"] = this.loginOutYield;
        data["reportNum"] = this.reportNum;
        return data; 
    }
}

export interface IWorkStationEfficiencyLogoutDTO {
    /** 登录记录id */
    id: string | undefined;
    /** 登出产量 */
    loginOutYield: number | undefined;
    /** 填报数量 */
    reportNum: number | undefined;
}

export class WorkStationEfficiencySearchDTO implements IWorkStationEfficiencySearchDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: string | undefined;
    /** 月 */
    month!: number | undefined;
    /** 开始时间 */
    startDate!: string | undefined;
    /** 统计方式:DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: WorkStationEfficiencySearchDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IWorkStationEfficiencySearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"];
            this.month = data["month"];
            this.startDate = data["startDate"];
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): WorkStationEfficiencySearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationEfficiencySearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["endDate"] = this.endDate;
        data["month"] = this.month;
        data["startDate"] = this.startDate;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IWorkStationEfficiencySearchDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: string | undefined;
    /** 月 */
    month: number | undefined;
    /** 开始时间 */
    startDate: string | undefined;
    /** 统计方式:DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: WorkStationEfficiencySearchDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class WorkStationEfficiencyVO implements IWorkStationEfficiencyVO {
    /** 平均运行时长 */
    avgYield!: number | undefined;
    /** 加工效率 */
    efficiency!: number | undefined;
    /** 员工code */
    employeeCode!: string | undefined;
    /** 员工id */
    employeeId!: string | undefined;
    /** 员工姓名 */
    employeeName!: string | undefined;
    /** 记录的id */
    id!: string | undefined;
    /** 上工时间 */
    loginInTime!: Date | undefined;
    /** 下工时间 */
    loginOutTime!: Date | undefined;
    /** 登入状态：0 登入  1 登出 */
    loginStatus!: number | undefined;
    /** 产量 */
    poorYield!: number | undefined;
    /** 运行时长  单位：小时 */
    runningTime!: number | undefined;
    /** 班次 */
    shiftIndex!: number | undefined;
    /** 设备名称 */
    workStationName!: string | undefined;
    /** 上工时长：登出时间-登入时间 */
    workingHours!: number | undefined;
    /** 设备code */
    workstationCode!: string | undefined;
    /** 设备id */
    workstationId!: string | undefined;
    /** 产品倍率 */
    yieldRatio!: number | undefined;

    constructor(data?: IWorkStationEfficiencyVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avgYield = data["avgYield"];
            this.efficiency = data["efficiency"];
            this.employeeCode = data["employeeCode"];
            this.employeeId = data["employeeId"];
            this.employeeName = data["employeeName"];
            this.id = data["id"];
            this.loginInTime = data["loginInTime"] ? new Date(data["loginInTime"].toString()) : <any>undefined;
            this.loginOutTime = data["loginOutTime"] ? new Date(data["loginOutTime"].toString()) : <any>undefined;
            this.loginStatus = data["loginStatus"];
            this.poorYield = data["poorYield"];
            this.runningTime = data["runningTime"];
            this.shiftIndex = data["shiftIndex"];
            this.workStationName = data["workStationName"];
            this.workingHours = data["workingHours"];
            this.workstationCode = data["workstationCode"];
            this.workstationId = data["workstationId"];
            this.yieldRatio = data["yieldRatio"];
        }
    }

    static fromJS(data: any): WorkStationEfficiencyVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationEfficiencyVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avgYield"] = this.avgYield;
        data["efficiency"] = this.efficiency;
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["id"] = this.id;
        data["loginInTime"] = this.loginInTime ? this.loginInTime.toISOString() : <any>undefined;
        data["loginOutTime"] = this.loginOutTime ? this.loginOutTime.toISOString() : <any>undefined;
        data["loginStatus"] = this.loginStatus;
        data["poorYield"] = this.poorYield;
        data["runningTime"] = this.runningTime;
        data["shiftIndex"] = this.shiftIndex;
        data["workStationName"] = this.workStationName;
        data["workingHours"] = this.workingHours;
        data["workstationCode"] = this.workstationCode;
        data["workstationId"] = this.workstationId;
        data["yieldRatio"] = this.yieldRatio;
        return data; 
    }
}

export interface IWorkStationEfficiencyVO {
    /** 平均运行时长 */
    avgYield: number | undefined;
    /** 加工效率 */
    efficiency: number | undefined;
    /** 员工code */
    employeeCode: string | undefined;
    /** 员工id */
    employeeId: string | undefined;
    /** 员工姓名 */
    employeeName: string | undefined;
    /** 记录的id */
    id: string | undefined;
    /** 上工时间 */
    loginInTime: Date | undefined;
    /** 下工时间 */
    loginOutTime: Date | undefined;
    /** 登入状态：0 登入  1 登出 */
    loginStatus: number | undefined;
    /** 产量 */
    poorYield: number | undefined;
    /** 运行时长  单位：小时 */
    runningTime: number | undefined;
    /** 班次 */
    shiftIndex: number | undefined;
    /** 设备名称 */
    workStationName: string | undefined;
    /** 上工时长：登出时间-登入时间 */
    workingHours: number | undefined;
    /** 设备code */
    workstationCode: string | undefined;
    /** 设备id */
    workstationId: string | undefined;
    /** 产品倍率 */
    yieldRatio: number | undefined;
}

export class WorkStationElectricityVO implements IWorkStationElectricityVO {
    /** 数据 */
    data!: { [key: string] : number; } | undefined;
    /** 工位信息 */
    workStation!: WorkStationInfoVO | undefined;

    constructor(data?: IWorkStationElectricityVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        this.data![key] = data["data"][key];
                }
            }
            this.workStation = data["workStation"] ? WorkStationInfoVO.fromJS(data["workStation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkStationElectricityVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationElectricityVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        data["workStation"] = this.workStation ? this.workStation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWorkStationElectricityVO {
    /** 数据 */
    data: { [key: string] : number; } | undefined;
    /** 工位信息 */
    workStation: WorkStationInfoVO | undefined;
}

export class WorkStationIdListDTO implements IWorkStationIdListDTO {
    /** 工位id集合 */
    workStationIdList!: string[] | undefined;

    constructor(data?: IWorkStationIdListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationIdListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationIdListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationIdListDTO {
    /** 工位id集合 */
    workStationIdList: string[] | undefined;
}

export class WorkStationInfoVO implements IWorkStationInfoVO {
    /** 序列号 */
    serialNo!: string | undefined;
    /** 工位编码 */
    workStationCode!: string | undefined;
    /** 工位Id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serialNo = data["serialNo"];
            this.workStationCode = data["workStationCode"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNo"] = this.serialNo;
        data["workStationCode"] = this.workStationCode;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationInfoVO {
    /** 序列号 */
    serialNo: string | undefined;
    /** 工位编码 */
    workStationCode: string | undefined;
    /** 工位Id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class WorkStationLoginDetailDTO implements IWorkStationLoginDetailDTO {
    /** 人员编码 */
    employeeCode!: string | undefined;
    /** 人员id */
    employeeId!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 人员id */
    workstationId!: string | undefined;

    constructor(data?: IWorkStationLoginDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.employeeCode = data["employeeCode"];
            this.employeeId = data["employeeId"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkStationLoginDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationLoginDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkStationLoginDetailDTO {
    /** 人员编码 */
    employeeCode: string | undefined;
    /** 人员id */
    employeeId: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 人员id */
    workstationId: string | undefined;
}

export class WorkStationLoginDetailVO implements IWorkStationLoginDetailVO {
    /** 平均运行时长 */
    avgYield!: string | undefined;
    /** 加工效率 */
    efficiency!: number | undefined;
    /** 人员 */
    employeeName!: string | undefined;
    /** 上工时间 */
    loginTime!: Date | undefined;
    /** 上工时间 */
    logoutTime!: Date | undefined;
    /** 填报数量 */
    reportNum!: number | undefined;
    /** 运行时长 */
    runningTime!: string | undefined;
    /** 运行时长  单位：小时 */
    runningTime1!: number | undefined;
    /** 班次 */
    shiftIndexName!: string | undefined;
    /** 序号 */
    sort!: number | undefined;
    /** 上工时长：登出时间-登入时间 */
    workingHours!: string | undefined;
    /** 上工时长：登出时间-登入时间 单位：小时 */
    workingHours1!: number | undefined;
    /** 产量 */
    yield!: number | undefined;

    constructor(data?: IWorkStationLoginDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avgYield = data["avgYield"];
            this.efficiency = data["efficiency"];
            this.employeeName = data["employeeName"];
            this.loginTime = data["loginTime"] ? new Date(data["loginTime"].toString()) : <any>undefined;
            this.logoutTime = data["logoutTime"] ? new Date(data["logoutTime"].toString()) : <any>undefined;
            this.reportNum = data["reportNum"];
            this.runningTime = data["runningTime"];
            this.runningTime1 = data["runningTime1"];
            this.shiftIndexName = data["shiftIndexName"];
            this.sort = data["sort"];
            this.workingHours = data["workingHours"];
            this.workingHours1 = data["workingHours1"];
            this.yield = data["yield"];
        }
    }

    static fromJS(data: any): WorkStationLoginDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationLoginDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avgYield"] = this.avgYield;
        data["efficiency"] = this.efficiency;
        data["employeeName"] = this.employeeName;
        data["loginTime"] = this.loginTime ? this.loginTime.toISOString() : <any>undefined;
        data["logoutTime"] = this.logoutTime ? this.logoutTime.toISOString() : <any>undefined;
        data["reportNum"] = this.reportNum;
        data["runningTime"] = this.runningTime;
        data["runningTime1"] = this.runningTime1;
        data["shiftIndexName"] = this.shiftIndexName;
        data["sort"] = this.sort;
        data["workingHours"] = this.workingHours;
        data["workingHours1"] = this.workingHours1;
        data["yield"] = this.yield;
        return data; 
    }
}

export interface IWorkStationLoginDetailVO {
    /** 平均运行时长 */
    avgYield: string | undefined;
    /** 加工效率 */
    efficiency: number | undefined;
    /** 人员 */
    employeeName: string | undefined;
    /** 上工时间 */
    loginTime: Date | undefined;
    /** 上工时间 */
    logoutTime: Date | undefined;
    /** 填报数量 */
    reportNum: number | undefined;
    /** 运行时长 */
    runningTime: string | undefined;
    /** 运行时长  单位：小时 */
    runningTime1: number | undefined;
    /** 班次 */
    shiftIndexName: string | undefined;
    /** 序号 */
    sort: number | undefined;
    /** 上工时长：登出时间-登入时间 */
    workingHours: string | undefined;
    /** 上工时长：登出时间-登入时间 单位：小时 */
    workingHours1: number | undefined;
    /** 产量 */
    yield: number | undefined;
}

export class WorkStationOeeBarBO implements IWorkStationOeeBarBO {
    /** 数据 */
    data!: string[] | undefined;
    /** 图例 */
    name!: string | undefined;

    constructor(data?: IWorkStationOeeBarBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(item);
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): WorkStationOeeBarBO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOeeBarBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IWorkStationOeeBarBO {
    /** 数据 */
    data: string[] | undefined;
    /** 图例 */
    name: string | undefined;
}

export class WorkStationOeeBarVO implements IWorkStationOeeBarVO {
    /** 横坐标 */
    categories!: string[] | undefined;
    /** 数据列表 */
    series!: WorkStationOeeBarBO[] | undefined;

    constructor(data?: IWorkStationOeeBarVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(WorkStationOeeBarBO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStationOeeBarVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOeeBarVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkStationOeeBarVO {
    /** 横坐标 */
    categories: string[] | undefined;
    /** 数据列表 */
    series: WorkStationOeeBarBO[] | undefined;
}

export class WorkStationOeeDTO implements IWorkStationOeeDTO {
    queryTime!: string | undefined;
    tenantId!: string | undefined;
    workStationCodeList!: string[] | undefined;

    constructor(data?: IWorkStationOeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.queryTime = data["queryTime"];
            this.tenantId = data["tenantId"];
            if (data["workStationCodeList"] && data["workStationCodeList"].constructor === Array) {
                this.workStationCodeList = [] as any;
                for (let item of data["workStationCodeList"])
                    this.workStationCodeList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationOeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryTime"] = this.queryTime;
        data["tenantId"] = this.tenantId;
        if (this.workStationCodeList && this.workStationCodeList.constructor === Array) {
            data["workStationCodeList"] = [];
            for (let item of this.workStationCodeList)
                data["workStationCodeList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationOeeDTO {
    queryTime: string | undefined;
    tenantId: string | undefined;
    workStationCodeList: string[] | undefined;
}

export class WorkStationOeeVO implements IWorkStationOeeVO {
    /** 稼动率值 */
    oeeValue!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationOeeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.oeeValue = data["oeeValue"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationOeeVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOeeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oeeValue"] = this.oeeValue;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationOeeVO {
    /** 稼动率值 */
    oeeValue: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class WorkStationOeeVisualVO implements IWorkStationOeeVisualVO {
    /** 稼动率值 */
    value!: number | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationOeeVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationOeeVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOeeVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationOeeVisualVO {
    /** 稼动率值 */
    value: number | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class WorkStationOutputByDeviceVO implements IWorkStationOutputByDeviceVO {
    /** 设备信息 */
    deviceInfo!: string | undefined;
    /** 时间产品产量列 */
    shiftOutputList!: TimeProductOutputInfoVO[] | undefined;

    constructor(data?: IWorkStationOutputByDeviceVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceInfo = data["deviceInfo"];
            if (data["shiftOutputList"] && data["shiftOutputList"].constructor === Array) {
                this.shiftOutputList = [] as any;
                for (let item of data["shiftOutputList"])
                    this.shiftOutputList!.push(TimeProductOutputInfoVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStationOutputByDeviceVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOutputByDeviceVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceInfo"] = this.deviceInfo;
        if (this.shiftOutputList && this.shiftOutputList.constructor === Array) {
            data["shiftOutputList"] = [];
            for (let item of this.shiftOutputList)
                data["shiftOutputList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkStationOutputByDeviceVO {
    /** 设备信息 */
    deviceInfo: string | undefined;
    /** 时间产品产量列 */
    shiftOutputList: TimeProductOutputInfoVO[] | undefined;
}

export class WorkStationOutputByTimeVO implements IWorkStationOutputByTimeVO {
    /** 设备产品产量列 */
    deviceOutputList!: ProductOutputInfoVO[] | undefined;
    /** 时间信息 */
    timeInfo!: string | undefined;

    constructor(data?: IWorkStationOutputByTimeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["deviceOutputList"] && data["deviceOutputList"].constructor === Array) {
                this.deviceOutputList = [] as any;
                for (let item of data["deviceOutputList"])
                    this.deviceOutputList!.push(ProductOutputInfoVO.fromJS(item));
            }
            this.timeInfo = data["timeInfo"];
        }
    }

    static fromJS(data: any): WorkStationOutputByTimeVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOutputByTimeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.deviceOutputList && this.deviceOutputList.constructor === Array) {
            data["deviceOutputList"] = [];
            for (let item of this.deviceOutputList)
                data["deviceOutputList"].push(item.toJSON());
        }
        data["timeInfo"] = this.timeInfo;
        return data; 
    }
}

export interface IWorkStationOutputByTimeVO {
    /** 设备产品产量列 */
    deviceOutputList: ProductOutputInfoVO[] | undefined;
    /** 时间信息 */
    timeInfo: string | undefined;
}

export class WorkStationOutputSearchDTO implements IWorkStationOutputSearchDTO {
    /** 日 */
    date!: Date | undefined;
    /** 结束时间 */
    endDate!: Date | undefined;
    /** 月 */
    month!: number | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 班次index */
    shiftIndex!: number | undefined;
    /** 选中的班次信息 */
    shiftList!: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate!: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: WorkStationOutputSearchDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IWorkStationOutputSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.productName = data["productName"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO.fromJS(item));
            }
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            this.week = data["week"];
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): WorkStationOutputSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOutputSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["month"] = this.month;
        data["productName"] = this.productName;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        data["week"] = this.week;
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IWorkStationOutputSearchDTO {
    /** 日 */
    date: Date | undefined;
    /** 结束时间 */
    endDate: Date | undefined;
    /** 月 */
    month: number | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 班次index */
    shiftIndex: number | undefined;
    /** 选中的班次信息 */
    shiftList: KeyNameDTO[] | undefined;
    /** 开始时间 */
    startDate: Date | undefined;
    /** 统计方式:SHIFT--班次--1,DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: WorkStationOutputSearchDTOStatisticalMethod | undefined;
    /** 周 */
    week: number | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

export class WorkStationOutputVO implements IWorkStationOutputVO {
    /** 数据 */
    data!: { [key: string] : number; } | undefined;
    /** 工位信息 */
    workStation!: WorkStationInfoVO | undefined;

    constructor(data?: IWorkStationOutputVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        this.data![key] = data["data"][key];
                }
            }
            this.workStation = data["workStation"] ? WorkStationInfoVO.fromJS(data["workStation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkStationOutputVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationOutputVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        data["workStation"] = this.workStation ? this.workStation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWorkStationOutputVO {
    /** 数据 */
    data: { [key: string] : number; } | undefined;
    /** 工位信息 */
    workStation: WorkStationInfoVO | undefined;
}

export class WorkStationProductivityVO implements IWorkStationProductivityVO {
    /** 数据 */
    data!: { [key: string] : number; } | undefined;
    /** 工位信息 */
    workStation!: WorkStationInfoVO | undefined;

    constructor(data?: IWorkStationProductivityVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        this.data![key] = data["data"][key];
                }
            }
            this.workStation = data["workStation"] ? WorkStationInfoVO.fromJS(data["workStation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkStationProductivityVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationProductivityVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        data["workStation"] = this.workStation ? this.workStation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWorkStationProductivityVO {
    /** 数据 */
    data: { [key: string] : number; } | undefined;
    /** 工位信息 */
    workStation: WorkStationInfoVO | undefined;
}

export class WorkStationQueryDataSourceDTO implements IWorkStationQueryDataSourceDTO {
    /** 工位id */
    workStationIdList!: string[] | undefined;

    constructor(data?: IWorkStationQueryDataSourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["workStationIdList"] && data["workStationIdList"].constructor === Array) {
                this.workStationIdList = [] as any;
                for (let item of data["workStationIdList"])
                    this.workStationIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationQueryDataSourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationQueryDataSourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.workStationIdList && this.workStationIdList.constructor === Array) {
            data["workStationIdList"] = [];
            for (let item of this.workStationIdList)
                data["workStationIdList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationQueryDataSourceDTO {
    /** 工位id */
    workStationIdList: string[] | undefined;
}

export class WorkStationShiftOeeItemVO implements IWorkStationShiftOeeItemVO {
    /** 稼动率 */
    oee!: string | undefined;
    /** 班次id */
    shiftId!: number | undefined;
    /** 班次名称 */
    shiftName!: string | undefined;

    constructor(data?: IWorkStationShiftOeeItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.oee = data["oee"];
            this.shiftId = data["shiftId"];
            this.shiftName = data["shiftName"];
        }
    }

    static fromJS(data: any): WorkStationShiftOeeItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationShiftOeeItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oee"] = this.oee;
        data["shiftId"] = this.shiftId;
        data["shiftName"] = this.shiftName;
        return data; 
    }
}

export interface IWorkStationShiftOeeItemVO {
    /** 稼动率 */
    oee: string | undefined;
    /** 班次id */
    shiftId: number | undefined;
    /** 班次名称 */
    shiftName: string | undefined;
}

export class WorkStationShiftOeeVO implements IWorkStationShiftOeeVO {
    /** 日期 */
    date!: string | undefined;
    /** 班次列表 */
    shiftList!: KeyNameDTO_1[] | undefined;
    /** 数据列表 */
    workStationShiftOeeItemVOS!: WorkStationShiftOeeItemVO[] | undefined;

    constructor(data?: IWorkStationShiftOeeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            if (data["shiftList"] && data["shiftList"].constructor === Array) {
                this.shiftList = [] as any;
                for (let item of data["shiftList"])
                    this.shiftList!.push(KeyNameDTO_1.fromJS(item));
            }
            if (data["workStationShiftOeeItemVOS"] && data["workStationShiftOeeItemVOS"].constructor === Array) {
                this.workStationShiftOeeItemVOS = [] as any;
                for (let item of data["workStationShiftOeeItemVOS"])
                    this.workStationShiftOeeItemVOS!.push(WorkStationShiftOeeItemVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStationShiftOeeVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationShiftOeeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        if (this.shiftList && this.shiftList.constructor === Array) {
            data["shiftList"] = [];
            for (let item of this.shiftList)
                data["shiftList"].push(item.toJSON());
        }
        if (this.workStationShiftOeeItemVOS && this.workStationShiftOeeItemVOS.constructor === Array) {
            data["workStationShiftOeeItemVOS"] = [];
            for (let item of this.workStationShiftOeeItemVOS)
                data["workStationShiftOeeItemVOS"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkStationShiftOeeVO {
    /** 日期 */
    date: string | undefined;
    /** 班次列表 */
    shiftList: KeyNameDTO_1[] | undefined;
    /** 数据列表 */
    workStationShiftOeeItemVOS: WorkStationShiftOeeItemVO[] | undefined;
}

export class WorkStationStandardOeeBarVO implements IWorkStationStandardOeeBarVO {
    /** 横坐标 */
    categories!: string[] | undefined;
    /** 数据列表 */
    series!: WorkStationOeeBarBO[] | undefined;
    /** 标准值列表 */
    standardEfficiencyList!: number[] | undefined;

    constructor(data?: IWorkStationStandardOeeBarVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(item);
            }
            if (data["series"] && data["series"].constructor === Array) {
                this.series = [] as any;
                for (let item of data["series"])
                    this.series!.push(WorkStationOeeBarBO.fromJS(item));
            }
            if (data["standardEfficiencyList"] && data["standardEfficiencyList"].constructor === Array) {
                this.standardEfficiencyList = [] as any;
                for (let item of data["standardEfficiencyList"])
                    this.standardEfficiencyList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkStationStandardOeeBarVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationStandardOeeBarVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (this.series && this.series.constructor === Array) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        if (this.standardEfficiencyList && this.standardEfficiencyList.constructor === Array) {
            data["standardEfficiencyList"] = [];
            for (let item of this.standardEfficiencyList)
                data["standardEfficiencyList"].push(item);
        }
        return data; 
    }
}

export interface IWorkStationStandardOeeBarVO {
    /** 横坐标 */
    categories: string[] | undefined;
    /** 数据列表 */
    series: WorkStationOeeBarBO[] | undefined;
    /** 标准值列表 */
    standardEfficiencyList: number[] | undefined;
}

export class WorkStationStatisticRpsDTO implements IWorkStationStatisticRpsDTO {
    /** 工位编号 */
    code!: string | undefined;
    /** 数据 */
    data!: { [key: string] : number; } | undefined;
    /** 序列号 */
    serialNo!: string | undefined;
    /** 工位Id */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationStatisticRpsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        this.data![key] = data["data"][key];
                }
            }
            this.serialNo = data["serialNo"];
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationStatisticRpsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationStatisticRpsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        data["serialNo"] = this.serialNo;
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationStatisticRpsDTO {
    /** 工位编号 */
    code: string | undefined;
    /** 数据 */
    data: { [key: string] : number; } | undefined;
    /** 序列号 */
    serialNo: string | undefined;
    /** 工位Id */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class WorkStationStatusRecordVO implements IWorkStationStatusRecordVO {
    /** 工位记录列表 */
    recordItems!: StatusRecordItemVO[] | undefined;
    /** 工位信息 */
    workStation!: WorkStationInfoVO | undefined;

    constructor(data?: IWorkStationStatusRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["recordItems"] && data["recordItems"].constructor === Array) {
                this.recordItems = [] as any;
                for (let item of data["recordItems"])
                    this.recordItems!.push(StatusRecordItemVO.fromJS(item));
            }
            this.workStation = data["workStation"] ? WorkStationInfoVO.fromJS(data["workStation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkStationStatusRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationStatusRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.recordItems && this.recordItems.constructor === Array) {
            data["recordItems"] = [];
            for (let item of this.recordItems)
                data["recordItems"].push(item.toJSON());
        }
        data["workStation"] = this.workStation ? this.workStation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWorkStationStatusRecordVO {
    /** 工位记录列表 */
    recordItems: StatusRecordItemVO[] | undefined;
    /** 工位信息 */
    workStation: WorkStationInfoVO | undefined;
}

export class WorkStationStatusStatisticByRpsVO implements IWorkStationStatusStatisticByRpsVO {
    /** 列信息 */
    columns!: ColumnInfoDTO[] | undefined;
    /** 数据 */
    items!: WorkStationStatisticRpsDTO[] | undefined;

    constructor(data?: IWorkStationStatusStatisticByRpsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["columns"] && data["columns"].constructor === Array) {
                this.columns = [] as any;
                for (let item of data["columns"])
                    this.columns!.push(ColumnInfoDTO.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(WorkStationStatisticRpsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStationStatusStatisticByRpsVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationStatusStatisticByRpsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columns && this.columns.constructor === Array) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkStationStatusStatisticByRpsVO {
    /** 列信息 */
    columns: ColumnInfoDTO[] | undefined;
    /** 数据 */
    items: WorkStationStatisticRpsDTO[] | undefined;
}

export class WorkStationStatusStatisticByWcsDTO implements IWorkStationStatusStatisticByWcsDTO {
    /** 工位WCS数据 */
    wcsData!: { [key: string] : string; } | undefined;
    /** 工位ID */
    workStationId!: string | undefined;
    /** 工位名称 */
    workStationName!: string | undefined;

    constructor(data?: IWorkStationStatusStatisticByWcsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["wcsData"]) {
                this.wcsData = {} as any;
                for (let key in data["wcsData"]) {
                    if (data["wcsData"].hasOwnProperty(key))
                        this.wcsData![key] = data["wcsData"][key];
                }
            }
            this.workStationId = data["workStationId"];
            this.workStationName = data["workStationName"];
        }
    }

    static fromJS(data: any): WorkStationStatusStatisticByWcsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationStatusStatisticByWcsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.wcsData) {
            data["wcsData"] = {};
            for (let key in this.wcsData) {
                if (this.wcsData.hasOwnProperty(key))
                    data["wcsData"][key] = this.wcsData[key];
            }
        }
        data["workStationId"] = this.workStationId;
        data["workStationName"] = this.workStationName;
        return data; 
    }
}

export interface IWorkStationStatusStatisticByWcsDTO {
    /** 工位WCS数据 */
    wcsData: { [key: string] : string; } | undefined;
    /** 工位ID */
    workStationId: string | undefined;
    /** 工位名称 */
    workStationName: string | undefined;
}

export class WorkStationStatusStatisticHourByRpsVO implements IWorkStationStatusStatisticHourByRpsVO {
    /** 列信息，就是小时点：8 ,9 等 */
    columns!: string[] | undefined;
    /** 每个小时点稼动率值数据 */
    data!: { [key: string] : number; } | undefined;

    constructor(data?: IWorkStationStatusStatisticHourByRpsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["columns"] && data["columns"].constructor === Array) {
                this.columns = [] as any;
                for (let item of data["columns"])
                    this.columns!.push(item);
            }
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        this.data![key] = data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): WorkStationStatusStatisticHourByRpsVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationStatusStatisticHourByRpsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columns && this.columns.constructor === Array) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        return data; 
    }
}

export interface IWorkStationStatusStatisticHourByRpsVO {
    /** 列信息，就是小时点：8 ,9 等 */
    columns: string[] | undefined;
    /** 每个小时点稼动率值数据 */
    data: { [key: string] : number; } | undefined;
}

export class WorkStationTimeDataVO implements IWorkStationTimeDataVO {
    /** s1状态值 */
    s1!: number | undefined;
    /** s2状态值 */
    s2!: number | undefined;
    /** s3状态值 */
    s3!: number | undefined;
    /** s4状态值 */
    s4!: number | undefined;
    /** s5状态值 */
    s5!: number | undefined;
    /** s6状态值 */
    s6!: number | undefined;
    /** s7状态值 */
    s7!: number | undefined;
    /** s8状态值 */
    s8!: number | undefined;
    /** s9状态值 */
    s9!: number | undefined;

    constructor(data?: IWorkStationTimeDataVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.s1 = data["s1"];
            this.s2 = data["s2"];
            this.s3 = data["s3"];
            this.s4 = data["s4"];
            this.s5 = data["s5"];
            this.s6 = data["s6"];
            this.s7 = data["s7"];
            this.s8 = data["s8"];
            this.s9 = data["s9"];
        }
    }

    static fromJS(data: any): WorkStationTimeDataVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationTimeDataVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["s1"] = this.s1;
        data["s2"] = this.s2;
        data["s3"] = this.s3;
        data["s4"] = this.s4;
        data["s5"] = this.s5;
        data["s6"] = this.s6;
        data["s7"] = this.s7;
        data["s8"] = this.s8;
        data["s9"] = this.s9;
        return data; 
    }
}

export interface IWorkStationTimeDataVO {
    /** s1状态值 */
    s1: number | undefined;
    /** s2状态值 */
    s2: number | undefined;
    /** s3状态值 */
    s3: number | undefined;
    /** s4状态值 */
    s4: number | undefined;
    /** s5状态值 */
    s5: number | undefined;
    /** s6状态值 */
    s6: number | undefined;
    /** s7状态值 */
    s7: number | undefined;
    /** s8状态值 */
    s8: number | undefined;
    /** s9状态值 */
    s9: number | undefined;
}

export class WorkStationTimeVO implements IWorkStationTimeVO {
    /** 数据 */
    data!: WorkStationTimeDataVO | undefined;
    /** 工位信息 */
    workStation!: WorkStationInfoVO | undefined;

    constructor(data?: IWorkStationTimeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.data = data["data"] ? WorkStationTimeDataVO.fromJS(data["data"]) : <any>undefined;
            this.workStation = data["workStation"] ? WorkStationInfoVO.fromJS(data["workStation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkStationTimeVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationTimeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["workStation"] = this.workStation ? this.workStation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWorkStationTimeVO {
    /** 数据 */
    data: WorkStationTimeDataVO | undefined;
    /** 工位信息 */
    workStation: WorkStationInfoVO | undefined;
}

/** 设备状态可视化 */
export class WorkStationVisualVO implements IWorkStationVisualVO {
    /** 状态对应的数量：key分别是【设备运行、设备等待、设备报警、设备离线、未知状态、网络断线】 */
    deviceStatus!: { [key: string] : number; } | undefined;

    constructor(data?: IWorkStationVisualVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["deviceStatus"]) {
                this.deviceStatus = {} as any;
                for (let key in data["deviceStatus"]) {
                    if (data["deviceStatus"].hasOwnProperty(key))
                        this.deviceStatus![key] = data["deviceStatus"][key];
                }
            }
        }
    }

    static fromJS(data: any): WorkStationVisualVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStationVisualVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.deviceStatus) {
            data["deviceStatus"] = {};
            for (let key in this.deviceStatus) {
                if (this.deviceStatus.hasOwnProperty(key))
                    data["deviceStatus"][key] = this.deviceStatus[key];
            }
        }
        return data; 
    }
}

/** 设备状态可视化 */
export interface IWorkStationVisualVO {
    /** 状态对应的数量：key分别是【设备运行、设备等待、设备报警、设备离线、未知状态、网络断线】 */
    deviceStatus: { [key: string] : number; } | undefined;
}

export class WorkstationLoginCountVO implements IWorkstationLoginCountVO {
    /** 平均运行时长 */
    avgYield!: string | undefined;
    /** 日期 */
    date!: string | undefined;
    /** 加工效率 */
    efficiency!: number | undefined;
    /** 员工code */
    employeeCode!: string | undefined;
    /** 员工id */
    employeeId!: string | undefined;
    /** 操作工信息 */
    employeeInfos!: EmployeeInfoVO[] | undefined;
    /** 员工姓名 */
    employeeName!: string | undefined;
    /** 结束时间 */
    endDate!: string | undefined;
    /** 工位组Id */
    groupId!: string | undefined;
    /** 工位顺序 */
    index!: number | undefined;
    /** 产量 */
    poorYield!: number | undefined;
    /** 填报数量 */
    reportNum!: number | undefined;
    /** 运行时长  单位：小时 */
    runningTime!: string | undefined;
    /** 运行时长  单位：小时 */
    runningTime1!: number | undefined;
    /** 开始时间 */
    startDate!: string | undefined;
    /** 设备名称 */
    workStationName!: string | undefined;
    /** 上工时长：登出时间-登入时间 */
    workingHours!: string | undefined;
    /** 上工时长：登出时间-登入时间 单位：小时 */
    workingHours1!: number | undefined;
    /** 设备code */
    workstationCode!: string | undefined;
    /** 设备id */
    workstationId!: string | undefined;

    constructor(data?: IWorkstationLoginCountVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avgYield = data["avgYield"];
            this.date = data["date"];
            this.efficiency = data["efficiency"];
            this.employeeCode = data["employeeCode"];
            this.employeeId = data["employeeId"];
            if (data["employeeInfos"] && data["employeeInfos"].constructor === Array) {
                this.employeeInfos = [] as any;
                for (let item of data["employeeInfos"])
                    this.employeeInfos!.push(EmployeeInfoVO.fromJS(item));
            }
            this.employeeName = data["employeeName"];
            this.endDate = data["endDate"];
            this.groupId = data["groupId"];
            this.index = data["index"];
            this.poorYield = data["poorYield"];
            this.reportNum = data["reportNum"];
            this.runningTime = data["runningTime"];
            this.runningTime1 = data["runningTime1"];
            this.startDate = data["startDate"];
            this.workStationName = data["workStationName"];
            this.workingHours = data["workingHours"];
            this.workingHours1 = data["workingHours1"];
            this.workstationCode = data["workstationCode"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkstationLoginCountVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkstationLoginCountVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avgYield"] = this.avgYield;
        data["date"] = this.date;
        data["efficiency"] = this.efficiency;
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        if (this.employeeInfos && this.employeeInfos.constructor === Array) {
            data["employeeInfos"] = [];
            for (let item of this.employeeInfos)
                data["employeeInfos"].push(item.toJSON());
        }
        data["employeeName"] = this.employeeName;
        data["endDate"] = this.endDate;
        data["groupId"] = this.groupId;
        data["index"] = this.index;
        data["poorYield"] = this.poorYield;
        data["reportNum"] = this.reportNum;
        data["runningTime"] = this.runningTime;
        data["runningTime1"] = this.runningTime1;
        data["startDate"] = this.startDate;
        data["workStationName"] = this.workStationName;
        data["workingHours"] = this.workingHours;
        data["workingHours1"] = this.workingHours1;
        data["workstationCode"] = this.workstationCode;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkstationLoginCountVO {
    /** 平均运行时长 */
    avgYield: string | undefined;
    /** 日期 */
    date: string | undefined;
    /** 加工效率 */
    efficiency: number | undefined;
    /** 员工code */
    employeeCode: string | undefined;
    /** 员工id */
    employeeId: string | undefined;
    /** 操作工信息 */
    employeeInfos: EmployeeInfoVO[] | undefined;
    /** 员工姓名 */
    employeeName: string | undefined;
    /** 结束时间 */
    endDate: string | undefined;
    /** 工位组Id */
    groupId: string | undefined;
    /** 工位顺序 */
    index: number | undefined;
    /** 产量 */
    poorYield: number | undefined;
    /** 填报数量 */
    reportNum: number | undefined;
    /** 运行时长  单位：小时 */
    runningTime: string | undefined;
    /** 运行时长  单位：小时 */
    runningTime1: number | undefined;
    /** 开始时间 */
    startDate: string | undefined;
    /** 设备名称 */
    workStationName: string | undefined;
    /** 上工时长：登出时间-登入时间 */
    workingHours: string | undefined;
    /** 上工时长：登出时间-登入时间 单位：小时 */
    workingHours1: number | undefined;
    /** 设备code */
    workstationCode: string | undefined;
    /** 设备id */
    workstationId: string | undefined;
}

export class WorkstationLoginExcelDTO implements IWorkstationLoginExcelDTO {
    /** 日 */
    date!: string[] | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 月 */
    month!: number[] | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 统计方式:DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod!: WorkstationLoginExcelDTOStatisticalMethod | undefined;
    /** 周 */
    week!: number[] | undefined;
    /** 选中的工位key-name */
    workStationList!: KeyNameDTO[] | undefined;
    /** 年 */
    year!: number | undefined;

    constructor(data?: IWorkstationLoginExcelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["date"] && data["date"].constructor === Array) {
                this.date = [] as any;
                for (let item of data["date"])
                    this.date!.push(item);
            }
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            if (data["month"] && data["month"].constructor === Array) {
                this.month = [] as any;
                for (let item of data["month"])
                    this.month!.push(item);
            }
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.statisticalMethod = data["statisticalMethod"];
            if (data["week"] && data["week"].constructor === Array) {
                this.week = [] as any;
                for (let item of data["week"])
                    this.week!.push(item);
            }
            if (data["workStationList"] && data["workStationList"].constructor === Array) {
                this.workStationList = [] as any;
                for (let item of data["workStationList"])
                    this.workStationList!.push(KeyNameDTO.fromJS(item));
            }
            this.year = data["year"];
        }
    }

    static fromJS(data: any): WorkstationLoginExcelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkstationLoginExcelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.date && this.date.constructor === Array) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item);
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (this.month && this.month.constructor === Array) {
            data["month"] = [];
            for (let item of this.month)
                data["month"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["statisticalMethod"] = this.statisticalMethod;
        if (this.week && this.week.constructor === Array) {
            data["week"] = [];
            for (let item of this.week)
                data["week"].push(item);
        }
        if (this.workStationList && this.workStationList.constructor === Array) {
            data["workStationList"] = [];
            for (let item of this.workStationList)
                data["workStationList"].push(item.toJSON());
        }
        data["year"] = this.year;
        return data; 
    }
}

export interface IWorkstationLoginExcelDTO {
    /** 日 */
    date: string[] | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 月 */
    month: number[] | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 统计方式:DAY--日--2,WEEK--周--3,MONTH--月--4 */
    statisticalMethod: WorkstationLoginExcelDTOStatisticalMethod | undefined;
    /** 周 */
    week: number[] | undefined;
    /** 选中的工位key-name */
    workStationList: KeyNameDTO[] | undefined;
    /** 年 */
    year: number | undefined;
}

/** 设备状态可视化 */
export class WorkstationStatusVO implements IWorkstationStatusVO {
    /** 状态对应的数量 */
    deviceStatus!: { [key: string] : number; } | undefined;

    constructor(data?: IWorkstationStatusVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["deviceStatus"]) {
                this.deviceStatus = {} as any;
                for (let key in data["deviceStatus"]) {
                    if (data["deviceStatus"].hasOwnProperty(key))
                        this.deviceStatus![key] = data["deviceStatus"][key];
                }
            }
        }
    }

    static fromJS(data: any): WorkstationStatusVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkstationStatusVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.deviceStatus) {
            data["deviceStatus"] = {};
            for (let key in this.deviceStatus) {
                if (this.deviceStatus.hasOwnProperty(key))
                    data["deviceStatus"][key] = this.deviceStatus[key];
            }
        }
        return data; 
    }
}

/** 设备状态可视化 */
export interface IWorkstationStatusVO {
    /** 状态对应的数量 */
    deviceStatus: { [key: string] : number; } | undefined;
}

export class WorkstationWcsStatisticVO implements IWorkstationWcsStatisticVO {
    /** 表头 */
    head!: WorkStationConditionStatusDTO[] | undefined;
    /** 工位用时列表 */
    items!: WorkStationStatusStatisticByWcsDTO[] | undefined;

    constructor(data?: IWorkstationWcsStatisticVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["head"] && data["head"].constructor === Array) {
                this.head = [] as any;
                for (let item of data["head"])
                    this.head!.push(WorkStationConditionStatusDTO.fromJS(item));
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(WorkStationStatusStatisticByWcsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkstationWcsStatisticVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkstationWcsStatisticVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.head && this.head.constructor === Array) {
            data["head"] = [];
            for (let item of this.head)
                data["head"].push(item.toJSON());
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkstationWcsStatisticVO {
    /** 表头 */
    head: WorkStationConditionStatusDTO[] | undefined;
    /** 工位用时列表 */
    items: WorkStationStatusStatisticByWcsDTO[] | undefined;
}

export enum AlarmDetailDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum AlarmExcelDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum AlarmStatisticsDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum AnalysisFilterDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum ElectricityStatisticsDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum OperationStatisticsDTOProductivityType {
    RUNNING = "RUNNING", 
    ALARM = "ALARM", 
    OEE = "OEE", 
}

export enum OpsAlarmStatisticsDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum OpsProductivityAnalysisDTOProductivityType {
    RUNNING = "RUNNING", 
    ALARM = "ALARM", 
    OEE = "OEE", 
}

export enum OpsProductivityAnalysisVOProductivityType {
    RUNNING = "RUNNING", 
    ALARM = "ALARM", 
    OEE = "OEE", 
}

export enum OutputStatisticsDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum ProductivityAnalysisDTOProductivityType {
    RUNNING = "RUNNING", 
    ALARM = "ALARM", 
    OEE = "OEE", 
}

export enum ProductivityAnalysisDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum SplitFilterVOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum TimeAnalysisDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum TimeAnalysisWcsExcelDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum WorkStationEfficiencySearchDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum WorkStationOutputSearchDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

export enum WorkstationLoginExcelDTOStatisticalMethod {
    SHIFT = "SHIFT", 
    DAY = "DAY", 
    WEEK = "WEEK", 
    MONTH = "MONTH", 
    DATE = "DATE", 
    LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS", 
    LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS", 
    LAST_FIFTEEN_DAYS = "LAST_FIFTEEN_DAYS", 
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}